import { create } from 'zustand';

const translations = {
  en: {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.history': 'History',
    'nav.settings': 'Settings',
    'section.production': 'Production',
    'section.broadcast': 'Broadcast',
    'section.social': 'Social Media',
    // Content type labels
    'type.anchor_script': 'Anchor Script',
    'type.story': 'Story',
    'type.debate': 'Debate',
    'type.breaking_news': 'Breaking News',
    'type.bulletin': 'Bulletin',
    'type.scroller': 'Scroller',
    'type.facebook_post': 'Facebook Post',
    'type.youtube': 'YouTube',
    // Anchor formats
    'type.anchorVisual': 'Anchor Visual',
    'type.anchorVisualByte': 'Anchor Visual Byte',
    'type.anchorByte': 'Anchor Byte',
    'type.anchorPackage': 'Anchor Package',
    'type.anchorLive': 'Anchor Live',
    'type.anchorToReporter': 'Anchor to Reporter',
    'type.anchorToGuest': 'Anchor to Guest',
    'type.anchorDrive': 'Anchor Drive',
    // Show / bulletin formats
    'type.tops': 'Tops',
    'type.breakingPoints': 'Breaking Points',
    'type.scrollings': 'Scrollings',
    'type.anchorBgTitles': 'Anchor BG Titles',
    'type.voiceOver': 'Voice Over',
    'type.newsBulletin': 'News Bulletin',
    'type.speedNews': 'Speed News',
    'type.indepth30': 'In-depth 30',
    'type.offTheRecord30': 'Off the Record 30',
    'type.specialFocus30': 'Special Focus 30',
    'type.analysis10': 'Analysis 10',
    // Script modes
    'type.scriptModeTelangana': 'Script Mode — Telangana',
    'type.scriptModeIrony': 'Script Mode — Irony',
    'type.scriptModeUplifting': 'Script Mode — Uplifting',
    'type.scriptModeCritical': 'Script Mode — Critical',
    'type.scriptModeBalanced': 'Script Mode — Balanced',
    // Social media
    'type.socialMediaAll': 'Social Media — All Platforms',
    'type.socialMediaYouTube': 'Social Media — YouTube',
    'type.socialMediaFacebook': 'Social Media — Facebook',
    'type.socialMediaInstagram': 'Social Media — Instagram',
    'type.socialMediaTwitter': 'Social Media — Twitter',
    // Promos & interviews
    'type.digitalAnchorVisual': 'Digital Anchor Visual',
    'type.promoScript': 'Promo Script',
    'type.interviewDoctor': 'Interview — Doctor',
    'type.interviewEducation': 'Interview — Education',
    'type.interviewRealEstate': 'Interview — Real Estate',
    // Sports
    'type.sportsMatchReview': 'Sports Match Review',
    'type.sportsPanelDiscussion': 'Sports Panel Discussion',
    // Special formats
    'type.headlinesSlugs': 'Headlines & Slugs',
    'type.breakingNewsPresentation': 'Breaking News Presentation',
    'type.conspiracyTheory': 'Conspiracy Theory',
    'type.breakingPlates': 'Breaking Plates',
    'type.videoToScript': 'Video to Script',
    // Editor
    'editor.configuration': 'Configuration',
    'editor.contentType': 'Content Type',
    'editor.tone': 'Tone',
    'editor.duration': 'Duration (words)',
    'editor.customInstructions': 'Custom Instructions',
    'editor.customPlaceholder': 'Add any specific requirements...',
    'editor.generate': 'Generate Content',
    'editor.generating': 'Generating...',
    'editor.inputContent': 'Input Content',
    'editor.inputPlaceholder': 'Paste your raw news content here. Supports Telugu, English, Hindi, or mixed language inputs...',
    'editor.minChars': 'Minimum 10 characters required',
    'editor.generatedContent': 'Generated Content',
    'editor.tokens': 'Tokens',
    'editor.cost': 'Cost',
    'editor.copy': 'Copy',
    'editor.download': 'Download',
    'editor.regenerate': 'Regenerate',
    'editor.rate': 'Rate this output:',
    // YouTube specific
    'youtube.thumbnailText': 'Thumbnail Text',
    'youtube.videoTitle': 'Video Title',
    'youtube.videoDescription': 'Video Description',
    'youtube.hashtags': 'Keywords & Hashtags',
    // Tones
    'tone.formal': 'Formal',
    'tone.conversational': 'Conversational',
    'tone.urgent': 'Urgent',
    'tone.analytical': 'Analytical',
    'tone.empathetic': 'Empathetic',
    'tone.happy': 'Happy',
    'tone.angry': 'Angry',
    'tone.sad': 'Sad',
    'tone.dramatic': 'Dramatic',
    'tone.neutral': 'Neutral',
    // TopRibbon
    'header.apiUsage': 'API Usage',
    'header.tokens': 'tokens',
    'header.profile': 'Profile',
    'header.settings': 'Settings',
    'header.logout': 'Logout',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'theme.switchToDark': 'Switch to dark mode',
    'theme.switchToLight': 'Switch to light mode',
    'theme.appearance': 'Appearance',
    'theme.appearanceHint': 'Saved to your account — it follows you to every browser and device.',
    'theme.lightHint': 'Bright background, dark text',
    'theme.darkHint': 'Dark background, easier on the eyes at night',
    'theme.saveFailed': 'Could not save your theme to your account. It is applied in this browser only.',
    'header.profileAccount': 'Profile & Account',
    'header.aiProviderSettings': 'AI Provider Settings',
    'header.promptEditor': 'Prompt Editor',
    'header.editorialRules': 'Editorial Rules',
    'header.usageBilling': 'Usage & Billing',
    'header.ipWhitelist': 'IP Whitelist',
    'header.automationSources': 'Automation Sources',
    'header.switchToTelugu': 'Switch to Telugu',
    'header.switchToEnglish': 'Switch to English',
    'header.userManagement': 'User Management',
    'lang.switch': 'తెలుగు',
    'lang.current': 'EN',
    // Dashboard
    'dashboard.welcome': 'Welcome back',
    'dashboard.subtitle': 'Manage your Telugu content generation with AI-powered newsroom tools',
    'dashboard.totalRequests': 'Total Requests',
    'dashboard.totalTokens': 'Total Tokens',
    'dashboard.totalCost': 'Total Cost',
    'dashboard.successRate': 'Success Rate',
    'dashboard.thisMonth': 'This month',
    'dashboard.used': 'Used',
    'dashboard.usd': 'USD',
    'dashboard.successful': 'Generations successful',
    'dashboard.quickStart': 'Quick Start',
    'dashboard.anchorScript': 'Anchor Script',
    'dashboard.anchorScriptDesc': 'Create engaging anchor scripts',
    'dashboard.newsStory': 'News Story',
    'dashboard.newsStoryDesc': 'Generate comprehensive news stories',
    'dashboard.facebookPost': 'Facebook Post',
    'dashboard.facebookPostDesc': 'Create viral Facebook posts in Telugu',
    'dashboard.usageByType': 'Usage by Content Type',
    'dashboard.requests': 'requests',
    'dashboard.tokens': 'tokens',
    // History
    'history.filters': 'Filters',
    'history.contentType': 'Content Type',
    'history.allTypes': 'All Types',
    'history.status': 'Status',
    'history.allStatus': 'All Status',
    'history.completed': 'Completed',
    'history.failed': 'Failed',
    'history.search': 'Search',
    'history.searchPlaceholder': 'Search content...',
    'history.type': 'Type',
    'history.tokens': 'Tokens',
    'history.cost': 'Cost',
    'history.date': 'Date',
    'history.actions': 'Actions',
    'history.noContent': 'No content found',
    'history.close': 'Close',
    // Toasts
    'toast.inputRequired': 'Please enter input content',
    'toast.generated': 'Content generated successfully',
    'toast.generateFailed': 'Failed to generate content',
    'toast.copied': 'Copied to clipboard',
    'toast.rated': 'Rating submitted',
    'toast.rateFailed': 'Failed to submit rating',
    'toast.statsFailed': 'Failed to fetch statistics',
    'toast.historyFailed': 'Failed to fetch history',
    'toast.contentFailed': 'Failed to fetch content',
    // Sidebar groups
    'sidebar.group.videoTools': 'Video Tools',
    'sidebar.group.anchorFormats': 'Anchor Formats',
    'sidebar.group.breakingPlates': 'Breaking & Plates',
    'sidebar.group.bulletinTops': 'Bulletin & Tops',
    'sidebar.group.scriptsFormats': 'Scripts & Formats',
    'sidebar.group.programs': 'Programs',
    'sidebar.group.longFormats': 'Long Formats',
    'sidebar.group.socialPromo': 'Social & Promo',
    'sidebar.group.speciality': 'Speciality',
    'sidebar.group.audioGeneration': 'Audio Generation',
    // Sidebar items
    'sidebar.item.videoToScript': 'Video to Script',
    'sidebar.item.videoToVideo': 'Video to Video',
    'sidebar.item.quickAI': 'Quick AI',
    'sidebar.item.newsAnchorFormats': 'News Anchor Formats',
    'sidebar.item.breakingPlates': 'Breaking Plates',
    'sidebar.item.breakingPoints': 'Breaking Points',
    'sidebar.item.tops': 'Tops',
    'sidebar.item.newsBulletin': 'News Bulletin',
    'sidebar.item.headlinesSlugs': 'Headlines with Slugs',
    'sidebar.item.breakingNewsPresentation': 'Breaking News Presentation',
    'sidebar.item.scrollings': 'Scrollings',
    'sidebar.item.anchorBGTitles': 'Anchor BG Titles',
    'sidebar.item.voiceOver': 'Voice Over',
    'sidebar.item.speedNews': 'Speed News',
    'sidebar.item.scriptModes': 'Script Modes',
    'sidebar.item.indepth': 'Indepth (30 mins)',
    'sidebar.item.offTheRecord': 'Off The Record (30 mins)',
    'sidebar.item.specialFocus': 'Special Focus (30 mins)',
    'sidebar.item.analysis': 'Analysis (10 mins)',
    'sidebar.item.socialMedia': 'Social Media',
    'sidebar.item.promoScript': 'Promo Script',
    'sidebar.item.digitalAnchorVisual': 'Digital Anchor Visual',
    'sidebar.item.commercialInterviews': 'Commercial Interviews',
    'sidebar.item.sports': 'Sports',
    'sidebar.item.conspiracyTheory': 'Conspiracy Theory',
    'sidebar.item.burningIssue': 'Burning Issue',
    'sidebar.item.tcr': 'TCR',
    'sidebar.item.worldNews': 'World News',
    'sidebar.item.crimeStory': 'Crime Story',
    'sidebar.item.scriptToVoice': 'Script to Voice',
    'sidebar.item.languageChange': 'Language Change',
    'sidebar.group.automation': 'Automation',
    'sidebar.item.pipeline': 'Pipeline',
    'sidebar.item.fullStory': 'Full Story',
    'fullStory.title': 'Full Story',
    'fullStory.subtitle': 'From raw news to a finished video — script, voice-over, pictures and video, reviewed step by step.',
    'fullStory.untitled': 'Untitled story',
    'fullStory.newStory': 'New story',
    'fullStory.creating': 'Creating…',
    'fullStory.myStories': 'My stories',
    'fullStory.teamStories': 'Team',
    'fullStory.searchByUser': 'Search by name or email',
    'fullStory.count': '{{count}} stories',
    'fullStory.loading': 'Loading…',
    'fullStory.noStories': 'No stories yet. Start one — paste the news and the app takes it to a finished video.',
    'fullStory.noTeamStories': 'No stories found.',
    'fullStory.videoReady': 'Video ready',
    'fullStory.delete': 'Delete',
    'fullStory.deleteConfirm': 'Delete "{{title}}" and all its files? This cannot be undone.',
    'fullStory.targetLength': 'target {{seconds}}s',
    'fullStory.prev': 'Previous',
    'fullStory.next': 'Next',
    'fullStory.notFound': 'This story was not found, or you do not have access to it.',
    'fullStory.backToStories': 'Back to stories',
    'fullStory.allStories': 'All stories',
    'fullStory.storyTitle': 'Story title',
    'fullStory.cost': 'AI cost so far ${{cost}}',
    'fullStory.costHint': 'Script, pictures and photo search. Voice-over is billed by ElevenLabs separately.',
    'fullStory.readOnly': 'Viewing {{name}}\'s story — read only.',
    'fullStory.step.script': 'Script',
    'fullStory.step.voice': 'Voice-over',
    'fullStory.step.images': 'Pictures',
    'fullStory.step.video': 'Video',
    'fullStory.stepHint.script': 'Paste the news; get a narration of the length you choose.',
    'fullStory.stepHint.voice': 'Voiced sentence by sentence — re-record any one.',
    'fullStory.stepHint.images': 'A picture per scene — AI, web photo or your own.',
    'fullStory.stepHint.video': 'Animated, timed to the voice, with optional logo and music.',
    'fullStory.state.done': 'Approved',
    'fullStory.state.ready': 'Ready',
    'fullStory.state.active': 'To review',
    'fullStory.state.busy': 'Working…',
    'fullStory.state.failed': 'Needs attention',
    'fullStory.state.outdated': 'Out of date',
    'fullStory.state.locked': 'Not yet',
    'fullStory.length': 'Length',
    'fullStory.secondsMax': 'seconds (10–{{max}})',
    'fullStory.minutes': '{{n}} min',
    'fullStory.lengthRange': 'The length can be from 10 to {{max}} seconds.',
    'fullStory.shape': 'Shape',
    'fullStory.landscape': '16:9 landscape',
    'fullStory.portrait': '9:16 vertical',
    'fullStory.shapeChangeWarn': 'Existing AI pictures were made for the old shape and will be cropped. You can remake them in the Pictures step. Change the shape?',
    'fullStory.stop': 'Stop',
    'fullStory.saveEdits': 'Save edits',
    'fullStory.discardEdits': 'Your unsaved edits to the script will be replaced. Continue?',
    'fullStory.scriptFailed': 'The script could not be written. Please try again.',
    'fullStory.approveScriptRedo': 'The script changed since it was voiced. Approving it clears the voice-over and the pictures so they can be made again for the new script. Continue?',
    'fullStory.script.title': 'Script',
    'fullStory.script.desc': 'Paste the raw news and say how you want it. The narration is written to your chosen length — edit it directly, or ask for a rewrite.',
    'fullStory.script.material': 'News material',
    'fullStory.script.materialPlaceholder': 'Paste the wire copy, notes, press release or any raw material…',
    'fullStory.script.instructions': 'Instructions (optional)',
    'fullStory.script.instructionsPlaceholder': 'e.g. Start with the court ruling, end with what happens next. Simple language for viewers.',
    'fullStory.script.write': 'Write script',
    'fullStory.script.writeAgain': 'Write again from material',
    'fullStory.script.narration': 'Narration',
    'fullStory.script.estimate': '{{words}} words · about {{seconds}}s of {{target}}s',
    'fullStory.script.tooLong': 'Probably longer than your target — shorten it, or ask for a rewrite ("make it shorter").',
    'fullStory.script.redoPlaceholder': 'Redo with changes — e.g. "make it shorter", "start with the airport"',
    'fullStory.script.redo': 'Redo',
    'fullStory.script.earlierDrafts': 'Earlier drafts',
    'fullStory.script.restoreConfirm': 'Bring back this earlier draft? The current one is kept in Earlier drafts.',
    'fullStory.script.approve': 'Approve script',
    'fullStory.script.approveHint': 'Approve when the narration reads right. Next: the voice-over.',
    'fullStory.script.approvedNote': 'Approved. Edit and approve again to change it.',
    'fullStory.voice.title': 'Voice-over',
    'fullStory.voice.desc': 'The script is voiced one sentence at a time, so every picture can be timed exactly. Listen, then fix or re-record any sentence.',
    'fullStory.voice.needScript': 'Approve the script first.',
    'fullStory.voice.voice': 'Voice',
    'fullStory.voice.artists': 'Voice artists',
    'fullStory.voice.otherVoices': 'Other voices',
    'fullStory.voice.make': 'Make voice-over',
    'fullStory.voice.remake': 'Voice all again',
    'fullStory.voice.making': 'Making voice-over…',
    'fullStory.voice.remakeConfirm': 'Voice every sentence again? The current voice-over is replaced.',
    'fullStory.voice.onlyMissing': 'Voice only the missing sentences',
    'fullStory.voice.voiceChanged': 'You picked a different voice — "Voice all again" to use it for every sentence.',
    'fullStory.voice.progress': '{{done}} of {{total}} sentences voiced',
    'fullStory.voice.full': 'Full voice-over',
    'fullStory.voice.length': '{{length}} (target {{target}})',
    'fullStory.voice.downloadMp3': 'Download MP3',
    'fullStory.voice.overMax': 'This is longer than the {{max}}-second maximum. Shorten the script, approve it, and voice it again.',
    'fullStory.voice.tooShort': 'This is {{length}} — shorter than your {{target}}.',
    'fullStory.voice.tooLong': 'This is {{length}} — longer than your {{target}}.',
    'fullStory.voice.fit': 'Fit to {{target}}',
    'fullStory.voice.fitConfirm': 'Rewrite the script to fit {{target}} at this voice\'s pace and voice it again? The pictures are made again afterwards. (About $0.01 plus the voice-over.)',
    'fullStory.voice.play': 'Play',
    'fullStory.voice.edit': 'Edit wording',
    'fullStory.voice.redo': 'Record this sentence again',
    'fullStory.voice.saveRevoice': 'Save and re-voice',
    'fullStory.voice.sentenceFailed': 'Could not be voiced — try again.',
    'fullStory.voice.approve': 'Approve voice-over',
    'fullStory.voice.approveHint': 'Approve when it sounds right. Next: the pictures — you can give instructions for them first.',
    'fullStory.voice.approvedNote': 'Approved.',
    'fullStory.images.title': 'Pictures',
    'fullStory.images.desc': 'The script is split into scenes; each scene shows one picture while its sentences are spoken. Change any picture, and decide which sentences each one covers.',
    'fullStory.images.needVoice': 'Approve the voice-over first.',
    'fullStory.images.summary': '{{scenes}} scenes covering {{sentences}} sentences',
    'fullStory.images.makingCount': 'making {{count}} picture(s)',
    'fullStory.images.planning': 'Planning scenes…',
    'fullStory.images.planningLong': 'Grouping the sentences into scenes and writing a picture brief for each. Pictures are made right after — this takes a minute or two.',
    'fullStory.images.plan': 'Plan scenes',
    'fullStory.images.replan': 'Re-plan scenes',
    'fullStory.images.replanConfirm': 'Re-plan all scenes? Every current picture is removed and new AI pictures are made (about $0.06 each).',
    'fullStory.images.instructionsLabel': 'Picture instructions',
    'fullStory.images.optional': '(optional)',
    'fullStory.images.instructionsPlaceholder': 'e.g. Every bike must be a Royal Enfield Classic 350 with the Royal Enfield badge visible — no other brands. Show Hyderabad streets.',
    'fullStory.images.instructionsHint': 'Followed strictly for every AI picture and the web photo searches',
    'fullStory.images.makePictures': 'Make pictures',
    'fullStory.images.remake': 'Remake {{count}} pictures with these instructions',
    'fullStory.images.remakeConfirm': 'Make {{count}} new AI pictures following these instructions? The current AI pictures are replaced (about $0.06 each). The scene layout, movements and effects stay as they are.',
    'fullStory.images.remakeConfirmKeep': 'Make {{count}} new AI pictures following these instructions? The current AI pictures are replaced (about $0.06 each). Your {{kept}} own uploads, chosen web photos and stock clips are kept, and the scene layout, movements and effects stay as they are.',
    'fullStory.images.remakeNothing': 'There are no AI pictures to remake — every scene has your own upload, web photo or stock clip.',
    'fullStory.images.scene': 'Scene {{n}}',
    'fullStory.images.sentence': 'sentence {{n}}',
    'fullStory.images.sentences': 'sentences {{from}}–{{to}}',
    'fullStory.images.giveFirst': 'Move the first sentence to the previous scene',
    'fullStory.images.giveLast': 'Move the last sentence to the next scene',
    'fullStory.images.mergePrev': 'Merge into the previous scene (this picture is removed)',
    'fullStory.images.mergeNext': 'Merge into the next scene (this picture is removed)',
    'fullStory.images.mergeConfirm': 'Merge this scene into its neighbour? Its picture is removed.',
    'fullStory.images.splitHere': 'New picture from this sentence',
    'fullStory.images.noPicture': 'No picture yet',
    'fullStory.images.making': 'Making the picture…',
    'fullStory.images.sourceAi': 'AI',
    'fullStory.images.sourceWeb': 'Web photo',
    'fullStory.images.sourceUpload': 'Your picture',
    'fullStory.images.sourceUploadVideo': 'Your video',
    'fullStory.images.sourceStock': 'Free stock',
    'fullStory.images.videoBadge': 'video {{seconds}}s',
    'fullStory.images.stockCredit': 'Clip by {{author}} ({{provider}})',
    'fullStory.images.uploadingVideo': 'Uploading and preparing the video…',
    'fullStory.images.videoTooBig': 'The video can be up to {{max}} MB. Trim it or export a smaller file.',
    'fullStory.images.clipPlays': 'Plays {{used}} of this {{clip}}s clip, starting {{from}}s in. The rest is not used.',
    'fullStory.images.clipSlowed': 'The clip ({{clip}}s) is shorter than the scene ({{scene}}s), so it plays slightly slower ({{speed}}% speed) to fill it.',
    'fullStory.images.clipSlowedHold': 'The clip ({{clip}}s) is shorter than the scene ({{scene}}s): it plays in slow motion ({{speed}}% speed) for {{played}}s, then holds its last frame for {{hold}}s.',
    'fullStory.images.clipHoldTip': 'To avoid the held frame, use a longer clip or move a sentence to the next scene.',
    'fullStory.images.clipStartAt': 'Start at (seconds)',
    'fullStory.images.clipStartHint': 'Which part of the clip to show — 0 to {{max}}.',
    'fullStory.images.photoSuggestion': 'This scene is about a real person or place — a web photo may suit it: "{{query}}".',
    'fullStory.images.aiPicture': 'New AI picture',
    'fullStory.images.webPhotos': 'Web photos',
    'fullStory.images.upload': 'Upload photo / video',
    'fullStory.images.remove': 'Remove',
    'fullStory.images.removeConfirm': 'Remove this picture?',
    'fullStory.images.briefLabel': 'Describe the picture',
    'fullStory.images.briefPlaceholder': 'Leave empty to describe it from the scene\'s sentences.',
    'fullStory.images.make': 'Make picture',
    'fullStory.images.makeNew': 'Make new picture',
    'fullStory.images.aiCost': 'About $0.06 per picture. AI pictures don\'t show real people\'s faces — use a web photo or your own for that.',
    'fullStory.images.searchPlaceholder': 'What to search for, e.g. "Hyderabad metro"',
    'fullStory.images.search': 'Search',
    'fullStory.images.searchHint': 'Search to see real photos from news sites; click one to use it.',
    'fullStory.images.webRights': 'Web photos belong to their publishers — check the rights before airing.',
    'fullStory.images.missing': '{{count}} scene(s) still need a picture.',
    'fullStory.images.approve': 'Approve pictures',
    'fullStory.images.approveHint': 'Approve when every scene has the right picture. Next: the video.',
    'fullStory.images.approvedNote': 'Approved.',
    'fullStory.video.title': 'Video',
    'fullStory.video.desc': 'Pictures are animated and joined with transitions, timed exactly to the voice-over. Add your logo or background music if you like.',
    'fullStory.video.needImages': 'Approve the pictures first.',
    'fullStory.video.animation': 'Animation',
    'fullStory.video.mixAuto': 'Mix automatically',
    'fullStory.effect.label': 'Effect',
    'fullStory.effect.none': 'No effect',
    'fullStory.effect.noneHint': 'The picture as it is. Most scenes look best this way.',
    'fullStory.effect.choose': 'Choose an effect for this scene',
    'fullStory.effect.intro': 'Pick from {{count}} effects for any scene: weather, tone, camera, film and news looks. Use them where they add meaning; most scenes are best left clean.',
    'fullStory.effect.pickTitle': 'Effect for scene {{n}}',
    'fullStory.effect.pickDesc': '{{count}} effects. Each one says when it fits. Preview it on this scene before applying.',
    'fullStory.effect.search': 'Search effects: rain, tribute, CCTV, history…',
    'fullStory.effect.all': 'All',
    'fullStory.effect.preview': 'Preview on this scene',
    'fullStory.effect.previewAgain': 'Preview again',
    'fullStory.effect.noPicture': 'This scene has no picture yet, so it can\'t be previewed.',
    'fullStory.effect.tip': 'Tip: double-click an effect to select and preview it at once.',
    'fullStory.effect.noMatch': 'No effects match your search.',
    'fullStory.effect.apply': 'Apply',
    'fullStory.effect.close': 'Close',
    'fullStory.effect.clearAll': 'Remove effects ({{count}})',
    'fullStory.effect.clearConfirm': 'Remove the effect from all {{count}} scenes that have one?',
    'fullStory.video.motion': 'Movement',
    'fullStory.video.clipMoves': 'Video clip — moves on its own',
    'fullStory.video.transitionIn': 'Transition in',
    'fullStory.video.opening': 'Opening',
    'fullStory.video.startsVideo': 'Starts the video',
    'fullStory.video.logo': 'Logo (optional)',
    'fullStory.video.logoHint': 'Upload your channel logo — a PNG with a transparent background looks best.',
    'fullStory.video.uploadLogo': 'Upload logo',
    'fullStory.video.replaceLogo': 'Replace logo',
    'fullStory.video.position': 'Position',
    'fullStory.video.music': 'Background music (optional)',
    'fullStory.video.musicHint': 'Upload an MP3, WAV or M4A — it plays softly under the voice and fades out at the end.',
    'fullStory.video.uploadMusic': 'Upload music',
    'fullStory.video.replaceMusic': 'Replace music',
    'fullStory.video.musicFile': 'Music',
    'fullStory.video.musicVolume': 'Music volume',
    'fullStory.video.useInVideo': 'Use in video',
    'fullStory.video.remove': 'Remove',
    'fullStory.video.make': 'Make video',
    'fullStory.video.remake': 'Make video again',
    'fullStory.video.renderHint': '{{length}} · {{scenes}} scenes. Made on the server — free.',
    'fullStory.video.rendering': 'Making the video…',
    'fullStory.video.renderingHint': 'A {{length}} video takes about one to two minutes per minute of video. You can leave this page; it keeps going.',
    'fullStory.video.outdated': 'Something changed since this video was made — make it again to include the changes.',
    'fullStory.video.downloadMp4': 'Download video (MP4)',
    'fullStory.video.downloadMp3': 'Download voice-over (MP3)',
    'fullStory.video.madeAt': '{{length}} · {{shape}} · made {{time}}',
    'fullStory.motion.zoom_in': 'Slow zoom in',
    'fullStory.motion.zoom_out': 'Slow zoom out',
    'fullStory.motion.pan_right': 'Pan left to right',
    'fullStory.motion.pan_left': 'Pan right to left',
    'fullStory.motion.pan_down': 'Pan top to bottom',
    'fullStory.motion.pan_up': 'Pan bottom to top',
    'fullStory.motion.zoom_in_left': 'Zoom in, drift left',
    'fullStory.motion.zoom_in_right': 'Zoom in, drift right',
    'fullStory.motion.still': 'No movement',
    'fullStory.transition.fade': 'Cross-fade',
    'fullStory.transition.fadeblack': 'Fade through black',
    'fullStory.transition.dissolve': 'Dissolve',
    'fullStory.transition.smoothleft': 'Slide left',
    'fullStory.transition.smoothright': 'Slide right',
    'fullStory.transition.smoothup': 'Slide up',
    'fullStory.transition.circleopen': 'Circle reveal',
    'fullStory.transition.wipeleft': 'Wipe left',
    'fullStory.transition.zoomin': 'Zoom through',
    'fullStory.transition.radial': 'Radial wipe',
    'fullStory.transition.cut': 'Straight cut',
    'fullStory.position.top-left': 'Top left',
    'fullStory.position.top-right': 'Top right',
    'fullStory.position.bottom-left': 'Bottom left',
    'fullStory.position.bottom-right': 'Bottom right',
    // Auth
    'auth.platformSubtitle': 'AI-Powered Telugu Newsroom Platform',
    'auth.welcomeBack': 'Welcome Back',
    'auth.emailAddress': 'Email Address',
    'auth.password': 'Password',
    'auth.signIn': 'Sign In',
    'auth.signingIn': 'Logging in...',
    'auth.dontHaveAccount': "Don't have an account?",
    'auth.signUpHere': 'Sign up here',
    'auth.demoNote': 'Demo: Use email: demo@kultworks.com | Password: demo123456',
    'auth.loginSuccess': 'Login successful!',
    'auth.loginFailed': 'Login failed',
    'auth.loggedOutAnotherDevice': 'You were logged out because your account was signed in from another device.',
    'auth.createAccount': 'Create Account',
    'auth.fullName': 'Full Name',
    'auth.email': 'Email',
    'auth.organization': 'Organization',
    'auth.creatingAccount': 'Creating Account...',
    'auth.alreadyHaveAccount': 'Already have an account?',
    'auth.registerSuccess': 'Account created successfully!',
    'auth.registerFailed': 'Registration failed',
    // Admin
    'admin.userManagement': 'User Management',
    'admin.createUser': 'Create User',
    'admin.newUser': 'New User',
    'admin.editUser': 'Edit User —',
    'admin.saveChanges': 'Save Changes',
    'admin.cancel': 'Cancel',
    'admin.loadingUsers': 'Loading users...',
    'admin.noUsersFound': 'No users found',
    'admin.failedLoadUsers': 'Failed to load users',
    'admin.userCreated': 'User {{email}} created',
    'admin.userUpdated': 'User updated',
    'admin.failedCreateUser': 'Failed to create user',
    'admin.failedUpdateUser': 'Failed to update user',
    'admin.fullName': 'Full Name',
    'admin.email': 'Email',
    'admin.password': 'Password',
    'admin.newPassword': 'New Password',
    'admin.leaveBlankPassword': '(leave blank to keep current)',
    'admin.role': 'Role',
    'admin.dailyBudget': 'Daily Budget',
    'admin.fixedForAdmins': '(fixed $50 for admins)',
    'admin.editor': 'Editor',
    'admin.manager': 'Manager',
    'admin.admin': 'Admin',
    'admin.user': 'User',
    'admin.todaySpend': "Today's Spend",
    'admin.dailyLimit': 'Daily Limit',
    'admin.remaining': 'Remaining',
    'admin.actions': 'Actions',
    'admin.edit': 'Edit',
    'admin.fixed': 'fixed',
    'admin.deleteUser': 'Delete User',
    'admin.confirmDelete': 'Are you sure you want to permanently delete {{name}}? This cannot be undone.',
    'admin.userDeleted': 'User deleted',
    'admin.failedDeleteUser': 'Failed to delete user',
    'admin.deactivate': 'Deactivate',
    'admin.activate': 'Activate',
    'admin.statusActive': 'Active',
    'admin.statusInactive': 'Inactive',
    'admin.organization': 'Organization',
    'admin.orgPlaceholder': 'e.g. Prime9 News',
    'admin.dailyTokens': 'Daily Token Budget (USD)',
    'admin.budgetHint': 'Each AI generation costs roughly $0.001–0.01. $10/day ≈ 500–2000 scripts.',
    // Error alerts shown inside content generation pages
    'alert.budgetExhausted': 'Your daily token limit has been reached.',
    'alert.budgetExhaustedDetail': 'Please contact your administrator to increase your daily budget.',
    'alert.apiNotConfigured': 'AI provider not configured.',
    'alert.apiNotConfiguredDetail': 'No API key is set for your account. Please configure one in Settings → AI Provider, or contact your administrator.',
    // GenPage
    'genpage.inputLabel': 'Input — Paste news details, wire copy, or raw information',
    'genpage.inputPlaceholder': 'Paste raw news copy, press release, event details, or any source material…',
    'genpage.generating': 'Generating…',
    'genpage.generate': 'Generate',
    'genpage.stop': 'Stop',
    'genpage.stopped': 'Stopped. The script so far is kept.',
    'prompts.label': 'Prompt',
    'prompts.none': 'No prompt',
    'prompts.manageButton': 'Manage prompts',
    'prompts.standard': 'Standard',
    'prompts.emptyText': 'Empty — the script is written from your news material alone',
    'prompts.isDefault': 'This is the default prompt — make another prompt the default to change it',
    'prompts.cannotDelete': 'The standard prompt can be edited but not deleted',
    'prompts.builtInHint': 'This is the standard prompt. You can change it or clear it, but not delete it. If it is empty, the script is written from your news material alone.',
    'prompts.managerTitle': 'My prompts — {{place}}',
    'prompts.count': '{{count}} of {{max}} saved',
    'prompts.close': 'Close',
    'prompts.default': 'Default',
    'prompts.makeDefault': 'Make default',
    'prompts.setDefault': 'Select this prompt automatically',
    'prompts.unsetDefault': 'Stop selecting this prompt automatically',
    'prompts.edit': 'Edit',
    'prompts.delete': 'Delete',
    'prompts.deleteConfirm': 'Delete the prompt "{{label}}"?',
    'prompts.newTitle': 'New prompt',
    'prompts.editTitle': 'Edit prompt',
    'prompts.labelPlaceholder': 'Name, e.g. "Debate format, strong close"',
    'prompts.textPlaceholder': 'Write the instructions you want to reuse…',
    'prompts.useByDefault': 'Select this prompt by default',
    'prompts.cancel': 'Cancel',
    'prompts.save': 'Save prompt',
    'prompts.saving': 'Saving…',
    'prompts.saved': 'Prompt saved',
    'prompts.saveFailed': 'Could not save the prompt. Please try again.',
    'prompts.needLabelAndText': 'Add a name and the prompt text.',
    'prompts.add': 'Add a prompt',
    'prompts.full': 'You have {{max}} prompts — delete or edit one to add another',
    'prompts.search': 'Search prompts…',
    'prompts.noMatch': 'No prompt matches your search.',
    'genpage.tone': 'Tone',
    'genpage.toneStandard': 'Standard',
    'genpage.toneUrgent': 'Urgent',
    'genpage.toneConversational': 'Conversational',
    'genpage.copy': 'Copy',
    'genpage.copied': 'Copied!',
    'genpage.copyToClipboard': 'Copy to clipboard',
    'genpage.download': 'Download',
    'genpage.clear': 'Clear',
    'genpage.clearAll': 'Clear all',
    'genpage.aiGenerating': 'AI is generating…',
    'genpage.outputPlaceholder': 'Generated output will appear here. Click Generate to start.',
    'genpage.promptUsedFor': 'Prompt used for',
    'genpage.loadingPrompt': 'Loading prompt…',
    'genpage.userPromptTemplate': 'User Prompt Template',
    'genpage.noTemplate': '(no template)',
    'genpage.editPrompt': 'Edit Prompt',
    'genpage.promptError': 'Unable to load prompt. Make sure the backend is running.',
    'genpage.generateError': 'Content generation failed. Check your AI provider settings.',
    'genpage.clipboardError': 'Clipboard access denied by browser.',
    'genpage.downloadError': 'Download failed. Please try again.',
    'genpage.inputRequired': 'Please enter some input text before generating.',
    'genpage.docx': '.docx (Word)',
    'genpage.pdf': '.pdf',
    'genpage.characters': 'characters',
    'genpage.words': 'words',
    'genpage.editSaved': 'Edit saved — AI will learn from this improvement ✓',
    'genpage.editSavedError': 'Edit saved locally, but learning feedback could not be stored.',
    // OutputToolbar
    'toolbar.changesVsOriginal': 'Changes vs. original AI output',
    'toolbar.addedByEditor': 'Added by editor',
    'toolbar.removedFromDraft': 'Removed from AI draft',
    'toolbar.noContent': 'No content to compare.',
    'toolbar.fontFamily': 'Font family',
    'toolbar.decreaseFont': 'Decrease font size',
    'toolbar.increaseFont': 'Increase font size',
    'toolbar.editOutput': 'Edit output',
    'toolbar.edit': 'Edit',
    'toolbar.editing': 'Editing…',
    'toolbar.saveYourEdit': 'Save your edit',
    'toolbar.saveEdit': 'Save Edit',
    'toolbar.discardYourEdit': 'Discard your edit',
    'toolbar.discard': 'Discard',
    'toolbar.showChangesTitle': 'Show changes vs. original AI output',
    'toolbar.showChanges': 'Show Changes',
    'toolbar.close': 'Close',
    // Settings — Profile
    'settings.profile': 'Profile & Account',
    'settings.profileSubtitle': 'Manage your name, email, and password',
    'settings.comingSoon': 'Coming soon',
    'settings.profileBeingBuilt': 'Profile editor is being built.',
    // Settings — AI Provider
    'settings.aiProvider': 'AI Provider Settings',
    'settings.aiProviderSubtitle': 'Configure API keys and models for each AI provider. The active provider is used for all content generation.',
    'settings.loadingProviders': 'Loading provider settings…',
    'settings.active': 'Active',
    'settings.enabled': 'Enabled',
    'settings.apiKey': 'API Key',
    'settings.storedKey': '(stored — enter new to replace)',
    'settings.model': 'Model',
    'settings.saving': 'Saving…',
    'settings.saved': 'Saved!',
    'settings.save': 'Save',
    'settings.setAsDefault': 'Set as Default',
    'settings.getApiKey': 'Get API key →',
    'settings.apiKeyRequired': 'API key is required',
    'settings.failedSave': 'Failed to save',
    // Settings — Prompt Editor
    'settings.promptEditor': 'Prompt Editor',
    'settings.promptEditorSubtitle': 'Customise system and user prompt templates for each content type. Changes override the built-in registry defaults.',
    'settings.loadingPrompts': 'Loading prompts…',
    'settings.contentType': 'Content Type',
    'settings.customOverrideActive': '✦ Custom override active',
    'settings.systemPrompt': 'System Prompt',
    'settings.systemPromptHint': "Sets the AI's role and tone for this content type.",
    'settings.systemPromptPlaceholder': 'You are a Telugu TV broadcast script writer…',
    'settings.userPromptTemplate': 'User Prompt Template',
    'settings.userPromptHint': 'Use {{input}} for the source text and {{options}} for additional options.',
    'settings.userPromptPlaceholder': 'Write a script based on:\n{{input}}\n\n{{options}}',
    'settings.notes': 'Notes',
    'settings.optional': '(optional)',
    'settings.notesPlaceholder': 'Usage hints or reminders for this prompt…',
    'settings.saveChanges': 'Save Changes',
    'settings.resetting': 'Resetting…',
    'settings.resetToDefault': 'Reset to Default',
    'settings.failedLoadPrompts': 'Failed to load prompts',
    'settings.failedLoadPrompt': 'Failed to load prompt',
    'settings.userPromptRequired': 'User prompt template is required',
    'settings.failedSavePrompt': 'Failed to save',
    'settings.failedResetPrompt': 'Failed to reset',
    'settings.resetConfirm': 'Reset this prompt to the registry default?',
    'settings.promptEditorAccessRestricted': 'Access Restricted',
    'settings.promptEditorAdminOnly': 'Prompt editing is available to administrators only.',
    'settings.resetSuccess': 'Reset to default — custom override removed',
    'settings.saveSuccess': 'Prompt saved',
    'settings.lastModifiedBy': 'Last modified by',
    'settings.on': 'on',
    'settings.editorialNotes': 'Editorial Notes',
    'settings.systemPromptFullHint': 'System Prompt — sets AI persona and rules',
    'settings.userPromptFullHint': 'User Prompt Template — use {{input}}, {{options}} as placeholders',
    'settings.selectPromptType': 'Select a content type from the list to begin editing.',
    // Settings — Editorial Rules
    'settings.editorialRules': 'Editorial Rules',
    'settings.editorialRulesSubtitle': 'Channel-wide style guide, banned words, and tone directives',
    'settings.editorialRulesBeingBuilt': 'Editorial rules editor is being built.',
    // Settings — Usage & Billing
    'settings.usageBilling': 'Usage & Billing',
    'settings.usageBillingSubtitle': 'Token consumption, daily budget, and cost breakdown',
    'settings.usageDashboardBeingBuilt': 'Usage dashboard is being built.',
    // Usage & Billing — cost report
    'usage.subtitle': 'What AI costs, by person and by activity',
    'usage.range.today': 'Today',
    'usage.range.yesterday': 'Yesterday',
    'usage.range.thisWeek': 'This week',
    'usage.range.lastWeek': 'Last week',
    'usage.range.thisMonth': 'This month',
    'usage.range.lastMonth': 'Last month',
    'usage.range.last30': 'Last 30 days',
    'usage.range.thisYear': 'This year',
    'usage.range.lastYear': 'Last year',
    'usage.from': 'From',
    'usage.to': 'To',
    'usage.refresh': 'Refresh',
    'usage.badRange': 'Choose a start date on or before the end date.',
    'usage.totalSpend': 'Total spend',
    'usage.paidCalls': 'Paid AI calls',
    'usage.topActivity': 'Top activity',
    'usage.topUser': 'Top user',
    'usage.noSpend': 'No AI spend in this period.',
    'usage.byActivity': 'By activity',
    'usage.byUser': 'By user',
    'usage.activity': 'Activity',
    'usage.user': 'User',
    'usage.cost': 'Cost',
    'usage.share': 'Share',
    'usage.calls': 'Calls',
    'usage.activity.quickAI': 'Quick AI',
    'usage.activity.mediaAI': 'Media AI',
    'usage.activity.scripts': 'Scripts & Programs',
    'usage.activity.scriptToVoice': 'Script to Voice',
    'usage.activity.fullStory': 'Full Story',
    'usage.activity.fullStoryVideo': 'Full Story Video',
    'usage.activity.graphicPlates': 'Graphic Plates',
    'usage.activity.pipeline': 'Automation Pipeline',
    'usage.activity.dubbing': 'Language Change (Dubbing)',
    'usage.activity.videoToScript': 'Video to Script',
    'usage.kind.Text': 'Text',
    'usage.kind.Images': 'Images',
    'usage.kind.Video': 'Video',
    'usage.kind.Voice': 'Voice',
    'usage.kind.Transcription': 'Transcription',
    'usage.role.admin': 'Admin',
    'usage.role.superadmin': 'Admin',
    'usage.role.manager': 'Manager',
    'usage.role.editor': 'Editor',
    'usage.role.user': 'User',
    'usage.role.viewer': 'Viewer',
    'usage.note': "Costs are calculated from each provider's published prices and may differ slightly from the invoices. Days run in Indian time. ElevenLabs voice is priced at {{rate}} per 1,000 credits (1 credit per character). Script to Voice, Dubbing, Pipeline thumbnails and voice-overs, and Video to Script are counted from 29 Oct 2026, when their costs started being recorded.",
    // Budget (ContentEditor)
    'budget.exceeded': 'Daily budget of ${{limit}} has been reached (${{spent}} spent). Content generation is paused. Contact your admin to increase your limit.',
    'budget.near90': 'Almost out of budget! ${{remaining}} remaining of ${{limit}} daily limit ({{percent}}% used).',
    'budget.near': 'Budget alert: ${{remaining}} remaining of ${{limit}} today ({{percent}}% used).',
    'budget.contactAdmin': 'Contact admin to add more credits.',
    'budget.dailyReached': 'Daily budget of ${{limit}} reached. Contact your admin for a top-up.',
    // Facebook preview (ContentEditor)
    'facebook.previewTitle': 'KultWorks News',
    'facebook.previewSubtitle': 'Facebook Post Preview',
    // History table
    'history.user': 'User',
    'history.input': 'Input',
    'history.aiOutput': 'AI Generated Output',
    'history.currentOutput': 'Current Output (Edited)',
    'history.editHistoryLabel': 'Edit History',
    'history.version': 'Version',
    'history.editedOn': 'Edited on',
    'history.original': 'Original AI Output',
    'history.editedBadge': 'Edited',
    'history.noEdits': 'No edits have been made to this output.',
    'history.collapseVersions': 'Hide versions',
    'history.expandVersions': 'Show all versions',
    'history.aiTab': 'AI Output',
    'history.editedTab': 'Edited Output',
    'history.showDiff': 'Show Changes',
    'history.hideDiff': 'Hide Changes',
    'history.addedByEditor': 'Added by editor',
    'history.removedFromDraft': 'Removed from AI draft',
    'history.noEditYet': 'This output has not been edited yet.',
    'history.lastEditedOn': 'Last edited',
    'history.settingsUsed': 'Settings Used',
    'history.toneLabel': 'Tone',
    'history.durationLabel': 'Duration',
    'history.wordCountLabel': 'Word Count',
    'history.providerLabel': 'AI Provider',
    'history.customInstructionsLabel': 'Custom Instructions',
    'history.wordsUnit': 'words',
    'history.pagination.showing': 'Showing',
    'history.pagination.to': 'to',
    'history.pagination.of': 'of',
    'history.pagination.results': 'results',
    'history.pagination.prev': 'Prev',
    'history.pagination.next': 'Next',
    'history.pagination.perPage': 'Per page',
    // Shared control labels used across content pages
    'label.duration': 'Duration',
    'label.stories': 'Stories',
    'label.count': 'Count',
    'label.maxWords': 'Max words',
    'label.headlines': 'Headlines',
    'label.plates': 'Plates',
    'label.sport': 'Sport',
    'label.hashtags': 'Hashtags',
    'label.emojis': 'Emojis',
    'label.posts': 'Posts',
    'label.length': 'Length',
    'label.include': 'Include',
    'label.exclude': 'Exclude',
    'label.byMinutes': 'By Minutes',
    'label.byWords': 'By Words',
    // Coming-soon pages
    'page.comingSoon': 'Coming soon',
    'page.editorBeingBuilt': 'This editor is being built.',
    // Content page — Breaking Plates
    'page.breakingPlates.title': 'Breaking Plates',
    'page.breakingPlates.desc': 'Generate on-screen lower thirds, headline plates, and ticker banners for breaking news',
    'page.breakingPlates.output': 'Generated Plates',
    // Content page — Breaking Points
    'page.breakingPoints.title': 'Breaking Points',
    'page.breakingPoints.desc': 'Generate rapid bullet-point summaries for breaking news situations',
    'page.breakingPoints.output': 'Generated Points',
    // Content page — Tops
    'page.tops.title': 'Tops',
    'page.tops.desc': 'Generate top-of-bulletin anchor read scripts for show opens',
    'page.tops.output': 'Generated Tops Script',
    // Content page — News Bulletin
    'page.newsBulletin.title': 'News Bulletin',
    'page.newsBulletin.desc': 'Generate a full news bulletin rundown script with anchor reads, VOs, and transitions',
    'page.newsBulletin.output': 'Generated Bulletin Script',
    // Content page — Scrollings
    'page.scrollings.title': 'Scrollings',
    'page.scrollings.desc': 'Generate TV ticker / scroll bar text for continuous news updates',
    'page.scrollings.output': 'Generated Scrolls',
    // Content page — Voice Over
    'page.voiceOver.title': 'Voice Over',
    'page.voiceOver.desc': 'Generate VO transcript for anchor or reporter to read on air over B-roll visuals',
    'page.voiceOver.output': 'Generated VO Script',
    // Content page — Speed News
    'page.speedNews.title': 'Speed News',
    'page.speedNews.desc': 'Generate rapid-fire speed news items for high-tempo bulletin segments',
    'page.speedNews.output': 'Generated Speed News Items',
    // Content page — Headlines with Slugs
    'page.headlinesSlugs.title': 'Headlines with Slugs',
    'page.headlinesSlugs.desc': 'Generate broadcast headlines paired with their editorial slugs for rundown sheets',
    'page.headlinesSlugs.output': 'Generated Headlines & Slugs',
    // Content page — Breaking News Presentation
    'page.breakingNewsPresentation.title': 'Breaking News Presentation',
    'page.breakingNewsPresentation.desc': 'Full breaking news on-air presentation script with anchor cues, tickers, and handoffs',
    'page.breakingNewsPresentation.output': 'Generated Breaking News Script',
    // Content page — Anchor BG Titles
    'page.anchorBgTitles.title': 'Anchor BG Titles',
    'page.anchorBgTitles.desc': 'Generate lower-third supers and background screen titles for anchor shots',
    'page.anchorBgTitles.output': 'Generated Titles',
    // Content page — Promo Script
    'page.promoScript.title': 'Promo Script',
    'page.promoScript.desc': 'Generate on-air promo and teaser scripts for upcoming shows and breaking stories',
    'page.promoScript.output': 'Generated Promo Script',
    // Content page — Digital Anchor Visual
    'page.digitalAnchorVisual.title': 'Digital Anchor Visual',
    'page.digitalAnchorVisual.desc': 'Paste one or more numbered raw news items (short notes, not full sentences) and get back one natural spoken-Telugu paragraph per item, in the same order — for a human anchor to read on camera.',
    'page.digitalAnchorVisual.output': 'Generated Digital Anchor Visual Script',
    // Content page — Conspiracy Theory Angle
    'page.conspiracyTheory.title': 'Conspiracy Theory Angle',
    'page.conspiracyTheory.desc': 'Generate an investigative or conspiracy-angle script that presents alternative interpretations while remaining responsible',
    'page.conspiracyTheory.output': 'Generated Investigative Script',
    // Content page — In-Depth (30 Min)
    'page.indepth.title': 'In-Depth (30 Min)',
    'page.indepth.desc': 'Generate a full 30-minute in-depth show script with structured segments, analysis, expert bytes, and closing summary',
    'page.indepth.output': 'Generated In-Depth Script',
    // Content page — Off The Record (30 Min)
    'page.offTheRecord.title': 'Off The Record (30 Min)',
    'page.offTheRecord.desc': 'Generate a 30-minute political talk show script with interview questions, anchor intro, expert panel exchanges, and closing remarks',
    'page.offTheRecord.output': 'Generated Off The Record Script',
    // Content page — Special Focus (30 Min)
    'page.specialFocus.title': 'Special Focus (30 Min)',
    'page.specialFocus.desc': 'Generate a 30-minute special focus documentary-style show script with deep-dive segments, visuals cues, and anchor narration',
    'page.specialFocus.output': 'Generated Special Focus Script',
    // Content page — Analysis (10 Min)
    'page.analysis.title': 'Analysis (10 Min)',
    'page.analysis.desc': 'Generate a 10-minute analysis segment script with structured arguments, supporting data points, and a clear anchor-led conclusion',
    'page.analysis.output': 'Generated Analysis Script',
    // Content page — Burning Issue
    'page.burningIssue.title': 'Burning Issue',
    'page.burningIssue.desc': 'Write a Burning Issue script from your news material — use your own saved prompt to set the format',
    'page.burningIssue.output': 'Generated Burning Issue Script',
    'page.tcr.title': 'TCR',
    'page.tcr.desc': 'Write a TCR script from your news material — use your own saved prompt to set the format',
    'page.tcr.output': 'Generated TCR Script',
    'page.worldNews.title': 'World News',
    'page.worldNews.desc': 'Write a World News script from your news material — use your own saved prompt to set the format',
    'page.worldNews.output': 'Generated World News Script',
    'page.crimeStory.title': 'Crime Story',
    'page.crimeStory.desc': 'Write a Crime Story script from your news material — use your own saved prompt to set the format',
    'page.crimeStory.output': 'Generated Crime Story Script',
    // Coming-soon content pages — In-Depth 30 / Off The Record 30 / Special Focus 30 / Analysis 10
    'page.indepth30.title': 'In-Depth 30',
    'page.indepth30.desc': '30-minute deep-dive show scripts with structured segments and transitions',
    'page.offTheRecord30.title': 'Off The Record 30',
    'page.offTheRecord30.desc': '30-minute investigative and background-context show format scripts',
    'page.specialFocus30.title': 'Special Focus 30',
    'page.specialFocus30.desc': '30-minute themed special programming scripts with editorial arc',
    'page.analysis10.title': 'Analysis 10',
    'page.analysis10.desc': '10-minute expert analysis segments with structured talking points',
    // News Anchor Formats page
    'anchorFormats.title': 'News Anchor Formats',
    'anchorFormats.desc': 'Telugu TV anchor scripts — Visual, Visual Byte, Byte, Package, Live, Reporter, Guest and Drive',
    // QuickAI — free-form ChatGPT-style chat, no content-type templates
    'quickAI.title': 'Quick AI',
    'quickAI.desc': 'Free-form AI chat — ask anything, write anything, no templates',
    'quickAI.newChat': 'New chat',
    'quickAI.chats': 'Chats',
    'quickAI.loadingChats': 'Loading chats…',
    'quickAI.noChats': 'No chats yet. Start one below.',
    'quickAI.emptyTitle': 'What can I help with?',
    'quickAI.emptyDesc': 'Type a story, a question, or an instruction below — in Telugu, English, or any language.',
    'quickAI.inputPlaceholder': 'Message Quick AI…',
    'quickAI.send': 'Send',
    'quickAI.attach': 'Attach files — PDF, Word, Excel, pictures or any file (up to {{max}})',
    'quickAI.removeFile': 'Remove',
    'quickAI.dropHere': 'Drop files to attach them (up to {{max}})',
    'quickAI.tooManyFiles': 'You can attach up to {{max}} files per message.',
    'quickAI.fileTooLarge': '"{{name}}" is larger than 25 MB.',
    'quickAI.emptyFile': '"{{name}}" is empty.',
    'quickAI.stop': 'Stop generating',
    'quickAI.disclaimer': 'Quick AI can make mistakes — check important information.',
    'quickAI.deleteConfirm': 'Delete this chat? This cannot be undone.',
    'quickAI.myChats': 'My Chats',
    'quickAI.team': 'Team',
    'quickAI.searchUser': 'Search by user name…',
    'quickAI.noTeamChats': 'No chats found.',
    'quickAI.viewingAs': 'Viewing',
    'quickAI.readOnly': 'read-only',
    'sidebar.item.mediaAI': 'Media AI',
    'admin.mediaAI': 'Media AI',
    'admin.mediaAIAlwaysOn': 'Always on',
    'admin.mediaAITurnOn': 'Turn on Media AI for this user',
    'admin.mediaAITurnOff': 'Turn off Media AI for this user',
    'admin.mediaAIEnabled': 'Media AI turned on for {{name}}',
    'admin.mediaAIDisabled': 'Media AI turned off for {{name}}',
    'admin.featureAccess': 'Feature access',
    'admin.featureAccessHint': 'Choose which optional features this user can open. Everything is off until you turn it on.',
    'admin.featuresAlwaysOnHint': 'Admins always have every feature.',
    'admin.featureAlwaysOnForRole': 'Always on for the {{role}} role.',
    'admin.allFeatures': 'All features',
    'admin.featureTurnOn': 'Turn on {{feature}} for this user',
    'admin.featureTurnOff': 'Turn off {{feature}} for this user',
    'admin.featureEnabled': '{{feature}} turned on for {{name}}',
    'admin.featureDisabled': '{{feature}} turned off for {{name}}',
    'admin.filterByFeature': 'Filter users by feature access',
    'admin.filterAllUsers': 'All users',
    'admin.filterHasFeature': 'Has {{feature}}',
    'admin.filterLacksFeature': 'No {{feature}}',
    'admin.noUsersMatchFilter': 'No users match this filter.',
    'features.mediaAI': 'Media AI',
    'features.mediaAIDesc': 'Generate and edit images and videos with AI.',
    'features.fullStory': 'Full Story',
    'features.fullStoryDesc': 'Turn a story into a narrated video: script, voice, pictures and render.',
    'sidebar.item.fullStoryVideo': 'Full Story Video',
    'features.fullStoryVideo': 'Full Story Video',
    'features.fullStoryVideoDesc': 'Turn raw footage into a full TV package: script, voice-over over matching footage, spots, bites and graphics.',
    'features.scriptToVoice': 'Script to Voice',
    'features.scriptToVoiceDesc': 'Turn a written script into a voice-over (MP3) in a chosen voice — up to 3,00,000 characters.',
    'fullStoryVideo.title': 'Full Story Video',
    'fullStoryVideo.subtitle': 'Upload raw footage and photos — get a finished package with voice-over, spots, bites and graphics.',
    'fullStoryVideo.untitled': 'Untitled package',
    'fullStoryVideo.newStory': 'New package',
    'fullStoryVideo.plateTemplates': 'Graphic Plates',
    'fullStoryVideo.look.plateTemplate': 'Graphic plate',
    'fullStoryVideo.look.plateTemplateHint': 'Every text plate of this video plays in this graphic plate — its photo and words appear in the plate\'s window. A plate can have its own.',
    'fullStoryVideo.look.plateTemplateAi': 'chosen by AI for this story',
    'fullStoryVideo.look.plateTemplateYou': 'chosen by you',
    'fullStoryVideo.look.plateTemplateDefault': 'default — plan the scenes to have one chosen',
    'fullStoryVideo.scene.plateChange': 'Graphic plate',
    'fullStoryVideo.scene.plateOwn': 'Own graphic plate',
    'fullStoryVideo.scene.plateTitle': 'Graphic plate for this plate',
    'fullStoryVideo.scene.plateHint': 'This text plate only — the others keep the story\'s graphic plate.',
    'fullStoryVideo.scene.plateUseStory': 'Use the story\'s graphic plate',
    'plateTemplates.title': 'Templates — Graphic Plates',
    'plateTemplates.subtitle': 'Animated plate designs that loop. The dark area in each is where a video or animated text plays.',
    'plateTemplates.back': 'Full Story Video',
    'plateTemplates.all': 'All',
    'plateTemplates.count': '{{count}} templates',
    'plateTemplates.loading': 'Loading templates…',
    'plateTemplates.preparing': 'Preparing animation…',
    'plateTemplates.preparingAll': 'Drawing animations: {{done}} of {{total}} ready. Posters show until each is ready.',
    'plateTemplates.loop': '{{seconds}}s loop',
    'plateTemplates.areas': '{{count}} content areas',
    'plateTemplates.area': '1 content area',
    'plateTemplates.close': 'Close',
    'plateTemplates.previous': 'Previous',
    'plateTemplates.next': 'Next',
    'plateTemplates.create': 'Create graphic plate',
    'plateTemplates.createTitle': 'Create a graphic plate',
    'plateTemplates.createHint': 'Describe the plate — or paste a prompt from an uploaded plate (View prompt). It is made as one finished 16:9 design with an empty text panel; in stories the scene\'s line is written into the panel, with the same animation and fonts as uploaded plates.',
    'plateTemplates.createPlaceholder': 'e.g. A versus plate for two chief ministers, in front of the Assembly at night, saffron and green light',
    'plateTemplates.createCost': 'Uses one high-quality AI picture (about $0.05). Takes about a minute.',
    'plateTemplates.createGo': 'Create',
    'plateTemplates.creating': 'Starting…',
    'plateTemplates.cancel': 'Cancel',
    'plateTemplates.custom': 'Created',
    'plateTemplates.customBadge': 'Custom',
    'plateTemplates.by': 'by {{name}}',
    'plateTemplates.status.planning': 'Designing the plate…',
    'plateTemplates.status.imaging': 'Making the background…',
    'plateTemplates.status.drawing': 'Drawing the animation…',
    'plateTemplates.status.failed': 'Could not be made',
    'plateTemplates.status.designing': 'Designing the plate…',
    'plateTemplates.usually': 'usually 1–2 minutes',
    'plateTemplates.openToRetry': 'Open it to try again.',
    'plateTemplates.tryAgain': 'Try again',
    'platePrompts.galleryButton': 'Favourite prompts',
    'platePrompts.loadFailed': 'Could not load favourites: {{error}}',
    'platePrompts.savedUnder': 'Saved to favourites under "{{label}}".',
    'platePrompts.removed': 'Removed from favourites.',
    'platePrompts.seeFavorites': 'See favourites',
    'plateTemplates.people.startFailed': 'Could not start: {{error}}',
    'plateTemplates.studio.fullscreen': 'Full screen',
    'plateTemplates.studio.exitFullscreen': 'Exit full screen',
    'plateTemplates.studio.back': 'Gallery',
    'plateTemplates.studio.more': 'More',
    'plateTemplates.studio.downloads': 'Downloads (16:9, 1920×1080)',
    'plateTemplates.studio.remove': 'Remove this plate…',
    'plateTemplates.studio.previewMode': 'Preview',
    'plateTemplates.studio.live': 'Live preview',
    'plateTemplates.studio.areas': 'Adjust areas',
    'plateTemplates.studio.sampleWords': 'With sample words',
    'plateTemplates.studio.replay': 'Play again',
    'plateTemplates.studio.unsaved': 'Not saved yet',
    'plateTemplates.studio.liveHint': 'Every change you make shows here at once — before you save.',
    'plateTemplates.studio.areasHint': 'Drag the text area and blur areas; resize from their corners. The live preview shows the result.',
    'plateTemplates.studio.tab.design': 'Design',
    'plateTemplates.studio.tab.animation': 'Animation',
    'plateTemplates.studio.tab.blur': 'Blur',
    'plateTemplates.studio.tab.changes': 'AI changes',
    'plateTemplates.studio.tab.details': 'Details',
    'plateTemplates.studio.textAreaHint': 'Where the words go.',
    'plateTemplates.studio.move': 'Move / resize',
    'plateTemplates.studio.done': 'Done',
    'plateTemplates.studio.blurTitle': 'Blur areas',
    'plateTemplates.studio.tags': 'Tags',
    'plateTemplates.studio.about': 'About',
    'plateTemplates.studio.noPrompt': 'No prompt for this plate.',
    'plateTemplates.studio.discard': 'Discard',
    'plateTemplates.studio.save': 'Save changes',
    'plateTemplates.studio.allSaved': 'All changes saved',
    'plateTemplates.studio.discardConfirm': 'You have changes that are not saved. Leave without saving them?',
    'plateTemplates.eta.left': 'about {{left}} left',
    'plateTemplates.eta.late': 'taking longer than usual',
    'plateTemplates.people.title': 'People that move',
    'plateTemplates.people.hint': 'Each person on a layer of their own: they move gently while the plate holds, and come in and go out — like a channel\'s own plates.',
    'plateTemplates.people.find': 'Find & animate people',
    'plateTemplates.people.again': 'Find the people again',
    'plateTemplates.people.cost': 'About a minute, in the background (three AI pictures, ~$0.16). The plate stays usable.',
    'plateTemplates.people.working': 'Finding the people…',
    'plateTemplates.people.usually': 'usually under a minute',
    'plateTemplates.people.stale': 'The picture changed since — find them again for this version.',
    'plateTemplates.people.on': 'Animate the people ({{count}} found)',
    'plateTemplates.people.motionLabel': 'Motion',
    'plateTemplates.people.entranceLabel': 'In & out',
    'plateTemplates.people.strengthLabel': 'Strength',
    'plateTemplates.people.motion.breathe': 'Breathe (slow push)',
    'plateTemplates.people.motion.drift': 'Drift',
    'plateTemplates.people.motion.parallax': 'Parallax',
    'plateTemplates.people.motion.still': 'Still',
    'plateTemplates.people.entrance.slide': 'Slide in from the sides',
    'plateTemplates.people.entrance.rise': 'Rise up',
    'plateTemplates.people.entrance.zoom': 'Zoom in',
    'plateTemplates.people.entrance.fade': 'Fade',
    'plateTemplates.people.entrance.none': 'None',
    'plateTemplates.people.strength.subtle': 'Subtle',
    'plateTemplates.people.strength.medium': 'Medium',
    'plateTemplates.people.strength.strong': 'Strong',
    'plateTemplates.live.loading': 'Loading…',
    'plateTemplates.live.pause': 'Pause',
    'plateTemplates.live.play': 'Play',
    'plateTemplates.pkg.playThis': 'Play this text',
    'plateTemplates.pkg.fullKeys': 'Space: play / pause · ← →: previous / next text · Esc: leave full screen',
    'plateTemplates.fxLayer.title': 'Effects run',
    'plateTemplates.fxLayer.front': 'Above the text plates',
    'plateTemplates.fxLayer.behind': 'Behind the text plates',
    'plateTemplates.fxLayer.hint.front': 'The effects fall over everything, the text panels too (as always).',
    'plateTemplates.fxLayer.hint.behind': 'The effects run around and behind the text panels — never over the panels or their words. Every text area of a package counts as a text plate.',
    'plateFonts.search': 'Search {{count}} fonts…',
    'plateFonts.kind.all': 'All',
    'plateFonts.kind.builtin': 'Channel picks',
    'plateFonts.kind.uploaded': 'Uploaded',
    'plateFonts.kind.display': 'Display',
    'plateFonts.kind.sans': 'Sans',
    'plateFonts.kind.serif': 'Serif',
    'plateFonts.kind.handwriting': 'Handwriting',
    'plateFonts.none': 'No font matches.',
    'plateFonts.uploadedBy': 'uploaded by {{name}}',
    'plateFonts.removeConfirm': 'Remove the font "{{name}}" for everyone? Plates using it go back to the default font.',
    'plateFonts.namePlaceholder': 'Name (optional) — e.g. "Anu Bold"',
    'plateFonts.upload': 'Upload a font',
    'plateFonts.uploadHint': 'Any font your channel has a licence for (Anu, Gautami, Nirmala UI, Shree-Lipi…): .ttf, .otf or .ttc, up to 30 MB. It must be a Unicode Telugu font — older fonts typed with a script manager are refused, with why. Everyone can then use it.',
    'plateTemplates.people.hintPlaceholder': 'Who to find (optional) — e.g. "only the two leaders in front"',
    'plateTemplates.people.filling': 'Filling in the background behind them…',
    'plateTemplates.people.choose': 'Choose what moves',
    'plateTemplates.people.moving': '{{count}} moving of {{found}} found',
    'plateTemplates.people.oldWay': 'Found the old way — find them again to choose who moves and to fill the background behind them.',
    'plateTemplates.people.uncoveredShort': 'Part of what moves has no background behind it yet — open "Choose what moves" to fill it.',
    'plateTemplates.people.editor.title': 'Choose what moves',
    'plateTemplates.people.editor.hint': 'Click a person to make them move or stay still. Add any person or object by painting over it. Mend an outline with the brush.',
    'plateTemplates.people.editor.saving': 'Saving…',
    'plateTemplates.people.editor.done': 'Done',
    'plateTemplates.people.editor.view.plate': 'Plate',
    'plateTemplates.people.editor.view.behind': 'Background behind them',
    'plateTemplates.people.editor.view.motion': 'Preview motion',
    'plateTemplates.people.editor.task.add': 'Taking it out and filling the background behind it…',
    'plateTemplates.people.editor.task.fill': 'Filling in the background…',
    'plateTemplates.people.editor.behindHint': 'What shows when the moving ones move away. Something left over here? Paint it with "Add" and find it, or fill the background again.',
    'plateTemplates.people.editor.motionHint': 'The people moving as they will in the video (without words).',
    'plateTemplates.people.editor.toolHint.pick': 'Click a person or object: coloured ones move, grey ones stay still.',
    'plateTemplates.people.editor.toolHint.add': 'Paint over the whole person or object, a little past its edges — then say what it is and press "Find it".',
    'plateTemplates.people.editor.toolHint.moves': 'Paint a part that should move with the person (hair, a hand, a mic that was missed). Applied as you lift the brush.',
    'plateTemplates.people.editor.toolHint.still': 'Paint a part that should stay still (a panel or frame caught in the outline). It stays in front of the moving person.',
    'plateTemplates.people.editor.toolHint.erase': 'Rub out brush marks: that part goes back to how it was found.',
    'plateTemplates.people.editor.uncovered': 'Part of what moves has no background behind it yet, so it could look cut out when it moves.',
    'plateTemplates.people.editor.fill': 'Fill the background (~40 s)',
    'plateTemplates.people.editor.tools': 'Tools',
    'plateTemplates.people.editor.tool.pick': 'Pick',
    'plateTemplates.people.editor.tool.add': 'Add',
    'plateTemplates.people.editor.tool.moves': 'Moves',
    'plateTemplates.people.editor.tool.still': 'Stays still',
    'plateTemplates.people.editor.tool.erase': 'Erase',
    'plateTemplates.people.editor.size': 'Brush',
    'plateTemplates.people.editor.undo': 'Undo',
    'plateTemplates.people.editor.clearBrush': 'Clear brush marks',
    'plateTemplates.people.editor.addTitle': 'Add a person or object',
    'plateTemplates.people.editor.addHint': 'Painted over it on the plate? Say what it is (helps the AI), then find it. It is taken out exactly, and the background behind it filled in.',
    'plateTemplates.people.editor.labelPlaceholder': 'What is it? e.g. "the car", "the trophy"',
    'plateTemplates.people.editor.addGo': 'Find it',
    'plateTemplates.people.editor.clearMarks': 'Clear marks',
    'plateTemplates.people.editor.addCost': 'About 40 s, in the background (two AI pictures, ~$0.10).',
    'plateTemplates.people.editor.list': 'On this plate ({{moving}} of {{count}} moving)',
    'plateTemplates.people.editor.moves': '{{n}} moves',
    'plateTemplates.people.editor.object': 'Object {{n}}',
    'plateTemplates.people.editor.person': 'Person {{n}}',
    'plateTemplates.people.editor.rough': 'rough outline — check it',
    'plateTemplates.people.editor.moving': 'moves',
    'plateTemplates.people.editor.still': 'still',
    'plateTemplates.people.editor.listHint': 'The background behind every one of them is filled in already, so any of them can move without looking cut out.',
    'plateTemplates.pkg.lineSpacing': 'Line {{n}} spacing',
    'plateTemplates.pkg.lineSpacingHint': 'Line spacing: the line\'s height as a multiple of its size',
    'plateTemplates.pkg.spacingAuto': 'Spacing: auto',
    'plateTemplates.pkg.spacingValue': 'Spacing {{v}}×',
    'plateTemplates.pkg.wordStyles': 'Word styles — click a word to give it its own colour, size, stroke or shadow',
    'plateTemplates.pkg.wordStyle': '"{{word}}"',
    'plateTemplates.pkg.wordSize': 'Size',
    'plateTemplates.pkg.wordAsLine': 'As the line',
    'plateTemplates.pkg.wordStyleClear': 'Back to the line\'s style',
    'plateTemplates.pkg.transparent': 'Transparent background (.mov)',
    'plateTemplates.pkg.transparentHint': 'Videos with a transparent background where the plate isn\'t (as a transition brings it in and out) — to lay over other footage in your editing software.',
    'plateTemplates.pkg.formatTransparent': 'Images: JPG, 1920×1080. Videos: MOV (ProRes 4444 with transparency), 1920×1080, 25 fps — opens in Premiere, Final Cut, DaVinci, Vegas. Several download together as a ZIP. No AI credits are used.',
    'plateTemplates.pkg.plateUnsaved': 'Plate changes not saved',
    'plateTemplates.pkg.savePlate': 'Save plate',
    'plateTemplates.pkg.tab.style': 'Text style',
    'plateTemplates.pkg.blurPackage': 'Blur on this package\'s plates',
    'plateTemplates.pkg.blurPlate': 'Blur on the plate itself (every package)',
    'plateTemplates.pkg.onPlate': 'plate',
    'plateTemplates.setupView.animation': 'Animation',
    'plateTemplates.fx.title': 'Effects',
    'plateTemplates.fx.hint': '{{count}} of {{max}} chosen — they play over the plate, in previews, packages and downloads',
    'plateTemplates.fx.thunder': 'Thunderstorm',
    'plateTemplates.fx.earthquake': 'Earthquake',
    'plateTemplates.fx.rain': 'Rain',
    'plateTemplates.fx.snow': 'Snow',
    'plateTemplates.fx.embers': 'Fire embers',
    'plateTemplates.fx.smoke': 'Smoke / fog',
    'plateTemplates.fx.glitch': 'Glitch',
    'plateTemplates.fx.flare': 'Lens flare',
    'plateTemplates.fx.confetti': 'Confetti',
    'plateTemplates.fx.sparkle': 'Sparkles',
    'plateTemplates.fx.pulse': 'Breaking pulse',
    'plateTemplates.fx.searchlight': 'Searchlights',
    'plateTemplates.fx.grain': 'Film grain',
    'plateTemplates.fx.bokeh': 'Bokeh lights',
    'plateTemplates.fx.dust': 'Golden dust',
    'plateTemplates.transition.title': 'Transition in and out',
    'plateTemplates.transition.hint': 'How the plate comes in at the start and goes out at the end (packages, stories and downloads).',
    'plateTemplates.transition.build': 'Build (default)',
    'plateTemplates.transition.whip': 'Whip zoom',
    'plateTemplates.transition.slide': 'Slide from left',
    'plateTemplates.transition.slideright': 'Slide from right',
    'plateTemplates.transition.slideup': 'Slide up',
    'plateTemplates.transition.wipe': 'Light wipe',
    'plateTemplates.transition.flash': 'Flash',
    'plateTemplates.transition.blur': 'Blur',
    'plateTemplates.transition.shutter': 'Shutter bars',
    'plateTemplates.transition.split': 'Split',
    'plateTemplates.transition.glitch': 'Glitch',
    'plateTemplates.transition.fade': 'Fade',
    'plateTemplates.transition.none': 'None (cut)',
    'plateTemplates.times.ready': 'Ready to use in {{time}}',
    'plateTemplates.times.animated': 'animation in {{time}}',
    'plateTemplates.createPromptLabel': 'Prompt',
    'platePrompts.open': 'Favourite & recent prompts',
    'platePrompts.title': 'Favourite & recent prompts',
    'platePrompts.hint': 'Each prompt with the plate it made. "Use" puts the prompt in Create graphic plate — change it there as you like.',
    'platePrompts.loading': 'Loading prompts…',
    'platePrompts.favorites': 'Your favourites',
    'platePrompts.labels': 'Labels',
    'platePrompts.allLabels': 'All',
    'platePrompts.search': 'Search favourites',
    'platePrompts.noFavorites': 'No favourites yet. Mark a prompt with ★ Favourite — below, or on any plate you open — and give it a label.',
    'platePrompts.noMatch': 'No favourite matches.',
    'platePrompts.recent': 'Recent prompts',
    'platePrompts.recentHint': 'the latest 10, from everyone',
    'platePrompts.noRecent': 'No plates have been made from a prompt yet.',
    'platePrompts.use': 'Use',
    'platePrompts.favorite': 'Favourite',
    'platePrompts.favoriteHint': 'Keep this plate\'s prompt as a favourite, with a label',
    'platePrompts.isFavorite': 'A favourite: {{label}}. Click to change the label or remove it.',
    'platePrompts.addFavorite': 'Add to favourites',
    'platePrompts.addFavoriteTitle': 'Keep this prompt as a favourite',
    'platePrompts.editFavorite': 'Favourite prompt',
    'platePrompts.label': 'Label',
    'platePrompts.labelPlaceholder': 'A label, e.g. Rain, Politics, Cricket',
    'platePrompts.labelHint': 'Favourites are grouped by label. Pick one you have, or type a new one.',
    'platePrompts.saveLabel': 'Save',
    'platePrompts.relabel': 'Change the label',
    'platePrompts.remove': 'Remove from favourites',
    'platePrompts.removeConfirm': 'Remove "{{label}}" from your favourites?',
    'platePrompts.savedOn': 'Saved {{date}}',
    'platePrompts.more': 'Show all',
    'platePrompts.less': 'Show less',
    'platePrompts.references': 'Made with {{count}} reference picture(s)',
    'platePrompts.referencesHint': 'Attach similar pictures again for a similar result: they are not kept with the prompt.',
    'platePrompts.replaceConfirm': 'Replace the prompt you have written with this one?',
    'plateTemplates.createNamePlaceholder': 'e.g. Political war',
    'plateTemplates.remove': 'Remove',
    'plateTemplates.previewVideo': 'Preview with video',
    'plateTemplates.previewOn': 'Showing sample footage in the windows — click to turn off',
    'plateTemplates.previewOff': 'Show the plate with sample footage in its windows',
    'plateTemplates.previewBuilding': 'Putting sample footage into the plate… about a minute the first time.',
    'plateTemplates.previewFailed': 'The preview could not be made.',
    'plateTemplates.retry': 'Try again',
    'plateTemplates.footage': 'Sample footage (Wikimedia Commons):',
    'plateTemplates.removeConfirm': 'Remove this custom plate? This cannot be undone.',
    'plateTemplates.upload': 'Upload plates',
    'plateTemplates.uploadTitle': 'Upload your graphic plates',
    'plateTemplates.uploadHint': 'Upload the plate without the headline — the empty version, with its text panel blank. Each plate is animated (camera move, light sweep) and the scene\'s line is written into its panel in the story.',
    'plateTemplates.uploadRules': '16:9 pictures (e.g. 1920×1080 or 1600×900), JPG, PNG or WebP, up to 15 MB each. You can choose several at once.',
    'plateTemplates.uploadChoose': 'Choose pictures',
    'plateTemplates.uploadChosen': '{{count}} chosen',
    'plateTemplates.uploadCategory': 'Category',
    'plateTemplates.uploadGo': 'Upload',
    'plateTemplates.uploading': 'Uploading {{done}} of {{total}}…',
    'plateTemplates.uploadFailed': '"{{name}}": {{error}}',
    'plateTemplates.uploadedBadge': 'Uploaded',
    'plateTemplates.createdBadge': 'Created',
    'plateTemplates.uploadRemoveConfirm': 'Remove this uploaded plate? This cannot be undone.',
    'plateTemplates.edit': 'Edit',
    'plateTemplates.editTitle': 'Set up the plate',
    'plateTemplates.editHint': 'Drag the box onto the plate\'s empty text panel — the story\'s words go inside it. Drag a corner to resize.',
    'plateTemplates.editName': 'Name',
    'plateTemplates.editInk': 'Text colour',
    'plateTemplates.ink.auto': 'Automatic ({{ink}})',
    'plateTemplates.ink.dark': 'Dark',
    'plateTemplates.ink.light': 'White with outline',
    'plateTemplates.editMotion': 'Animation',
    'plateTemplates.motion.push': 'Slow push in and out',
    'plateTemplates.motion.drift': 'Gentle drift',
    'plateTemplates.motion.still': 'Almost still',
    'plateTemplates.editDust': 'Floating light dust',
    'plateTemplates.save': 'Save',
    'plateTemplates.saving': 'Saving…',
    'plateTemplates.previewWords': 'Preview with words',
    'plateTemplates.previewWordsOn': 'Showing sample words in the panel — click to turn off',
    'plateTemplates.previewWordsOff': 'Show the plate building in, with sample words in its panel',
    'plateTemplates.previewWordsBuilding': 'Writing sample words into the plate… a few seconds.',
    'plateTemplates.textArea': 'Text area',
    'plateTemplates.font': 'Font',
    'plateTemplates.viewPrompt': 'View prompt',
    'plateTemplates.writePrompt': 'Write prompt',
    'plateTemplates.writingPrompt': 'Writing prompt…',
    'plateTemplates.promptFailed': 'The prompt could not be written: {{error}}',
    'plateTemplates.changeWithPrompt': 'Change with prompt',
    'plateTemplates.threadTitle': 'Change this plate',
    'plateTemplates.threadHint': 'Write what to change — the rest stays as it is. Every change is a new version; click any version to show it again.',
    'plateTemplates.versionOriginal': 'Original',
    'plateTemplates.version': 'Version {{n}}',
    'plateTemplates.versionCurrent': 'Showing now',
    'plateTemplates.versionUse': 'Show this version again',
    'plateTemplates.changePlaceholder': 'e.g. Make the text panel bigger and move it lower; put the person from the attached photo on the left',
    'plateTemplates.changeSend': 'Send',
    'plateTemplates.references': 'Reference pictures',
    'plateTemplates.referenceAttach': 'Attach reference pictures (up to {{count}}) — e.g. a photo to put in, or a look to follow',
    'plateTemplates.referenceRemove': 'Remove this picture',
    'plateTemplates.referenceMax': 'Attach at most {{count}} reference pictures.',
    'plateTemplates.referenceType': 'Reference pictures must be JPG, PNG or WebP.',
    'plateTemplates.createReferences': 'Reference images (optional, up to {{count}})',
    'plateTemplates.createReferencesHint': '{{count}} of {{max}} — e.g. a photo of a person or place to put in, or a plate whose look to follow. The description is still required.',
    'plateTemplates.createReferencesUsed': 'Made with these reference images:',
    'plateTemplates.download.title': 'Download (16:9, 1920×1080)',
    'plateTemplates.download.background': 'Background image',
    'plateTemplates.download.image': 'Image',
    'plateTemplates.download.video': 'Video (MP4)',
    'plateTemplates.download.failed': 'The download could not be made. Try again.',
    'plateTemplates.download.making.video': 'Making the Full HD video…',
    'plateTemplates.download.making.images': 'Making images… {{done}} / {{total}}',
    'plateTemplates.download.making.videos': 'Making videos… {{done}} / {{total}}',
    'plateTemplates.pkg.open': 'Package',
    'plateTemplates.pkg.title': 'Graphic plate package',
    'plateTemplates.pkg.hint': 'One background, one or two text areas, up to {{count}} texts — one plate for each text. Download every plate as an image or a video.',
    'plateTemplates.pkg.saved': 'Saved',
    'plateTemplates.pkg.new': 'New package',
    'plateTemplates.pkg.view.preview': 'Preview',
    'plateTemplates.pkg.view.areas': 'Move text areas',
    'plateTemplates.pkg.previewHint': 'The selected text on the plate, exactly as the image downloads. Videos also build in, with the words coming in.',
    'plateTemplates.pkg.areasHint': 'Drag a box to move a text area, a corner to resize it. Leave some space around the words.',
    'plateTemplates.pkg.drawing': 'Drawing…',
    'plateTemplates.pkg.showing': 'Text {{n}}',
    'plateTemplates.pkg.area': 'Text area {{n}}',
    'plateTemplates.pkg.removeArea': 'Remove',
    'plateTemplates.pkg.addArea': 'Add a second text area',
    'plateTemplates.pkg.roleLabel': 'What this text area shows',
    'plateTemplates.pkg.role.changes': 'Changes on each plate',
    'plateTemplates.pkg.role.common': 'Same on every plate',
    'plateTemplates.pkg.roleHint.changes': 'Each text below gets its own plate with these words.',
    'plateTemplates.pkg.roleHint.common': 'Written once here, shown on every plate (e.g. a heading).',
    'plateTemplates.pkg.commonPlaceholder': 'The words on every plate',
    'plateTemplates.pkg.inkAuto': 'Automatic',
    'plateTemplates.pkg.texts': 'Texts',
    'plateTemplates.pkg.count': '{{count}} of {{max}}',
    'plateTemplates.pkg.paste': 'Paste a list',
    'plateTemplates.pkg.pasteHint': 'One text per line — each line becomes a plate (up to {{count}}).',
    'plateTemplates.pkg.pasteHintTwo': 'One plate per line; separate the two text areas with | (e.g. "first area | second area"). Up to {{count}}.',
    'plateTemplates.pkg.pasteGo': 'Add these',
    'plateTemplates.pkg.tooMany': 'A package has at most {{count}} texts — the rest were left out.',
    'plateTemplates.pkg.item': 'Text {{n}}',
    'plateTemplates.pkg.itemPlaceholder': 'Text {{n}} — press Enter for the next one',
    'plateTemplates.pkg.show': 'Show on the plate',
    'plateTemplates.pkg.oneImage': 'Download this plate as an image',
    'plateTemplates.pkg.oneVideo': 'Download this plate as a video',
    'plateTemplates.pkg.removeItem': 'Remove this text',
    'plateTemplates.pkg.addText': 'Add text',
    'plateTemplates.pkg.full': '{{count}} texts — the most a package holds',
    'plateTemplates.pkg.allCommon': 'Every text area is the same on every plate, so this package makes one plate. Set an area to "Changes on each plate" to make many.',
    'plateTemplates.pkg.name': 'Package name',
    'plateTemplates.pkg.namePlaceholder': 'e.g. Village festival — 12 plates',
    'plateTemplates.pkg.removeConfirm': 'Remove this saved package? The plate itself stays.',
    'plateTemplates.pkg.seconds': 'Video length',
    'plateTemplates.pkg.secondsValue': '{{seconds}} seconds',
    'plateTemplates.pkg.image': 'Download image',
    'plateTemplates.pkg.video': 'Download video',
    'plateTemplates.pkg.allImages': 'All {{count}} images (ZIP)',
    'plateTemplates.pkg.allVideos': 'All {{count}} videos (ZIP)',
    'plateTemplates.pkg.playingOf': 'Text {{n}} · {{at}} of {{count}}',
    'plateTemplates.pkg.playAgain': 'Play again',
    'plateTemplates.pkg.restart': 'From the start',
    'plateTemplates.pkg.gettingReady': 'Getting the plates ready…',
    'plateTemplates.pkg.previewAll': 'Preview all {{count}}',
    'plateTemplates.pkg.makingAll': 'Making the preview of all texts… {{done}} / {{total}}',
    'plateTemplates.pkg.oneVideoAll': 'All {{count}} as one video',
    'plateTemplates.download.making.combined': 'Making one video of all plates… {{done}} / {{total}}',
    'plateTemplates.download.making.previewAll': 'Making the preview of all texts… {{done}} / {{total}}',
    'plateTemplates.pkg.format': 'Images: JPG, 1920×1080. Videos: MP4, 1920×1080 (Full HD), 25 fps. Several plates download together as a ZIP. No AI credits are used.',
    'plateTemplates.download.making.preview': 'Making the video preview…',
    'plateTemplates.pkg.lineStyles': 'Each line\'s size and colours (start a new line with Shift+Enter)',
    'plateTemplates.pkg.sizeAuto': 'Auto size',
    'plateTemplates.pkg.sizeOld': '{{size}} (older size)',
    'plateTemplates.pkg.sizeHint': 'Font size in pixels on the 1920×1080 plate. Auto: as large as fits the text area.',
    'plateTemplates.pkg.wordColours': 'Word colours — click a word to give it its own colour',
    'plateTemplates.pkg.wordColoursEmpty': 'Write the text first; its words appear here.',
    'plateTemplates.pkg.wordColour': 'Colour of “{{word}}”',
    'plateTemplates.pkg.wordColourClear': 'Use the line\'s colour again',
    'plateTemplates.pkg.styles': 'Saved text styles',
    'plateTemplates.pkg.stylesPick': 'Use a saved text style…',
    'plateTemplates.pkg.stylesNone': 'No saved text styles yet',
    'plateTemplates.pkg.styleSave': 'Save style',
    'plateTemplates.pkg.styleSaveHint': 'Save this area\'s font, effect, sizes and colours to use again on any plate',
    'plateTemplates.pkg.styleName': 'Style name',
    'plateTemplates.pkg.styleUpdate': 'Update',
    'plateTemplates.pkg.styleRemoveConfirm': 'Remove the text style “{{name}}”? Plates already made keep their look.',
    'plateTemplates.pkg.line': 'Line {{n}}',
    'plateTemplates.pkg.lineColour': 'Colour of line {{n}}',
    'plateTemplates.pkg.lineSize': 'Size of line {{n}}',
    'plateTemplates.pkg.lineHint': 'More lines (up to 4) get their own colour and size here as you add them.',
    'plateTemplates.pkg.withText': 'With text',
    'plateTemplates.pkg.withoutText': 'Without text',
    'plateTemplates.pkg.backToPicture': 'Back to the picture',
    'plateTemplates.pkg.makingVideo': 'Making the video of text {{n}}… (a few seconds)',
    'plateTemplates.pkg.playVideo': 'Play its video (with the animation)',
    'plateTemplates.pkg.defaultAnim': 'Animation',
    'plateTemplates.pkg.animDefault': 'Animation: {{anim}} (same)',
    'plateTemplates.pkg.fontDefault': 'Font: {{font}} (same)',
    'plateTemplates.pkg.secondsDefault': 'Length: {{seconds}} s (same)',
    'plateTemplates.pkg.itemAnim': 'Animation of text {{n}}',
    'plateTemplates.pkg.itemFont': 'Font of text {{n}}',
    'plateTemplates.pkg.itemSeconds': 'Video length of text {{n}}',
    'plateTemplates.pkg.keysHint': 'Enter: next text · Shift+Enter: a new line in the same text',
    'plateTemplates.anim.wipe': 'Wipe in',
    'plateTemplates.anim.fade': 'Fade in',
    'plateTemplates.anim.rise': 'Rise up',
    'plateTemplates.anim.pop': 'Pop',
    'plateTemplates.anim.slide': 'Slide in',
    'plateTemplates.anim.none': 'No animation',
    'plateTemplates.colour.auto': 'Automatic',
    'plateTemplates.colour.white': 'White',
    'plateTemplates.colour.silver': 'Silver',
    'plateTemplates.colour.gold': 'Gold',
    'plateTemplates.colour.yellow': 'Yellow',
    'plateTemplates.colour.red': 'Red',
    'plateTemplates.colour.black': 'Black',
    'plateTemplates.colour.blue': 'Blue',
    'plateTemplates.colour.custom': 'Own colour',
    'plateTemplates.colour.none': 'None',
    'plateTemplates.colour.fill': 'Colour',
    'plateTemplates.colour.stroke': 'Stroke',
    'plateTemplates.colour.shadow': 'Shadow',
    'plateTemplates.colour.depth': '3D depth',
    'plateTemplates.shadow.title': 'Shadow (Photoshop-style drop shadow)',
    'plateTemplates.shadow.presets': 'Quick looks',
    'plateTemplates.shadow.auto': 'Auto',
    'plateTemplates.shadow.none': 'None',
    'plateTemplates.shadow.soft': 'Soft',
    'plateTemplates.shadow.hard': 'Hard edge',
    'plateTemplates.shadow.long': 'Long',
    'plateTemplates.shadow.glow': 'Glow',
    'plateTemplates.shadow.double': 'Double',
    'plateTemplates.shadow.n': 'Drop shadow {{n}}',
    'plateTemplates.shadow.add': 'Add a second shadow',
    'plateTemplates.shadow.remove': 'Remove this shadow',
    'plateTemplates.shadow.blend': 'Blend mode',
    'plateTemplates.shadow.colour': 'Colour',
    'plateTemplates.shadow.opacity': 'Opacity',
    'plateTemplates.shadow.angle': 'Angle',
    'plateTemplates.shadow.angleHint': 'Where the light comes from: 90° = above, so the shadow falls below. Click or drag the dial.',
    'plateTemplates.shadow.distance': 'Distance',
    'plateTemplates.shadow.spread': 'Spread',
    'plateTemplates.shadow.size': 'Size',
    'plateTemplates.shadow.noise': 'Noise',
    'plateTemplates.shadow.hint': 'Sizes are in pixels on the 1920×1080 plate. An outline (stroke) sits over the shadow; set it to None to see a thin shadow.',
    'plateTemplates.shadow.depth': '3D depth',
    'plateTemplates.shadow.depthSize': 'Depth',
    'plateTemplates.shadow.depthAuto': 'Auto',
    'plateTemplates.shadow.depthAngle': 'Light from',
    'plateTemplates.shadow.blend.normal': 'Normal',
    'plateTemplates.shadow.blend.multiply': 'Multiply',
    'plateTemplates.shadow.blend.screen': 'Screen',
    'plateTemplates.shadow.blend.overlay': 'Overlay',
    'plateTemplates.shadow.blend.darken': 'Darken',
    'plateTemplates.shadow.blend.lighten': 'Lighten',
    'plateTemplates.shadow.blend.color-burn': 'Color Burn',
    'plateTemplates.shadow.blend.color-dodge': 'Color Dodge',
    'plateTemplates.shadow.blend.hard-light': 'Hard Light',
    'plateTemplates.shadow.blend.soft-light': 'Soft Light',
    'plateTemplates.shadow.blend.difference': 'Difference',
    'plateTemplates.colour.looks': 'Ready looks',
    'plateTemplates.colour.used': 'Most used',
    'plateTemplates.colour.palette': 'Colours',
    'plateTemplates.colour.typeHint': '#FF8800 or 255, 136, 0',
    'plateTemplates.colour.gradient': 'Gradient (top → bottom)',
    'plateTemplates.colour.gradientTo': 'Bottom colour',
    'plateTemplates.blur.title': 'Blur areas',
    'plateTemplates.blur.hint': 'Blur part of the plate — a face, a logo, a busy corner. Pick a shape, then move and resize it on the plate.',
    'plateTemplates.blur.plateHint': 'These blur areas are part of the plate: they show wherever it is used (stories, packages, downloads).',
    'plateTemplates.blur.add': 'Add a {{shape}} blur',
    'plateTemplates.blur.label': 'Blur {{n}}',
    'plateTemplates.blur.remove': 'Remove this blur area',
    'plateTemplates.blur.shapeLabel': 'Shape',
    'plateTemplates.blur.strengthLabel': 'Strength',
    'plateTemplates.blur.edgeLabel': 'Edge',
    'plateTemplates.blur.shape.rect': 'Rectangle',
    'plateTemplates.blur.shape.rounded': 'Rounded',
    'plateTemplates.blur.shape.square': 'Square',
    'plateTemplates.blur.shape.ellipse': 'Ellipse',
    'plateTemplates.blur.shape.circle': 'Circle',
    'plateTemplates.blur.strength.light': 'Light blur',
    'plateTemplates.blur.strength.medium': 'Medium blur',
    'plateTemplates.blur.strength.strong': 'Strong blur',
    'plateTemplates.blur.strength.pixelate': 'Pixelate',
    'plateTemplates.blur.edge.sharp': 'Sharp edge',
    'plateTemplates.blur.edge.soft': 'Soft edge',
    'plateTemplates.blur.edge.softer': 'Very soft edge',
    'plateTemplates.setupView.areas': 'Text & blur areas',
    'plateTemplates.setupView.preview': 'Preview',
    'plateTemplates.search': 'Search by name, tag, maker or category',
    'plateTemplates.dates.label': 'When changed',
    'plateTemplates.dates.any': 'Any time',
    'plateTemplates.dates.today': 'Today',
    'plateTemplates.dates.7': 'Last 7 days',
    'plateTemplates.dates.30': 'Last 30 days',
    'plateTemplates.dates.custom': 'Between dates…',
    'plateTemplates.dates.from': 'From',
    'plateTemplates.dates.to': 'To',
    'plateTemplates.clearFilters': 'Clear',
    'plateTemplates.found': '{{count}} found',
    'plateTemplates.noMatch': 'No plates match. Try other words, or clear the filters.',
    'plateTemplates.showMore': 'Show more ({{count}})',
    'plateTemplates.card.created': 'Created {{at}}',
    'plateTemplates.card.modified': 'Modified {{at}}',
    'plateTemplates.card.builtIn': 'Built-in plate',
    'plateTemplates.tags.add': 'Add tags',
    'plateTemplates.tags.placeholder': 'Add tags, comma-separated',
    'plateTemplates.tags.remove': 'Remove the tag {{tag}}',
    'plateTemplates.createTags': 'Tags',
    'plateTemplates.optional': '(optional)',
    'plateTemplates.createTagsHint': 'Words that help find this plate later in the search — e.g. elections, AP, rally. Separate them with commas.',
    'plateTemplates.changeWorking': 'Making the change… about a minute',
    'plateTemplates.changeFailed': 'The change could not be made.',
    'plateTemplates.changeDone': 'Version {{n}} — now showing',
    'plateTemplates.changeCost': 'Each change uses one AI picture (about $0.05). Ctrl+Enter sends.',
    'plateTemplates.promptTitle': 'The prompt behind this plate',
    'plateTemplates.promptHint': 'Paste it into an image generator (16:9, high quality) to make a plate like this. The panel and label come out blank — the words go in afterwards.',
    'plateTemplates.promptAvoid': 'Keep out:',
    'plateTemplates.promptParts': 'What makes it work',
    'plateTemplates.promptTips': 'Tips',
    'plateTemplates.copyPrompt': 'Copy prompt',
    'plateTemplates.copy': 'Copy',
    'plateTemplates.copied': 'Copied',
    'plateTemplates.createdEmpty': 'Plates you make with "Create graphic plate" appear here.',
    'plateTemplates.textStyle': 'Text style',
    'plateTemplates.effect.flat': 'Flat',
    'plateTemplates.effect.3d': '3D',
    'fullStoryVideo.noStories': 'No packages yet. Start one and upload your footage.',
    'fullStoryVideo.step.script': 'Material & script',
    'fullStoryVideo.step.voice': 'Voice-over',
    'fullStoryVideo.step.images': 'Scenes',
    'fullStoryVideo.step.video': 'Video',
    'fullStoryVideo.stepHint.script': 'Upload footage, then let AI write the package or paste your own script.',
    'fullStoryVideo.stepHint.voice': 'Anchor and voice parts, voiced sentence by sentence.',
    'fullStoryVideo.stepHint.images': 'Footage matched to every line, plus spots, bites and text plates.',
    'fullStoryVideo.stepHint.video': 'The finished package with header, location and tops on screen.',
    'fullStoryVideo.footage.title': 'Footage',
    'fullStoryVideo.footage.hint': 'Raw videos up to 5 GB (about 3 hours) each — MP4, MOV, AVI, MXF, MKV, MTS, WMV and other video formats — and photos. Each video is transcribed and read shot by shot.',
    'fullStoryVideo.notVideo': '"{{name}}" is not a video file. Use MP4, MOV, AVI, MXF, MKV, MTS, WMV or another video format.',
    'fullStoryVideo.footage.uploadVideos': 'Upload videos',
    'fullStoryVideo.footage.addPhotos': 'Add photos',
    'fullStoryVideo.footage.none': 'No footage yet.',
    'fullStoryVideo.footage.photo': 'Photo',
    'fullStoryVideo.footage.ready': 'Ready',
    'fullStoryVideo.footage.read': '{{moments}} moments · {{lines}} spoken lines',
    'fullStoryVideo.footage.incomplete': 'Upload did not finish — remove it and upload again.',
    'fullStoryVideo.footage.removeConfirm': 'Remove "{{name}}" from this package?',
    'fullStoryVideo.footage.uploadingHint': 'Keep this page open until the uploads finish.',
    'fullStoryVideo.notes.title': 'Notes for the script',
    'fullStoryVideo.notes.placeholder': 'What is the story? Names, places, facts, the angle you want — the AI uses this with what is said in the footage.',
    'fullStoryVideo.length': 'Length',
    'fullStoryVideo.minutes': 'minutes',
    'fullStoryVideo.minutesRange': 'Between 1 and 30 minutes.',
    'fullStoryVideo.tooBig': '"{{name}}" is too big — videos can be up to 5 GB.',
    'fullStoryVideo.uploadFailed': 'Upload failed. Check your connection and try again.',
    'fullStoryVideo.script.title': 'Script',
    'fullStoryVideo.script.hint': 'Write it with AI from your notes and footage, or paste a finished script (Sk, tops, location, header, Anchor, Voice, gfx, ...spot...) — it is used as written.',
    'fullStoryVideo.script.placeholder': 'Paste the package script here, or press "Write with AI".',
    'fullStoryVideo.script.write': 'Write with AI',
    'fullStoryVideo.script.rewrite': 'Rewrite with AI',
    'fullStoryVideo.script.waitFootage': 'Wait for the footage to be read so the AI can use it.',
    'fullStoryVideo.script.approve': 'Approve script',
    'fullStoryVideo.script.approveHint': 'Only Anchor and Voice parts are voiced; spots, bites and gfx come from the footage.',
    'fullStoryVideo.script.approved': 'Script approved',
    'fullStoryVideo.preview.title': 'How the package reads',
    'fullStoryVideo.preview.empty': 'Paste or write a script to see the package.',
    'fullStoryVideo.preview.header': 'Header',
    'fullStoryVideo.preview.location': 'Location',
    'fullStoryVideo.preview.tops': '{{count}} tops',
    'fullStoryVideo.preview.sentences': '{{count}} sentences to voice',
    'fullStoryVideo.block.anchor': 'Anchor',
    'fullStoryVideo.block.voice': 'Voice-over',
    'fullStoryVideo.block.spot': 'Spot',
    'fullStoryVideo.block.byte': 'Bite',
    'fullStoryVideo.block.gfx': 'Graphics',
    'fullStoryVideo.stage.waiting': 'Waiting',
    'fullStoryVideo.stage.checking': 'Checking',
    'fullStoryVideo.stage.preparing': 'Preparing',
    'fullStoryVideo.stage.converting': 'Converting',
    'fullStoryVideo.stage.transcribing': 'Transcribing',
    'fullStoryVideo.stage.finding shots': 'Finding shots',
    'fullStoryVideo.stage.describing': 'Reading the shots',
    'fullStoryVideo.stage.indexing': 'Indexing',
    'fullStoryVideo.scenes.title': 'Scenes',
    'fullStoryVideo.scenes.hint': 'Each voice-over line gets the best matching footage; spots and bites play the footage with its own sound; gfx lines become text plates.',
    'fullStoryVideo.scenes.instructions': 'Anything the planner should know? (optional) e.g. "use the hospital corridor shots for the opening"',
    'fullStoryVideo.scenes.plan': 'Match footage',
    'fullStoryVideo.scenes.replan': 'Match again',
    'fullStoryVideo.scenes.replanConfirm': 'Match all scenes again? Your changes to scenes will be replaced.',
    'fullStoryVideo.scenes.planning': 'Matching footage…',
    'fullStoryVideo.scenes.waitFootage': 'Wait until all footage is read.',
    'fullStoryVideo.scenes.runningTime': 'Running time {{time}} · {{count}} scenes',
    'fullStoryVideo.scenes.missing': '{{count}} scenes still need footage or a picture.',
    'fullStoryVideo.scenes.allReady': 'Every scene is ready.',
    'fullStoryVideo.scenes.approve': 'Approve scenes',
    'fullStoryVideo.scene.chooseFootage': 'Choose footage',
    'fullStoryVideo.scene.aiPicture': 'AI picture',
    'fullStoryVideo.scene.webPhoto': 'Web photo',
    'fullStoryVideo.scene.upload': 'Upload',
    'fullStoryVideo.scene.editPlate': 'Edit text',
    'fullStoryVideo.scene.removeConfirm': 'Remove this scene from the package?',
    'fullStoryVideo.scene.fromFootage': '{{name}} at {{at}}',
    'fullStoryVideo.scene.fromRange': '{{name}} {{from}}–{{to}}',
    'fullStoryVideo.scene.source.ai': 'AI picture',
    'fullStoryVideo.scene.source.web': 'Web photo',
    'fullStoryVideo.scene.source.upload': 'Your upload',
    'fullStoryVideo.scene.source.stock': 'Stock',
    'fullStoryVideo.scene.source.gfx': 'Text plate',
    'fullStoryVideo.scene.source.footage': 'Footage',
    'fullStoryVideo.scene.briefPlaceholder': 'Describe the picture you want.',
    'fullStoryVideo.scene.makePicture': 'Make picture',
    'fullStoryVideo.scene.searchPlaceholder': 'Search the web for a photo',
    'fullStoryVideo.scene.search': 'Search',
    'fullStoryVideo.scene.seconds': 'Seconds',
    'fullStoryVideo.scene.platePhoto': 'Plate photo from footage',
    'fullStoryVideo.scene.platePhotoUpload': 'Upload plate photo',
    'fullStoryVideo.look.title': 'Look & music',
    'fullStoryVideo.look.hint': 'Footage plays full screen; the breaking plates all use one design; music plays under each part and comes up on the plates — change it per scene below.',
    'fullStoryVideo.look.editText': 'Plate kicker',
    'fullStoryVideo.look.autoMusic': 'Background music',
    'fullStoryVideo.look.musicVolume': 'Music level',
    'fullStoryVideo.look.kicker': 'Plate kicker',
    'fullStoryVideo.look.plateDesign': 'Breaking plate design',
    'fullStoryVideo.look.plateAuto': 'Picked automatically for this story — every plate in the video uses it.',
    'fullStoryVideo.look.plateChosen': 'Your choice — every plate in the video uses it.',
    'fullStoryVideo.look.plateChange': 'Change design',
    'fullStoryVideo.look.plateHint': 'One design for all the plates in this video.',
    'fullStoryVideo.look.plateAutoUse': 'Pick automatically',
    'fullStoryVideo.look.cancel': 'Cancel',
    'fullStoryVideo.music.none': 'No music',
    'fullStoryVideo.music.custom': 'Your uploaded track',
    'fullStoryVideo.music.listen': 'Listen',
    'fullStoryVideo.music.forPart': 'Music for this whole part',
    'fullStoryVideo.music.ownSound': 'Own sound (no music)',
    'fullStoryVideo.frame.title': 'Overlay frame',
    'fullStoryVideo.frame.add': 'Frame',
    'fullStoryVideo.frame.change': 'Change frame',
    'fullStoryVideo.frame.remove': 'Remove frame',
    'fullStoryVideo.frame.use': 'Use this frame',
    'fullStoryVideo.frame.opacity': 'Opacity',
    'fullStoryVideo.frame.search': 'Search frames (fire, Diwali, police…)',
    'fullStoryVideo.frame.preparing': 'Preparing the preview…',
    'fullStoryVideo.frame.category.festival': 'Festivals',
    'fullStoryVideo.frame.category.celebration': 'Celebrations',
    'fullStoryVideo.frame.category.fire': 'Fire & danger',
    'fullStoryVideo.frame.category.film': 'Film & texture',
    'fullStoryVideo.frame.category.alert': 'Alerts',
    'fullStoryVideo.frame.category.emotion': 'Emotion & tribute',
    'fullStoryVideo.frame.category.nature': 'Weather & nature',
    'fullStoryVideo.frame.category.tech': 'Technology & money',
    'fullStoryVideo.picker.title': 'Choose the footage for this line',
    'fullStoryVideo.picker.titleRange': 'Choose where the spot starts and ends',
    'fullStoryVideo.picker.noFootage': 'No footage is ready yet.',
    'fullStoryVideo.picker.noSoundFootage': 'No video with sound is ready yet.',
    'fullStoryVideo.picker.start': 'Start (s)',
    'fullStoryVideo.picker.end': 'End (s)',
    'fullStoryVideo.picker.useNowStart': 'Start here',
    'fullStoryVideo.picker.useNowEnd': 'End here',
    'fullStoryVideo.picker.length': '{{seconds}} s',
    'fullStoryVideo.picker.play': 'Play',
    'fullStoryVideo.picker.use': 'Use this',
    'fullStoryVideo.picker.search': 'Search moments (what is seen or said)',
    'features.noAccessTitle': '{{feature}} is not enabled for your account',
    'features.noAccessDesc': 'Ask your administrator or manager to turn it on in User Management.',
    'mediaAI.title': 'Media AI',
    'mediaAI.desc': 'Describe an image or video, or attach photos and videos to work from',
    'mediaAI.newChat': 'New chat',
    'mediaAI.chats': 'Chats',
    'mediaAI.loadingChats': 'Loading chats…',
    'mediaAI.noChats': 'No chats yet. Start one below.',
    'mediaAI.emptyTitle': 'What should I create?',
    'mediaAI.emptyDesc': 'Describe the image or video you need — in Telugu, English, or any language. Attach photos or videos to edit, combine, animate, or use as a reference.',
    'mediaAI.inputPlaceholder': 'Describe the image or video you want…',
    'mediaAI.send': 'Send',
    'mediaAI.waitForResult': 'Wait for the current request to finish',
    'mediaAI.attach': 'Attach images or videos',
    'mediaAI.removeFile': 'Remove',
    'mediaAI.dropHere': 'Drop images or videos to attach them',
    'mediaAI.creating': 'Creating…',
    'mediaAI.creatingHint': 'Images take about a minute, videos 5 to 20 minutes depending on length',
    'mediaAI.failed': 'Generation failed. Please try again.',
    'mediaAI.generatedAlt': 'Generated image',
    'mediaAI.download': 'Download',
    'mediaAI.disclaimer': 'Images and videos are AI-generated — check them before publishing.',
    'mediaAI.deleteConfirm': 'Delete this chat and everything created in it? This cannot be undone.',
    'mediaAI.deleteChat': 'Delete chat',
    'mediaAI.deleteFailed': 'Could not delete this chat.',
    'mediaAI.loadFailed': 'Could not load this chat.',
    'mediaAI.myChats': 'My Chats',
    'mediaAI.team': 'Team',
    'mediaAI.searchUser': 'Search by user name…',
    'mediaAI.noTeamChats': 'No chats found.',
    'mediaAI.viewingAs': 'Viewing',
    'mediaAI.readOnly': 'read-only',
    'mediaAI.unsupportedFile': '"{{name}}" is not a supported image or video.',
    'mediaAI.fileTooLarge': '"{{name}}" is larger than 200 MB.',
    'mediaAI.tooManyFiles': 'You can attach up to {{max}} files per message.',
    'mediaAI.noAccessTitle': 'Media AI is not enabled for your account',
    'mediaAI.noAccessDesc': 'Ask your administrator to turn it on in User Management.',
    'header.mediaAIProviders': 'Media AI Providers',
    'mediaAI.imagesBy': 'Images by',
    'mediaAI.madeWith': 'Made with {{provider}}',
    'mediaAI.downloadVideo': 'Download video',
    'mediaAI.tryAgain': 'Try again',
    'mediaAI.shape': 'Shape',
    'mediaAI.edit': 'Edit',
    'mediaAI.useInChat': 'Use in next request',
    'mediaAI.referenceAdded': 'Picture added to your next request',
    'mediaAI.fromWeb': 'Found on the web — check the source and usage rights before publishing.',
    'mediaAI.viewSource': 'Source',
    'mediaAI.editor.title': 'Edit image',
    'mediaAI.editor.adjust': 'Adjust',
    'mediaAI.editor.resize': 'Resize',
    'mediaAI.editor.blur': 'Blur',
    'mediaAI.editor.removeBg': 'Remove background',
    'mediaAI.editor.removeObject': 'Remove object',
    'mediaAI.editor.brightness': 'Brightness',
    'mediaAI.editor.contrast': 'Contrast',
    'mediaAI.editor.saturation': 'Saturation',
    'mediaAI.editor.sharpness': 'Sharpness',
    'mediaAI.editor.reset': 'Reset',
    'mediaAI.editor.crop': 'Crop',
    'mediaAI.editor.extend': 'Extend with AI',
    'mediaAI.editor.custom': 'Custom',
    'mediaAI.editor.width': 'Width',
    'mediaAI.editor.height': 'Height',
    'mediaAI.editor.cropDragHint': 'Drag the frame to choose what to keep.',
    'mediaAI.editor.extendHint': 'AI paints the extra space around the picture; the original stays untouched.',
    'mediaAI.editor.blurAll': 'Whole picture',
    'mediaAI.editor.blurSelection': 'Painted area',
    'mediaAI.editor.blurBackground': 'Background (AI)',
    'mediaAI.editor.amount': 'Amount',
    'mediaAI.editor.paintHint': 'Paint over the area with your mouse or finger.',
    'mediaAI.editor.brushSize': 'Brush size',
    'mediaAI.editor.undo': 'Undo',
    'mediaAI.editor.clear': 'Clear',
    'mediaAI.editor.removeBgHint': 'AI cuts out the main subject and makes the background transparent (PNG).',
    'mediaAI.editor.objectDescription': 'What is it? (optional — e.g. "the man on the left")',
    'mediaAI.editor.aiNote': 'Uses AI — takes about a minute.',
    'mediaAI.editor.apply': 'Apply',
    'mediaAI.editor.applying': 'Applying…',
    'mediaAI.editor.paintFirst': 'Paint over the area first.',
    'mediaAI.editor.failed': 'Could not apply the edit.',
    'mediaProviders.title': 'Media AI Providers',
    'mediaProviders.subtitle': 'Credentials for the services that create images and videos in Media AI',
    'mediaProviders.openaiUse': 'Images, and understanding each request',
    'mediaProviders.openaiNote': 'Uses the OpenAI key already set up for the app. Nothing to enter here.',
    'mediaProviders.freepikUse': 'Images and videos',
    'mediaProviders.connected': 'Connected',
    'mediaProviders.notConnected': 'Not connected',
    'mediaProviders.loading': 'Loading…',
    'mediaProviders.storedKey': 'Stored key:',
    'mediaProviders.updatedBy': 'saved by {{name}}',
    'mediaProviders.apiKey': 'API key',
    'mediaProviders.apiKeyPlaceholder': 'Paste the Freepik API key',
    'mediaProviders.keepBlank': 'Leave blank to keep the stored value',
    'mediaProviders.webhookSecret': 'Webhook signing secret',
    'mediaProviders.optional': '(optional)',
    'mediaProviders.webhookHint': 'Stored for later use. Media AI currently checks Freepik for results itself, so it works without webhooks.',
    'mediaProviders.save': 'Save',
    'mediaProviders.checking': 'Checking key…',
    'mediaProviders.saved': 'Freepik credentials saved',
    'mediaAI.videoModel': 'Video',
    'mediaAI.stop': 'Stop',
    'mediaAI.stopped': 'You stopped this request.',
    'mediaAI.stopFailed': 'Could not stop the request. Please try again.',
    'mediaAI.copy': 'Copy',
    'mediaAI.copied': 'Copied',
    'mediaAI.editMessage': 'Edit message',
    'mediaAI.cancel': 'Cancel',
    'mediaAI.previousVersion': 'Previous version',
    'mediaAI.nextVersion': 'Next version',
    'mediaAI.games.title': 'Play while you wait',
    'mediaAI.games.best': 'best',
    'mediaAI.games.aria': '{{game}} game — click, then play with the keyboard or mouse',
    'mediaAI.games.playing': 'Playing — the keys control the game. Click the message box to type again.',
    'mediaAI.games.clickToPlay': 'Click the game to play with the keyboard, or just use the mouse.',
    'mediaAI.games.hide': 'Hide game',
    'mediaAI.games.show': 'Play a game',
    'mediaProviders.videoTitle': 'Video',
    'mediaProviders.videoDesc': 'Add a key for each video provider you want to use. Every model with a key appears in the Video dropdown in Media AI. Prices are the providers\' own list prices.',
    'mediaProviders.videoBudget': 'Daily video budget',
    'mediaProviders.videoBudgetDesc': 'The most the whole team can spend on video per day. A video that would go over it is not made.',
    'mediaProviders.spentToday': '${{spent}} spent today',
    'mediaProviders.dailyLimit': 'Daily limit',
    'mediaProviders.budgetSaved': 'Daily video budget saved',
    'mediaProviders.keySaved': 'Key saved',
    'mediaProviders.model': 'Model',
    'mediaProviders.usingServerKey': 'Using the server\'s Gemini key (GEMINI_API_KEY). Add a key here to use a different one.',
    'mediaProviders.replaceKey': 'Paste a new key to replace the stored one',
    'mediaProviders.whereToGet': 'Get it from {{where}}.',
    'mediaProviders.alibabaHost': 'Model Studio address',
    'mediaProviders.alibabaHostHint': 'Leave empty for the international (Singapore) address. Workspaces with their own address show it in Model Studio.',
    'mediaProviders.removeVideoConfirm': 'Remove the {{provider}} key? Its models disappear from Media AI.',
    'mediaProviders.saving': 'Saving…',
    'mediaProviders.saveFailed': 'Could not save the credentials',
    'mediaProviders.remove': 'Remove credentials',
    'mediaProviders.removeConfirm': 'Remove the Freepik credentials? Video generation and Freepik images will stop working until a key is added again.',
    'mediaProviders.removed': 'Freepik credentials removed',
    'mediaProviders.restrictedTitle': 'Access Restricted',
    'mediaProviders.restrictedDesc': 'Media AI provider settings are available to admins only.',
    'anchorFormats.tab.visual': 'Anchor Visual',
    'anchorFormats.tab.visualByte': 'Anchor Visual Byte',
    'anchorFormats.tab.byte': 'Anchor Byte',
    'anchorFormats.tab.package': 'Anchor Package',
    'anchorFormats.tab.live': 'Anchor Live',
    'anchorFormats.tab.toReporter': 'Anchor to Reporter',
    'anchorFormats.tab.toGuest': 'Anchor to Guest',
    'anchorFormats.tab.drive': 'Anchor Drive',
    'anchorFormats.generatedScript': 'Generated Script',
    'anchorFormats.aiWriting': 'AI is writing your script…',
    'anchorFormats.carriedOver': 'Input carried over from previous tab',
    // AV Newsroom Controls
    'avControls.label': 'Newsroom Controls',
    'avControls.storyEnhancement': 'Story Enhancement',
    'avControls.dramaticIntensity': 'Dramatic Intensity',
    'avControls.honorifics': 'Honorifics',
    'avControls.fullNames': 'Full Names',
    'avControls.low': 'Low',
    'avControls.medium': 'Medium',
    'avControls.high': 'High',
    // IP Whitelist Settings
    'ipWhitelist.title': 'IP Whitelist',
    'ipWhitelist.subtitle': 'Restrict system access by IP address. Admins are always exempt.',
    'ipWhitelist.adminNotAffected': 'Admins can always access from any IP address regardless of this setting.',
    'ipWhitelist.enableToggle': 'Enable IP Whitelist',
    'ipWhitelist.enabledDesc': 'Only users with listed IP addresses can access the system.',
    'ipWhitelist.disabledDesc': 'All IP addresses are allowed (default). No restrictions in place.',
    'ipWhitelist.warningEmpty': 'Warning: with no IP addresses listed, enabling this will block ALL non-admin users immediately.',
    'ipWhitelist.warningEmptyShort': 'Add at least one IP before saving.',
    'ipWhitelist.yourIp': 'Your Current IP Address',
    'ipWhitelist.loopbackHint': 'The server sees a loopback address (127.0.0.1), which means your reverse proxy is not forwarding the real client IP. Ask your server admin to add "proxy_set_header X-Real-IP $remote_addr;" to the nginx config, then reload. Until then, enter your IP manually in the form below.',
    'ipWhitelist.addMyIp': '+ Add My IP',
    'ipWhitelist.myIpLabel': 'Admin',
    'ipWhitelist.alreadyAdded': 'Already in list',
    'ipWhitelist.addIp': 'Add IP',
    'ipWhitelist.ipAddress': 'IP Address',
    'ipWhitelist.labelCol': 'Label',
    'ipWhitelist.ipPlaceholder': 'e.g. 203.0.113.45',
    'ipWhitelist.labelPlaceholder': 'e.g. Office, Home, Editor 1',
    'ipWhitelist.ipRequired': 'IP address is required.',
    'ipWhitelist.ipInvalid': 'Enter a valid IP address.',
    'ipWhitelist.allowedIps': 'Allowed IP Addresses',
    'ipWhitelist.noIps': 'No IP addresses added yet.',
    'ipWhitelist.addedOn': 'Added On',
    'ipWhitelist.remove': 'Remove',
    'ipWhitelist.saveChanges': 'Save Changes',
    'ipWhitelist.saving': 'Saving…',
    'ipWhitelist.saved': 'IP whitelist settings saved.',
    'settings.adminOnly': 'This page is restricted to administrators.',
    // Settings — Automation Sources
    'settings.automationSources': 'Automation Sources',
    'settings.automationSourcesSubtitle': 'Configure input sources (e.g. WhatsApp) and output destinations (e.g. YouTube) available in the Automation → Pipeline tab.',
    'automationSources.input': 'Input Sources',
    'automationSources.output': 'Output Destinations',
    'automationSources.otherSources': 'Other Sources',
    'automationSources.addCustomSource': '+ Add a custom source',
    'automationSources.addSource': 'Add Source',
    'automationSources.namePlaceholder': 'e.g. WhatsApp',
    'automationSources.keyPlaceholder': 'e.g. whatsapp',
    'automationSources.enabled': 'Enabled',
    'automationSources.noSources': 'No sources configured yet.',
    'automationSources.deleteConfirm': 'Remove this source? Pipeline items already using it are unaffected.',
    'automationSources.added': 'Source added.',
    'automationSources.deleted': 'Source removed.',
    'automationSources.connected': 'Connected',
    'automationSources.notConnected': 'Not Connected',
    'automationSources.inputs.title': 'WhatsApp Sources',
    'automationSources.inputs.subtitle': 'Groups and contacts monitored for incoming content — matches are pulled into the Pipeline automatically.',
    'automationSources.inputs.empty': 'No groups or contacts added yet — add one below.',
    'automationSources.inputs.colType': 'Type',
    'automationSources.inputs.colName': 'Name',
    'automationSources.outputs.title': 'Publish Destinations',
    'automationSources.outputs.subtitle': 'YouTube channels available to publish to from the Pipeline.',
    'automationSources.outputs.colChannel': 'Channel',
    'automationSources.outputs.colStatus': 'Status',
    'automationSources.whatsapp.title': 'WhatsApp',
    'automationSources.whatsapp.subtitle': 'Connect a WhatsApp account to pull messages from selected contacts and groups into the Pipeline.',
    'automationSources.whatsapp.connect': 'Connect WhatsApp',
    'automationSources.whatsapp.connecting': 'Connecting…',
    'automationSources.whatsapp.initializing': 'Starting WhatsApp session…',
    'automationSources.whatsapp.stalledHint': "This is taking longer than expected. It's safe to check again.",
    'automationSources.whatsapp.checkAgain': 'Check Again',
    'automationSources.whatsapp.scanHint': 'Open WhatsApp on your phone → Linked Devices → Link a Device, then scan this code.',
    'automationSources.whatsapp.disconnect': 'Disconnect',
    'automationSources.whatsapp.syncNow': 'Sync Now',
    'automationSources.whatsapp.syncing': 'Syncing…',
    'automationSources.whatsapp.syncDone': 'Sync complete — any missed messages have been pulled in.',
    'automationSources.whatsapp.monitoredChats': 'Monitored Chats',
    'automationSources.whatsapp.loadChats': 'Load Chats',
    'automationSources.whatsapp.allowListHint': 'Only messages from the contacts/groups added below are pulled into the Pipeline table — nothing else is imported.',
    'automationSources.whatsapp.groups': 'Groups',
    'automationSources.whatsapp.contacts': 'Contacts',
    'automationSources.whatsapp.groupNamePlaceholder': 'Exact WhatsApp group name',
    'automationSources.whatsapp.labelPlaceholder': 'Label (optional)',
    'automationSources.whatsapp.groupNameHint': 'Must match the group name exactly as it appears in WhatsApp (case-insensitive).',
    'automationSources.whatsapp.contactNumberPlaceholder': 'Phone number with country code, e.g. 919876543210',
    'automationSources.whatsapp.contactNumberHint': 'Include the country code, digits only (no + or spaces needed).',
    'automationSources.whatsapp.alreadyAdded': 'Already on the list.',
    'automationSources.whatsapp.invalidNumber': 'Enter a valid phone number with country code.',
    'automationSources.whatsapp.noChats': 'No chats found.',
    'automationSources.whatsapp.saveMonitored': 'Save Monitored List',
    'automationSources.whatsapp.monitoredSaved': 'Monitored list saved.',
    'automationSources.whatsapp.status.disconnected': 'Disconnected',
    'automationSources.whatsapp.status.initializing': 'Starting…',
    'automationSources.whatsapp.status.qr_pending': 'Scan QR Code',
    'automationSources.whatsapp.status.connected': 'Connected',
    'automationSources.youtube.title': 'YouTube',
    'automationSources.youtube.subtitle': 'Add a YouTube account (Google OAuth app credentials) once, then connect its channels one at a time below — Google requires a separate authorization per channel, even from the same login, but you never re-enter the credentials.',
    'automationSources.youtube.multiChannelHint': 'Have more than one channel on this login? Click "Connect a Channel" again after each one — Google will let you pick a different channel each time, without asking for these credentials again.',
    'automationSources.youtube.redirectUriLabel': 'Authorized redirect URI',
    'automationSources.youtube.redirectUriHint': 'Add this exact URI to your OAuth Client\'s "Authorized redirect URIs" in Google Cloud Console.',
    'automationSources.youtube.clientIdPlaceholder': 'Client ID',
    'automationSources.youtube.clientSecretPlaceholder': 'Client Secret',
    'automationSources.youtube.clientSecretStoredPlaceholder': 'Leave blank to keep the current secret',
    'automationSources.youtube.redirectUriPlaceholder': 'https://yourdomain.com/api/automation/sources/youtube/oauth/callback',
    'automationSources.youtube.suggestedUri': 'Suggested:',
    'automationSources.youtube.useSuggested': 'Use this',
    'automationSources.youtube.connecting': 'Redirecting…',
    'automationSources.youtube.disconnect': 'Disconnect',
    'automationSources.youtube.connectedToast': 'YouTube channel connected.',
    'automationSources.youtube.connectedToastNamed': 'Connected: "{{channel}}" — check this is the right channel before using it to publish.',
    'automationSources.youtube.connectFailed': 'YouTube connection failed.',
    'automationSources.youtube.defaultPrivacyLabel': 'Default privacy for published videos',
    'automationSources.youtube.defaultPrivacyHint': 'Applied automatically when you publish — you\'ll still see and can change it per-video on the Publish screen.',
    'automationSources.youtube.defaultPrivacySaved': 'Default privacy status updated.',
    'automationSources.youtube.accountsTitle': 'YouTube Accounts',
    'automationSources.youtube.noAccountsYet': 'No YouTube accounts yet. Add one to connect a channel.',
    'automationSources.youtube.addAccount': 'Add YouTube Account',
    'automationSources.youtube.accountNamePlaceholder': 'Account name (e.g. Studio A)',
    'automationSources.youtube.accountSaved': 'Account saved.',
    'automationSources.youtube.deleteAccountConfirm': 'Delete this account? Only possible once it has no connected channels.',
    'automationSources.youtube.accountDeleted': 'Account removed.',
    'automationSources.youtube.channelsInAccount': 'Channels',
    'automationSources.youtube.noChannelsYet': 'No channels connected yet.',
    'automationSources.youtube.connectChannel': 'Connect a Channel',
    'automationSources.youtube.colAccount': 'Account',
    'youtube.privacyPublic': 'Public',
    'youtube.privacyUnlisted': 'Unlisted',
    'youtube.privacyPrivate': 'Private',
    // Automation Sources — Default Destination Mappings
    'automationSources.mappings.title': 'Default Destination Mappings',
    'automationSources.mappings.subtitle': 'Set a default publish destination per WhatsApp group or contact — pre-fills automatically, still changeable per item when publishing.',
    'automationSources.mappings.searchPlaceholder': 'Search groups/contacts…',
    'automationSources.mappings.destinationPlaceholder': 'Select destination…',
    'automationSources.mappings.saved': 'Default destination saved.',
    'automationSources.mappings.emptyNoInputs': 'Add a WhatsApp group or contact above before setting default destinations.',
    'automationSources.mappings.emptyNoOutputs': 'Connect a YouTube channel above before setting default destinations.',
    // Automation — Pipeline page
    'automation.title': 'Automation',
    'automation.desc': 'Pull incoming content from connected sources and publish it out to your platforms',
    'automation.tab.pipeline': 'Pipeline',
    'automation.configureSources': 'Configure Sources',
    'pipeline.filterStatus': 'Status',
    'pipeline.filterAllStatus': 'All Status',
    'pipeline.filterSource': 'Source',
    'pipeline.filterAllSources': 'All Sources',
    'pipeline.filterGroup': 'Group',
    'pipeline.filterAllGroups': 'All Groups',
    'pipeline.filterDirect': 'Direct (no group)',
    'pipeline.filterName': 'Name',
    'pipeline.filterNamePlaceholder': 'Search by name…',
    'pipeline.filterNumber': 'Number',
    'pipeline.filterNumberPlaceholder': 'Search by number…',
    'pipeline.filterContact': 'Contact',
    'pipeline.filterAllContacts': 'All Contacts',
    'pipeline.clearFilters': 'Clear filters',
    'pipeline.backfill': 'Fix filters for old messages',
    'pipeline.backfilling': 'Fixing…',
    'pipeline.backfillHint': 'One-time fix so Group/Contact filters also work on messages captured before those filters existed. Safe to run more than once.',
    'pipeline.backfillResult': 'Scanned {{scanned}} — matched {{groupsMatched}} group + {{contactsMatched}} contact message(s), {{unmatched}} left unmatched.',
    'pipeline.filterReceivedFrom': 'Received From',
    'pipeline.filterReceivedTo': 'Received To',
    'pipeline.filterPublishedFrom': 'Published From',
    'pipeline.filterPublishedTo': 'Published To',
    'pipeline.pagination.showing': 'Showing {{from}}–{{to}} of {{total}}',
    'pipeline.col.source': 'Source',
    'pipeline.col.receivedDatetime': 'Received Datetime',
    'pipeline.col.receivedFrom': 'Received From',
    'pipeline.col.text': 'Text',
    'pipeline.col.attachments': 'Attachments',
    'pipeline.col.destination': 'Destination',
    'pipeline.col.status': 'Status',
    'pipeline.col.publishedDatetime': 'Published Datetime',
    'pipeline.col.actions': 'Actions',
    'pipeline.noItems': 'No pipeline items yet. Connect an input source to start receiving content here.',
    'pipeline.selectDestination': 'Select destination',
    'pipeline.execute': 'Execute',
    'pipeline.viewEdit': 'View / Edit',
    'pipeline.viewEditMessage': 'View / Edit Message',
    'pipeline.detail.title': 'Message Details',
    'pipeline.detail.editText': 'Edit',
    'pipeline.detail.noText': 'No text content',
    'pipeline.detail.uploading': 'Uploading…',
    'pipeline.detail.addReplaceVideo': 'Add / Replace Video',
    'pipeline.detail.noAttachments': 'No attachments',
    'pipeline.detail.textSaved': 'Text updated.',
    'pipeline.detail.sender': 'Sender',
    'pipeline.detail.editSender': 'Edit',
    'pipeline.detail.senderSaved': 'Sender info updated.',
    'pipeline.detail.senderNumberPlaceholder': 'e.g. 919700802399',
    'pipeline.detail.attachmentAdded': 'Attachment added.',
    'pipeline.detail.removeAttachment': 'Remove attachment',
    'pipeline.detail.removeAttachmentConfirm': 'Remove this attachment? This cannot be undone.',
    'pipeline.detail.generatedContent': 'Generated Content',
    'pipeline.detail.cancel': 'Cancel',
    'pipeline.status.collecting': 'Collecting…',
    'pipeline.stillCollecting': 'Still collecting messages for this topic — send a line of 6+ dashes in WhatsApp to close it out.',
    'pipeline.status.received': 'Received',
    'pipeline.status.generating': 'Generating…',
    'pipeline.status.generated': 'Generated',
    'pipeline.status.publishing': 'Publishing…',
    'pipeline.status.published': 'Published',
    'pipeline.status.failed': 'Failed',
    'pipeline.noAttachments': '—',
    'pipeline.attachmentsCount': '{{count}} file(s)',
    'pipeline.capturingAttachment': 'Capturing attachment…',
    'pipeline.pagination.page': 'Page {{page}} of {{pages}}',
    'pipeline.pagination.prev': 'Prev',
    'pipeline.pagination.next': 'Next',
    'pipeline.modal.title': 'Prepare for {{destination}}',
    'pipeline.modal.generating': 'Generating {{destination}} content…',
    'pipeline.modal.regenerate': 'Regenerate',
    'pipeline.modal.generatedContentLabel': 'Generated Content',
    'pipeline.modal.editPrompt': 'Edit Prompt',
    'pipeline.modal.editPromptHint': 'Admin only — jump to this prompt in the Prompt Editor.',
    'pipeline.modal.videoTitle': 'Video Title',
    'pipeline.modal.videoDescription': 'Video Description',
    'pipeline.modal.hashtags': 'Hashtags',
    'pipeline.modal.videoTags': 'Video Tags',
    'pipeline.modal.selectAttachment': 'Select Attachment to Publish',
    'pipeline.modal.noAttachments': 'No attachments received with this message.',
    'pipeline.modal.inputVideos': 'Input Videos — assign merge order',
    'pipeline.modal.outputVideos': 'Output Videos — select one to publish',
    'pipeline.modal.mergeOrderPlaceholder': '#',
    'pipeline.modal.mergeOrderLabel': 'Merge order (leave blank to exclude)',
    'pipeline.modal.mergeSelectedVideos': 'Merge Selected Videos ({{count}})',
    'pipeline.modal.merging': 'Merging…',
    'pipeline.modal.mergeStarted': 'Merge started — this can take a while for longer clips. You can keep working; it’ll update automatically.',
    'pipeline.modal.mergeSuccess': 'Videos merged successfully.',
    'pipeline.modal.mergeFailed': 'Failed to merge videos.',
    'pipeline.modal.mergedFrom': 'Merged from {{count}} video(s)',
    'pipeline.modal.mergeBlocksPublish': 'Wait for the merge to finish before publishing.',
    'pipeline.modal.mergeBlocksVoiceOver': 'Wait for the merge to finish before generating a voice-over.',
    'pipeline.modal.publish': 'Publish',
    'pipeline.modal.publishing': 'Publishing…',
    'pipeline.modal.publishStarted': 'Publishing started — this can take a while for a large video. You can keep working; it’ll update automatically.',
    'pipeline.modal.publishStep.watermarking': 'Applying logo/watermark…',
    'pipeline.modal.publishStep.uploading': 'Uploading to YouTube…',
    'pipeline.modal.publishStep.setting_thumbnail': 'Setting thumbnail…',
    'pipeline.modal.close': 'Close',
    'pipeline.modal.generationFailed': 'Content generation failed. Check your AI provider settings.',
    'pipeline.modal.notSupported': 'Generation for this destination is not supported yet.',
    'pipeline.modal.selectDestinationFirst': 'Select a destination for this row before executing.',
    'pipeline.modal.publishSuccess': 'Marked as published. Note: live upload to the destination platform is not connected yet — that integration is being added separately.',
    'pipeline.modal.publishSuccessYoutube': 'Uploaded to YouTube as {{status}}: {{url}}',
    'pipeline.modal.privacyStatusLabel': 'Privacy on YouTube',
    'pipeline.modal.viewOnYoutube': 'View on YouTube',
    'pipeline.modal.voiceOverTitle': 'Voice-Over Narration',
    'pipeline.modal.voiceOverAsk': 'Would you like to add a voice-over narration to this video?',
    'pipeline.modal.voiceOverYes': 'Yes',
    'pipeline.modal.voiceOverNo': 'No',
    'pipeline.modal.voiceOverSkipped': 'No voice-over will be added.',
    'pipeline.modal.voiceOverChangeAnswer': 'Add one instead',
    'pipeline.modal.voiceOverLoadingVoices': 'Loading voices…',
    'pipeline.modal.voiceOverRefreshVoices': 'Refresh voice list',
    'pipeline.modal.voiceOverPickVideoHint': "Uses the video selected above — pick one first if you haven't already.",
    'pipeline.modal.voiceOverGenerate': 'Generate Voice Over',
    'pipeline.modal.voiceOverUploadOwn': 'Upload Your Own',
    'pipeline.modal.voiceOverStarting': 'Starting…',
    'pipeline.modal.voiceOverCancel': 'Stop',
    'pipeline.modal.voiceOverCancelling': 'Stopping…',
    'pipeline.modal.voiceOverSelectVideoFirst': 'Select a video attachment above before generating a voice-over.',
    'pipeline.modal.voiceOverFailed': 'Voice-over generation failed.',
    'pipeline.modal.voiceOverDone': 'Voice-over added ({{voice}}) — preview below.',
    'pipeline.modal.voiceOverBlocksPublish': 'Wait for the voice-over to finish before publishing.',
    'pipeline.modal.voiceOverStatus.generating_script': 'Writing narration script…',
    'pipeline.modal.voiceOverStatus.generating_audio': 'Generating narration audio…',
    'pipeline.modal.voiceOverStatus.merging': 'Merging narration into the video…',
    'pipeline.modal.thumbnailText': 'Thumbnail Text',
    'pipeline.modal.thumbnailsTitle': 'Thumbnail',
    'pipeline.modal.thumbnailsGenerateFrame': 'From Video Frame',
    'pipeline.modal.thumbnailsGenerateFrameHint': 'Free, instant — 6 options: 3 single-frame, plus 3 multi-image collage layouts, each with the thumbnail text overlaid.',
    'pipeline.modal.thumbnailsRegenerate': 'Regenerate',
    'pipeline.modal.thumbnailsGenerateAI': 'Generate with AI',
    'pipeline.modal.thumbnailsGenerateAIHint': 'Uses an AI image model to create a content-relevant background image (costs money per call), then overlays the thumbnail text. Can take a few minutes.',
    'pipeline.modal.thumbnailsGenerateAIAnother': 'Generate Another ({{count}}/{{max}})',
    'pipeline.modal.thumbnailsAILimitReached': 'Max {{max}} reached',
    'pipeline.modal.thumbnailsRegenerateAI': 'Regenerate with AI',
    'pipeline.modal.thumbnailsGenerating': 'Generating…',
    'pipeline.modal.thumbnailsGeneratingAILong': 'Generating your AI thumbnail — this can take up to a few minutes. Please keep this window open.',
    'pipeline.modal.thumbnailsUploadOwn': 'Upload Your Own',
    'pipeline.modal.thumbnailsEmpty': 'No thumbnails yet — generate from the video, generate with AI, or upload your own.',
    'pipeline.modal.thumbnailSelectVideoFirst': 'Select a video attachment above before generating thumbnails.',
    'pipeline.modal.thumbnailTextGenerationFailed': 'Thumbnail text generation failed ({{message}}) — the rest of the content still generated; you can type it in manually or try again.',
    'pipeline.modal.unparsedOutputWarning': 'The AI responded, but its answer didn\'t match the expected format (this usually means the "Text prompt" was edited to no longer use the required section headers). Showing the raw response below — you can copy it into the fields manually, or fix the prompt via "Edit Prompt" and regenerate.',
    'pipeline.modal.thumbnailsViewLarge': 'View large',
    'pipeline.modal.thumbnailsPosition': 'Position:',
    'pipeline.modal.thumbnailsMoveUp': 'Move text up',
    'pipeline.modal.thumbnailsMoveDown': 'Move text down',
    'pipeline.modal.thumbnailsMoveLeft': 'Move text left',
    'pipeline.modal.thumbnailsMoveRight': 'Move text right',
    'pipeline.modal.thumbnailsSize': 'Size:',
    'pipeline.modal.thumbnailsSizeDecrease': 'Decrease text size',
    'pipeline.modal.thumbnailsSizeIncrease': 'Increase text size',
    'pipeline.modal.thumbnailsResetStyle': 'Reset to default',
    'pipeline.modal.publishFailed': 'Publish failed.',
    'pipeline.modal.originalMessage': 'Original Message',
    // Script Modes page
    'scriptModes.title': 'Script Modes',
    'scriptModes.desc': 'Rewrite or generate scripts in different editorial styles',
    'scriptModes.tab.telangana': 'Telangana Dialect',
    'scriptModes.tab.irony': 'Irony / Wit / Satire',
    'scriptModes.tab.uplifting': 'Uplifting & Optimistic',
    'scriptModes.tab.critical': 'Critical & Questioning',
    'scriptModes.tab.balanced': 'Balanced Journalistic Objectivity',
    'scriptModes.inputLabel': 'Input — Paste news copy or raw information to rewrite',
    'scriptModes.generatedScript': 'Generated Script',
    'scriptModes.aiWriting': 'AI is writing your script…',
    'scriptModes.placeholder': 'Rewritten script will appear here. Click Generate to start.',
    // Social Media page
    'socialMedia.title': 'Social Media',
    'socialMedia.desc': 'Generate social media posts for your story across platforms',
    'socialMedia.tab.all': 'All Platforms',
    'socialMedia.tab.youtube': 'YouTube',
    'socialMedia.tab.facebook': 'Facebook',
    'socialMedia.tab.instagram': 'Instagram',
    'socialMedia.tab.twitter': 'Twitter / X',
    'socialMedia.inputLabel': 'Input — Paste news copy, story details, or raw content',
    'socialMedia.generatedAllPlatforms': 'Generated Posts — All Platforms',
    'socialMedia.generatedPost': 'Generated {{platform}} Post',
    'socialMedia.postPerPlatform': '1 post per platform',
    'socialMedia.aiGenerating': 'AI is generating your posts…',
    'socialMedia.placeholder': 'Generated social media posts will appear here. Click Generate to start.',
    // Sports page
    'sports.title': 'Sports',
    'sports.desc': 'Telugu TV sports scripts — match reviews and live panel discussions',
    'sports.tab.matchReview': 'Match Review',
    'sports.tab.panelDiscussion': 'Panel Discussion on Match',
    'sports.inputLabel': 'Input — Paste match details, scorecards, player stats, key moments',
    'sports.inputPlaceholder': 'Paste match details, scorecards, player stats, key moments…',
    'sports.aiWriting': 'AI is writing your sports script…',
    'sports.placeholder': 'Your generated script will appear here. Click Generate to start.',
    // Commercial Interviews page
    'interviews.title': 'Commercial Interviews',
    'interviews.desc': 'AI-generated structured question sets for sponsored on-air guest interviews',
    'interviews.tab.doctor': 'Doctor Interview',
    'interviews.tab.education': 'Education Interview',
    'interviews.tab.realEstate': 'Real Estate Interview',
    'interviews.guestName': 'Guest Name',
    'interviews.hospitalName': 'Hospital / Clinic Name',
    'interviews.universityName': 'University / Institution Name',
    'interviews.companyName': 'Company / Project Name',
    'interviews.designation': 'Designation / Title',
    'interviews.additionalInfo': 'Additional Info',
    'interviews.includeWebResearch': 'Include web research',
    'interviews.generate': 'Generate Questions',
    'interviews.clear': 'Clear',
    'interviews.sections': '{{count}} sections · {{total}} questions',
    'interviews.copyAll': 'Copy All',
    'interviews.questionsWillAppear': '50+ questions will appear here',
    'interviews.fillDetails': 'Fill in the guest details on the left and click Generate',
    'interviews.researchingOnline': 'Researching{{org}} online…',
    'interviews.gatheringContext': 'Gathering background context from the web',
    'interviews.generatingQuestions': 'Generating questions…',
    'interviews.writingQuestions': 'AI is writing 50 interview questions across 10 topics',
    'interviews.questionsLabel': '{{count}} questions',
    'interviews.additionalNote': 'Anything you want the AI to know — awards, controversies, recent news, focus areas.',
    'interviews.webResearchNote': 'Searches the web for background info on the guest and organisation before generating questions. Uses SerpAPI if configured, or DuckDuckGo as fallback (free, no key needed).',
    'interviews.guestRequired': 'Please enter the guest name before generating.',
    'interviews.generationFailed': 'Generation failed. Check your AI provider settings.',
    'interviews.doctorPlaceholder': 'E.g., speciality, achievements, notable cases or treatments…',
    'interviews.educationPlaceholder': 'E.g., NAAC grade, notable alumni, recent achievements, current programs…',
    'interviews.realEstatePlaceholder': 'E.g., ongoing projects, target market, price range, RERA registration status…',
    'interviews.guestNamePlaceholder': 'Dr. Ravi Kumar / Prof. Sunita Reddy / Mr. Arun Sharma',
    'interviews.doctorOrgPlaceholder': 'NIMS Hospital, Hyderabad',
    'interviews.educationOrgPlaceholder': 'Osmania University, Hyderabad',
    'interviews.realEstateOrgPlaceholder': 'Rainbow Infracon, Hyderabad',
    'interviews.doctorDesignationPlaceholder': 'Senior Cardiologist & Head of Department',
    'interviews.educationDesignationPlaceholder': 'Vice Chancellor / Principal',
    'interviews.realEstateDesignationPlaceholder': 'MD & Managing Director',
    'interviews.copySection': 'Copy this section',
    // Video to Script page
    'videoToScript.title': 'Video to Script',
    'videoToScript.desc': 'Transcribe video/audio and convert to a broadcast-ready TV script',
    'videoToScript.uploadVideo': 'Upload Video',
    'videoToScript.youtubeUrl': 'YouTube URL',
    'videoToScript.drop': 'Drag & drop or click to browse',
    'videoToScript.dropping': 'Drop the file here',
    'videoToScript.fileTypes': 'MP4, MOV, AVI, MKV, MP3, WAV, M4A — max 200 MB',
    'videoToScript.remove': 'Remove',
    'videoToScript.step1': 'Uploading / Fetching video',
    'videoToScript.step2': 'Transcribing audio',
    'videoToScript.step3': 'Generating TV script',
    'videoToScript.transcript': 'Transcript',
    'videoToScript.tvScript': 'TV Script',
    'videoToScript.rawTranscript': 'Raw Transcript (output)',
    'videoToScript.generatedScript': 'Generated TV Script',
    'videoToScript.regenerate': 'Regenerate Script',
    'videoToScript.regenerateNote': 'Re-runs script generation only, skipping transcription',
    'videoToScript.transcribeGenerate': 'Transcribe & Generate Script',
    'videoToScript.processing': 'Processing…',
    'videoToScript.uploading': 'Uploading file…',
    'videoToScript.fetchingYoutube': 'Fetching YouTube audio…',
    'videoToScript.transcribing': 'Transcribing audio',
    'videoToScript.converting': 'Converting to TV script…',
    'videoToScript.emptyTitle': 'Transcript and script will appear here',
    'videoToScript.emptyUpload': 'Select a file on the left and click Generate',
    'videoToScript.emptyUrl': 'Paste a YouTube URL on the left and click Generate',
    'videoToScript.publicOnly': 'Public videos only. Audio is downloaded server-side and transcribed.',
    'videoToScript.tone': 'Tone',
    'videoToScript.selectFile': 'Please select a video or audio file.',
    'videoToScript.pasteUrl': 'Please paste a YouTube URL.',
    'videoToScript.willAppear': 'Will appear here after generation…',
    'videoToScript.promptUsedFor': 'Prompt used for',
    // Video to Video page
    'videoToVideo.title': 'Video to Video',
    'videoToVideo.desc': 'Extract multiple short viral clips from any long video using AI',
    'videoToVideo.uploadVideo': 'Upload Video',
    'videoToVideo.youtubeUrl': 'YouTube URL',
    'videoToVideo.drop': 'Drag & drop or click to browse',
    'videoToVideo.dropping': 'Drop the video here',
    'videoToVideo.fileTypes': 'MP4, MOV, AVI, MKV, WEBM — max 500 MB',
    'videoToVideo.remove': 'Remove',
    'videoToVideo.step1': 'Fetching / Uploading video',
    'videoToVideo.step2': 'Analysing content with AI',
    'videoToVideo.step3': 'Extracting viral clips',
    'videoToVideo.generate': 'Extract Clips',
    'videoToVideo.processing': 'Processing…',
    'videoToVideo.pasteUrl': 'Please paste a YouTube URL.',
    'videoToVideo.selectFile': 'Please select a video file.',
    'videoToVideo.publicOnly': 'Public videos only. Video is downloaded server-side.',
    'videoToVideo.emptyTitle': 'Viral clips will appear here',
    'videoToVideo.emptyDesc': 'Upload or paste a YouTube URL and click Extract Clips',
    'videoToVideo.download': 'Download',
    'videoToVideo.clip': 'Clip',
    'videoToVideo.duration': 'Duration',
    'videoToVideo.platform': 'Best for',
    'videoToVideo.hook': 'Why it works',
    'videoToVideo.seconds': 's',
    // Legacy Common/Settings (imported but not currently routed)
    'legacySettings.title': 'API Configuration',
    'legacySettings.provider': 'AI Provider',
    'legacySettings.apiKey': 'API Key',
    'legacySettings.apiKeySecure': 'Your API key is encrypted and never shared',
    'legacySettings.model': 'Model',
    'legacySettings.temperature': 'Temperature: {{value}}',
    'legacySettings.temperatureNote': 'Lower values = more focused, Higher values = more creative',
    'legacySettings.maxTokens': 'Max Tokens',
    'legacySettings.save': 'Save Configuration',
    'legacySettings.saving': 'Saving...',
    'legacySettings.saved': 'API configuration saved successfully',
    'legacySettings.apiKeyRequired': 'API key is required',
    'legacySettings.failedSave': 'Failed to save configuration',
    'legacySettings.editorialTitle': 'Editorial Preferences',
    'legacySettings.editorialDesc': 'Configure default editorial rules and quality checks for content generation',
  },
  te: {
    // Navigation
    'nav.dashboard': 'డాష్‌బోర్డ్',
    'nav.history': 'చరిత్ర',
    'nav.settings': 'సెట్టింగ్‌లు',
    'section.production': 'నిర్మాణం',
    'section.broadcast': 'ప్రసారం',
    'section.social': 'సోషల్ మీడియా',
    // Content type labels
    'type.anchor_script': 'యాంకర్ స్క్రిప్ట్',
    'type.story': 'వార్త కథనం',
    'type.debate': 'చర్చ',
    'type.breaking_news': 'తక్షణ వార్త',
    'type.bulletin': 'వార్తా సారాంశం',
    'type.scroller': 'స్క్రోలర్',
    'type.facebook_post': 'ఫేస్‌బుక్ పోస్ట్',
    'type.youtube': 'యూట్యూబ్',
    // Anchor formats
    'type.anchorVisual': 'యాంకర్ విజువల్',
    'type.anchorVisualByte': 'యాంకర్ విజువల్ బైట్',
    'type.anchorByte': 'యాంకర్ బైట్',
    'type.anchorPackage': 'యాంకర్ ప్యాకేజ్',
    'type.anchorLive': 'యాంకర్ లైవ్',
    'type.anchorToReporter': 'యాంకర్ టు రిపోర్టర్',
    'type.anchorToGuest': 'యాంకర్ టు గెస్ట్',
    'type.anchorDrive': 'యాంకర్ డ్రైవ్',
    // Show / bulletin formats
    'type.tops': 'టాప్స్',
    'type.breakingPoints': 'బ్రేకింగ్ పాయింట్స్',
    'type.scrollings': 'స్క్రోలింగ్స్',
    'type.anchorBgTitles': 'యాంకర్ BG టైటిల్స్',
    'type.voiceOver': 'వాయిస్ ఓవర్',
    'type.newsBulletin': 'న్యూస్ బులెటిన్',
    'type.speedNews': 'స్పీడ్ న్యూస్',
    'type.indepth30': 'ఇన్-డెప్త్ 30',
    'type.offTheRecord30': 'ఆఫ్ ది రికార్డ్ 30',
    'type.specialFocus30': 'స్పెషల్ ఫోకస్ 30',
    'type.analysis10': 'అనాలిసిస్ 10',
    // Script modes
    'type.scriptModeTelangana': 'స్క్రిప్ట్ మోడ్ — తెలంగాణ',
    'type.scriptModeIrony': 'స్క్రిప్ట్ మోడ్ — వ్యంగ్యం',
    'type.scriptModeUplifting': 'స్క్రిప్ట్ మోడ్ — ఉత్సాహం',
    'type.scriptModeCritical': 'స్క్రిప్ట్ మోడ్ — విమర్శ',
    'type.scriptModeBalanced': 'స్క్రిప్ట్ మోడ్ — సమతుల్యం',
    // Social media
    'type.socialMediaAll': 'సోషల్ మీడియా — అన్ని వేదికలు',
    'type.socialMediaYouTube': 'సోషల్ మీడియా — యూట్యూబ్',
    'type.socialMediaFacebook': 'సోషల్ మీడియా — ఫేస్‌బుక్',
    'type.socialMediaInstagram': 'సోషల్ మీడియా — ఇన్‌స్టాగ్రామ్',
    'type.socialMediaTwitter': 'సోషల్ మీడియా — ట్విట్టర్',
    // Promos & interviews
    'type.digitalAnchorVisual': 'డిజిటల్ యాంకర్ విజువల్',
    'type.promoScript': 'ప్రోమో స్క్రిప్ట్',
    'type.interviewDoctor': 'ఇంటర్వ్యూ — డాక్టర్',
    'type.interviewEducation': 'ఇంటర్వ్యూ — విద్య',
    'type.interviewRealEstate': 'ఇంటర్వ్యూ — రియల్ ఎస్టేట్',
    // Sports
    'type.sportsMatchReview': 'స్పోర్ట్స్ మ్యాచ్ రివ్యూ',
    'type.sportsPanelDiscussion': 'స్పోర్ట్స్ పానెల్ చర్చ',
    // Special formats
    'type.headlinesSlugs': 'హెడ్‌లైన్స్ & స్లగ్స్',
    'type.breakingNewsPresentation': 'బ్రేకింగ్ న్యూస్ ప్రెజెంటేషన్',
    'type.conspiracyTheory': 'కాన్స్పిరసీ థియరీ',
    'type.breakingPlates': 'బ్రేకింగ్ ప్లేట్స్',
    'type.videoToScript': 'వీడియో టు స్క్రిప్ట్',
    // Editor
    'editor.configuration': 'సెట్టింగ్‌లు',
    'editor.contentType': 'కంటెంట్ రకం',
    'editor.tone': 'శైలి',
    'editor.duration': 'పొడవు (పదాలు)',
    'editor.customInstructions': 'ప్రత్యేక సూచనలు',
    'editor.customPlaceholder': 'ప్రత్యేక అవసరాలు ఇక్కడ రాయండి...',
    'editor.generate': 'కంటెంట్ రూపొందించు',
    'editor.generating': 'రూపొందిస్తున్నాం...',
    'editor.inputContent': 'ఇన్‌పుట్ కంటెంట్',
    'editor.inputPlaceholder': 'మీ వార్త వివరాలు ఇక్కడ అతికించండి. తెలుగు, ఇంగ్లీష్, హిందీ లేదా మిక్స్‌డ్ భాషలో వ్రాయవచ్చు...',
    'editor.minChars': 'కనీసం 10 అక్షరాలు అవసరం',
    'editor.generatedContent': 'రూపొందించిన కంటెంట్',
    'editor.tokens': 'టోకెన్లు',
    'editor.cost': 'వ్యయం',
    'editor.copy': 'కాపీ చేయి',
    'editor.download': 'డౌన్‌లోడ్',
    'editor.regenerate': 'మళ్ళీ రూపొందించు',
    'editor.rate': 'ఈ అవుట్‌పుట్‌కు రేటింగ్ ఇవ్వండి:',
    // YouTube specific
    'youtube.thumbnailText': 'థంబ్‌నెయిల్ టెక్స్ట్',
    'youtube.videoTitle': 'వీడియో శీర్షిక',
    'youtube.videoDescription': 'వీడియో వివరణ',
    'youtube.hashtags': 'కీవర్డ్‌లు & హ్యాష్‌ట్యాగ్‌లు',
    // Tones
    'tone.formal': 'అధికారిక',
    'tone.conversational': 'సంభాషణాత్మక',
    'tone.urgent': 'అత్యవసర',
    'tone.analytical': 'విశ్లేషణాత్మక',
    'tone.empathetic': 'సానుభూతిపూర్వక',
    'tone.happy': 'సంతోషం',
    'tone.angry': 'ఆగ్రహం',
    'tone.sad': 'విచారం',
    'tone.dramatic': 'నాటకీయ',
    'tone.neutral': 'తటస్థ',
    // TopRibbon
    'header.apiUsage': 'API వినియోగం',
    'header.tokens': 'టోకెన్లు',
    'header.profile': 'ప్రొఫైల్',
    'header.settings': 'సెట్టింగ్‌లు',
    'header.logout': 'లాగవుట్',
    'theme.light': 'లైట్',
    'theme.dark': 'డార్క్',
    'theme.switchToDark': 'డార్క్ మోడ్‌కు మారండి',
    'theme.switchToLight': 'లైట్ మోడ్‌కు మారండి',
    'theme.appearance': 'రూపం',
    'theme.appearanceHint': 'మీ ఖాతాలో సేవ్ అవుతుంది — ప్రతి బ్రౌజర్, పరికరంలో ఇదే కనిపిస్తుంది.',
    'theme.lightHint': 'తెల్లని నేపథ్యం, ముదురు అక్షరాలు',
    'theme.darkHint': 'ముదురు నేపథ్యం, రాత్రి వేళ కళ్లకు సౌకర్యం',
    'theme.saveFailed': 'థీమ్‌ను మీ ఖాతాలో సేవ్ చేయలేకపోయాం. ఇది ఈ బ్రౌజర్‌లో మాత్రమే వర్తిస్తుంది.',
    'header.profileAccount': 'ప్రొఫైల్ & అకౌంట్',
    'header.aiProviderSettings': 'AI ప్రొవైడర్ సెట్టింగ్‌లు',
    'header.promptEditor': 'ప్రాంప్ట్ ఎడిటర్',
    'header.editorialRules': 'సంపాదకీయ నియమాలు',
    'header.usageBilling': 'వినియోగం & బిల్లింగ్',
    'header.ipWhitelist': 'IP వైట్‌లిస్ట్',
    'header.automationSources': 'ఆటోమేషన్ సోర్సెస్',
    'header.switchToTelugu': 'తెలుగుకు మారండి',
    'header.switchToEnglish': 'ఇంగ్లీష్‌కు మారండి',
    'header.userManagement': 'వినియోగదారు నిర్వహణ',
    'lang.switch': 'English',
    'lang.current': 'తె',
    // Dashboard
    'dashboard.welcome': 'స్వాగతం',
    'dashboard.subtitle': 'AI-ఆధారిత న్యూస్‌రూమ్ సాధనాలతో మీ తెలుగు కంటెంట్‌ను నిర్వహించండి',
    'dashboard.totalRequests': 'మొత్తం అభ్యర్థనలు',
    'dashboard.totalTokens': 'మొత్తం టోకెన్లు',
    'dashboard.totalCost': 'మొత్తం వ్యయం',
    'dashboard.successRate': 'విజయ రేటు',
    'dashboard.thisMonth': 'ఈ నెల',
    'dashboard.used': 'వినియోగించబడింది',
    'dashboard.usd': 'USD',
    'dashboard.successful': 'విజయవంతమైన రూపాంతరాలు',
    'dashboard.quickStart': 'త్వరిత ప్రారంభం',
    'dashboard.anchorScript': 'యాంకర్ స్క్రిప్ట్',
    'dashboard.anchorScriptDesc': 'ఆకర్షణీయమైన యాంకర్ స్క్రిప్ట్‌లు రూపొందించండి',
    'dashboard.newsStory': 'వార్త కథనం',
    'dashboard.newsStoryDesc': 'సమగ్ర వార్త కథనాలు రూపొందించండి',
    'dashboard.facebookPost': 'ఫేస్‌బుక్ పోస్ట్',
    'dashboard.facebookPostDesc': 'తెలుగులో వైరల్ ఫేస్‌బుక్ పోస్ట్‌లు రూపొందించండి',
    'dashboard.usageByType': 'కంటెంట్ రకం వారీగా వినియోగం',
    'dashboard.requests': 'అభ్యర్థనలు',
    'dashboard.tokens': 'టోకెన్లు',
    // History
    'history.filters': 'వడపోత',
    'history.contentType': 'కంటెంట్ రకం',
    'history.allTypes': 'అన్ని రకాలు',
    'history.status': 'స్థితి',
    'history.allStatus': 'అన్ని స్థితులు',
    'history.completed': 'పూర్తయింది',
    'history.failed': 'విఫలమైంది',
    'history.search': 'వెతుకు',
    'history.searchPlaceholder': 'కంటెంట్ వెతుకు...',
    'history.type': 'రకం',
    'history.tokens': 'టోకెన్లు',
    'history.cost': 'వ్యయం',
    'history.date': 'తేదీ',
    'history.actions': 'చర్యలు',
    'history.noContent': 'కంటెంట్ కనుగొనబడలేదు',
    'history.close': 'మూసివేయి',
    // Toasts
    'toast.inputRequired': 'దయచేసి ఇన్‌పుట్ కంటెంట్ నమోదు చేయండి',
    'toast.generated': 'కంటెంట్ విజయవంతంగా రూపొందించబడింది',
    'toast.generateFailed': 'కంటెంట్ రూపొందించడం విఫలమైంది',
    'toast.copied': 'క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది',
    'toast.rated': 'రేటింగ్ సమర్పించబడింది',
    'toast.rateFailed': 'రేటింగ్ సమర్పించడం విఫలమైంది',
    'toast.statsFailed': 'గణాంకాలు పొందడం విఫలమైంది',
    'toast.historyFailed': 'చరిత్ర పొందడం విఫలమైంది',
    'toast.contentFailed': 'కంటెంట్ పొందడం విఫలమైంది',
    // Sidebar groups
    'sidebar.group.videoTools': 'వీడియో సాధనాలు',
    'sidebar.group.anchorFormats': 'యాంకర్ ఫార్మాట్లు',
    'sidebar.group.breakingPlates': 'బ్రేకింగ్ & ప్లేట్స్',
    'sidebar.group.bulletinTops': 'బులెటిన్ & టాప్స్',
    'sidebar.group.scriptsFormats': 'స్క్రిప్ట్స్ & ఫార్మాట్లు',
    'sidebar.group.programs': 'కార్యక్రమాలు',
    'sidebar.group.longFormats': 'దీర్ఘ ఫార్మాట్లు',
    'sidebar.group.socialPromo': 'సోషల్ & ప్రోమో',
    'sidebar.group.speciality': 'విశేష కార్యక్రమాలు',
    'sidebar.group.audioGeneration': 'ఆడియో జనరేషన్',
    // Sidebar items
    'sidebar.item.videoToScript': 'వీడియో నుండి స్క్రిప్ట్',
    'sidebar.item.videoToVideo': 'వీడియో నుండి వీడియో',
    'sidebar.item.quickAI': 'క్విక్ AI',
    'sidebar.item.newsAnchorFormats': 'న్యూస్ యాంకర్ ఫార్మాట్లు',
    'sidebar.item.breakingPlates': 'బ్రేకింగ్ ప్లేట్స్',
    'sidebar.item.breakingPoints': 'బ్రేకింగ్ పాయింట్స్',
    'sidebar.item.tops': 'టాప్స్',
    'sidebar.item.newsBulletin': 'న్యూస్ బులెటిన్',
    'sidebar.item.headlinesSlugs': 'స్లగ్‌లతో శీర్షికలు',
    'sidebar.item.breakingNewsPresentation': 'బ్రేకింగ్ న్యూస్ ప్రెజెంటేషన్',
    'sidebar.item.scrollings': 'స్క్రోలింగ్స్',
    'sidebar.item.anchorBGTitles': 'యాంకర్ బిజి టైటిల్స్',
    'sidebar.item.voiceOver': 'వాయిస్ ఓవర్',
    'sidebar.item.speedNews': 'స్పీడ్ న్యూస్',
    'sidebar.item.scriptModes': 'స్క్రిప్ట్ మోడ్స్',
    'sidebar.item.indepth': 'లోతైన విశ్లేషణ (30 నిమి)',
    'sidebar.item.offTheRecord': 'ఆఫ్ ది రికార్డ్ (30 నిమి)',
    'sidebar.item.specialFocus': 'ప్రత్యేక దృష్టి (30 నిమి)',
    'sidebar.item.analysis': 'విశ్లేషణ (10 నిమి)',
    'sidebar.item.socialMedia': 'సోషల్ మీడియా',
    'sidebar.item.promoScript': 'ప్రోమో స్క్రిప్ట్',
    'sidebar.item.digitalAnchorVisual': 'డిజిటల్ యాంకర్ విజువల్',
    'sidebar.item.commercialInterviews': 'వాణిజ్య ఇంటర్వ్యూలు',
    'sidebar.item.sports': 'క్రీడలు',
    'sidebar.item.conspiracyTheory': 'కుట్ర సిద్ధాంతం',
    'sidebar.item.burningIssue': 'బర్నింగ్ ఇష్యూ',
    'sidebar.item.tcr': 'TCR',
    'sidebar.item.worldNews': 'వరల్డ్ న్యూస్',
    'sidebar.item.crimeStory': 'క్రైమ్ స్టోరీ',
    'sidebar.item.scriptToVoice': 'స్క్రిప్ట్ నుండి వాయిస్',
    'sidebar.item.languageChange': 'భాష మార్పు',
    'sidebar.group.automation': 'ఆటోమేషన్',
    'sidebar.item.pipeline': 'పైప్‌లైన్',
    'sidebar.item.fullStory': 'ఫుల్ స్టోరీ',
    'fullStory.title': 'ఫుల్ స్టోరీ',
    'fullStory.subtitle': 'ముడి వార్త నుంచి పూర్తి వీడియో వరకు — స్క్రిప్ట్, వాయిస్ ఓవర్, చిత్రాలు, వీడియో, ఒక్కో దశలో సమీక్షిస్తూ.',
    'fullStory.untitled': 'పేరు లేని స్టోరీ',
    'fullStory.newStory': 'కొత్త స్టోరీ',
    'fullStory.creating': 'సృష్టిస్తోంది…',
    'fullStory.myStories': 'నా స్టోరీలు',
    'fullStory.teamStories': 'టీమ్',
    'fullStory.searchByUser': 'పేరు లేదా ఇమెయిల్‌తో వెతకండి',
    'fullStory.count': '{{count}} స్టోరీలు',
    'fullStory.loading': 'లోడ్ అవుతోంది…',
    'fullStory.noStories': 'ఇంకా స్టోరీలు లేవు. ఒకటి ప్రారంభించండి — వార్తను అతికిస్తే యాప్ దాన్ని పూర్తి వీడియోగా మారుస్తుంది.',
    'fullStory.noTeamStories': 'స్టోరీలు ఏవీ లేవు.',
    'fullStory.videoReady': 'వీడియో సిద్ధం',
    'fullStory.delete': 'తొలగించు',
    'fullStory.deleteConfirm': '"{{title}}" మరియు దాని అన్ని ఫైళ్లను తొలగించాలా? ఇది తిరిగి రాదు.',
    'fullStory.targetLength': 'లక్ష్యం {{seconds}}సె',
    'fullStory.prev': 'వెనుకకు',
    'fullStory.next': 'తర్వాత',
    'fullStory.notFound': 'ఈ స్టోరీ దొరకలేదు, లేదా మీకు అనుమతి లేదు.',
    'fullStory.backToStories': 'స్టోరీలకు తిరిగి వెళ్లండి',
    'fullStory.allStories': 'అన్ని స్టోరీలు',
    'fullStory.storyTitle': 'స్టోరీ శీర్షిక',
    'fullStory.cost': 'ఇప్పటివరకు AI ఖర్చు ${{cost}}',
    'fullStory.costHint': 'స్క్రిప్ట్, చిత్రాలు, ఫోటో సెర్చ్. వాయిస్ ఓవర్ ఖర్చు ElevenLabs విడిగా వసూలు చేస్తుంది.',
    'fullStory.readOnly': '{{name}} స్టోరీని చూస్తున్నారు — మార్చలేరు.',
    'fullStory.step.script': 'స్క్రిప్ట్',
    'fullStory.step.voice': 'వాయిస్ ఓవర్',
    'fullStory.step.images': 'చిత్రాలు',
    'fullStory.step.video': 'వీడియో',
    'fullStory.stepHint.script': 'వార్తను అతికించండి; మీరు ఎంచుకున్న నిడివిలో కథనం వస్తుంది.',
    'fullStory.stepHint.voice': 'వాక్యం వాక్యంగా వాయిస్ — ఏదైనా మళ్లీ రికార్డ్ చేయవచ్చు.',
    'fullStory.stepHint.images': 'ప్రతి సీన్‌కు ఒక చిత్రం — AI, వెబ్ ఫోటో లేదా మీ సొంతది.',
    'fullStory.stepHint.video': 'యానిమేషన్‌తో, వాయిస్‌కు సరిగ్గా సమయానికి, లోగో మరియు మ్యూజిక్ ఐచ్ఛికం.',
    'fullStory.state.done': 'ఆమోదించారు',
    'fullStory.state.ready': 'సిద్ధం',
    'fullStory.state.active': 'సమీక్షించాలి',
    'fullStory.state.busy': 'జరుగుతోంది…',
    'fullStory.state.failed': 'పరిశీలించాలి',
    'fullStory.state.outdated': 'పాతది',
    'fullStory.state.locked': 'ఇంకా కాదు',
    'fullStory.length': 'నిడివి',
    'fullStory.secondsMax': 'సెకన్లు (10–{{max}})',
    'fullStory.minutes': '{{n}} నిమి.',
    'fullStory.lengthRange': 'నిడివి 10 నుంచి {{max}} సెకన్ల వరకు ఉండవచ్చు.',
    'fullStory.shape': 'ఆకారం',
    'fullStory.landscape': '16:9 అడ్డంగా',
    'fullStory.portrait': '9:16 నిలువుగా',
    'fullStory.shapeChangeWarn': 'ఇప్పటి AI చిత్రాలు పాత ఆకారానికి చేసినవి, కత్తిరించబడతాయి. చిత్రాల దశలో వాటిని మళ్లీ చేయవచ్చు. ఆకారం మార్చాలా?',
    'fullStory.stop': 'ఆపు',
    'fullStory.saveEdits': 'మార్పులు సేవ్ చేయి',
    'fullStory.discardEdits': 'స్క్రిప్ట్‌లో సేవ్ చేయని మీ మార్పులు పోతాయి. కొనసాగించాలా?',
    'fullStory.scriptFailed': 'స్క్రిప్ట్ రాయలేకపోయాం. మళ్లీ ప్రయత్నించండి.',
    'fullStory.approveScriptRedo': 'వాయిస్ చేసిన తర్వాత స్క్రిప్ట్ మారింది. ఆమోదిస్తే వాయిస్ ఓవర్ మరియు చిత్రాలు తొలగిపోతాయి, కొత్త స్క్రిప్ట్‌కు మళ్లీ చేయవచ్చు. కొనసాగించాలా?',
    'fullStory.script.title': 'స్క్రిప్ట్',
    'fullStory.script.desc': 'ముడి వార్తను అతికించి, ఎలా కావాలో చెప్పండి. కథనం మీరు ఎంచుకున్న నిడివిలో రాయబడుతుంది — నేరుగా మార్చండి, లేదా మళ్లీ రాయమని అడగండి.',
    'fullStory.script.material': 'వార్త సమాచారం',
    'fullStory.script.materialPlaceholder': 'వైర్ కాపీ, నోట్స్, ప్రెస్ రిలీజ్ లేదా ఏదైనా ముడి సమాచారం అతికించండి…',
    'fullStory.script.instructions': 'సూచనలు (ఐచ్ఛికం)',
    'fullStory.script.instructionsPlaceholder': 'ఉదా. కోర్టు తీర్పుతో మొదలుపెట్టి, తర్వాత ఏం జరుగుతుందో చెప్పి ముగించండి. ప్రేక్షకులకు సులభమైన భాష.',
    'fullStory.script.write': 'స్క్రిప్ట్ రాయి',
    'fullStory.script.writeAgain': 'సమాచారం నుంచి మళ్లీ రాయి',
    'fullStory.script.narration': 'కథనం',
    'fullStory.script.estimate': '{{words}} పదాలు · సుమారు {{seconds}}సె / {{target}}సె',
    'fullStory.script.tooLong': 'లక్ష్యం కంటే పొడవుగా ఉండవచ్చు — తగ్గించండి, లేదా "ఇంకా చిన్నగా" అని మళ్లీ రాయమనండి.',
    'fullStory.script.redoPlaceholder': 'మార్పులతో మళ్లీ — ఉదా. "ఇంకా చిన్నగా", "విమానాశ్రయంతో మొదలుపెట్టు"',
    'fullStory.script.redo': 'మళ్లీ రాయి',
    'fullStory.script.earlierDrafts': 'పాత డ్రాఫ్ట్‌లు',
    'fullStory.script.restoreConfirm': 'ఈ పాత డ్రాఫ్ట్‌ను తిరిగి తేవాలా? ప్రస్తుతది పాత డ్రాఫ్ట్‌లలో ఉంటుంది.',
    'fullStory.script.approve': 'స్క్రిప్ట్ ఆమోదించు',
    'fullStory.script.approveHint': 'కథనం సరిగ్గా ఉంటే ఆమోదించండి. తర్వాత: వాయిస్ ఓవర్.',
    'fullStory.script.approvedNote': 'ఆమోదించారు. మార్చాలంటే ఎడిట్ చేసి మళ్లీ ఆమోదించండి.',
    'fullStory.voice.title': 'వాయిస్ ఓవర్',
    'fullStory.voice.desc': 'స్క్రిప్ట్ ఒక్కో వాక్యంగా వాయిస్ చేయబడుతుంది, అందువల్ల ప్రతి చిత్రం సరిగ్గా సమయానికి వస్తుంది. విని, ఏ వాక్యాన్నైనా సరిచేయండి లేదా మళ్లీ రికార్డ్ చేయండి.',
    'fullStory.voice.needScript': 'ముందుగా స్క్రిప్ట్ ఆమోదించండి.',
    'fullStory.voice.voice': 'వాయిస్',
    'fullStory.voice.artists': 'వాయిస్ ఆర్టిస్టులు',
    'fullStory.voice.otherVoices': 'ఇతర వాయిస్‌లు',
    'fullStory.voice.make': 'వాయిస్ ఓవర్ చేయి',
    'fullStory.voice.remake': 'అన్నీ మళ్లీ వాయిస్ చేయి',
    'fullStory.voice.making': 'వాయిస్ ఓవర్ తయారవుతోంది…',
    'fullStory.voice.remakeConfirm': 'ప్రతి వాక్యాన్ని మళ్లీ వాయిస్ చేయాలా? ప్రస్తుత వాయిస్ ఓవర్ మారిపోతుంది.',
    'fullStory.voice.onlyMissing': 'మిగిలిన వాక్యాలను మాత్రమే వాయిస్ చేయి',
    'fullStory.voice.voiceChanged': 'మీరు వేరే వాయిస్ ఎంచుకున్నారు — అన్ని వాక్యాలకు వాడాలంటే "అన్నీ మళ్లీ వాయిస్ చేయి".',
    'fullStory.voice.progress': '{{total}}లో {{done}} వాక్యాలు పూర్తయ్యాయి',
    'fullStory.voice.full': 'పూర్తి వాయిస్ ఓవర్',
    'fullStory.voice.length': '{{length}} (లక్ష్యం {{target}})',
    'fullStory.voice.downloadMp3': 'MP3 డౌన్‌లోడ్',
    'fullStory.voice.overMax': 'ఇది గరిష్ఠ {{max}} సెకన్ల కంటే పొడవుగా ఉంది. స్క్రిప్ట్ తగ్గించి, ఆమోదించి, మళ్లీ వాయిస్ చేయండి.',
    'fullStory.voice.tooShort': 'ఇది {{length}} — మీ {{target}} కంటే తక్కువ.',
    'fullStory.voice.tooLong': 'ఇది {{length}} — మీ {{target}} కంటే ఎక్కువ.',
    'fullStory.voice.fit': '{{target}}కు సరిపెట్టు',
    'fullStory.voice.fitConfirm': 'ఈ వాయిస్ వేగానికి {{target}}కు సరిపోయేలా స్క్రిప్ట్ మళ్లీ రాసి, మళ్లీ వాయిస్ చేయాలా? తర్వాత చిత్రాలు మళ్లీ తయారవుతాయి. (సుమారు $0.01 మరియు వాయిస్ ఓవర్.)',
    'fullStory.voice.play': 'ప్లే',
    'fullStory.voice.edit': 'పదాలు మార్చు',
    'fullStory.voice.redo': 'ఈ వాక్యం మళ్లీ రికార్డ్ చేయి',
    'fullStory.voice.saveRevoice': 'సేవ్ చేసి మళ్లీ వాయిస్ చేయి',
    'fullStory.voice.sentenceFailed': 'వాయిస్ కాలేదు — మళ్లీ ప్రయత్నించండి.',
    'fullStory.voice.approve': 'వాయిస్ ఓవర్ ఆమోదించు',
    'fullStory.voice.approveHint': 'సరిగ్గా వినిపిస్తే ఆమోదించండి. తర్వాత: చిత్రాలు — ముందుగా వాటి కోసం సూచనలు ఇవ్వవచ్చు.',
    'fullStory.voice.approvedNote': 'ఆమోదించారు.',
    'fullStory.images.title': 'చిత్రాలు',
    'fullStory.images.desc': 'స్క్రిప్ట్ సీన్లుగా విభజించబడుతుంది; ఒక్కో సీన్‌లోని వాక్యాలు చెబుతున్నప్పుడు ఒక చిత్రం కనిపిస్తుంది. ఏ చిత్రాన్నైనా మార్చండి, ఏ వాక్యాలకు ఏది అని నిర్ణయించండి.',
    'fullStory.images.needVoice': 'ముందుగా వాయిస్ ఓవర్ ఆమోదించండి.',
    'fullStory.images.summary': '{{sentences}} వాక్యాలకు {{scenes}} సీన్లు',
    'fullStory.images.makingCount': '{{count}} చిత్రం(లు) తయారవుతున్నాయి',
    'fullStory.images.planning': 'సీన్లు ప్లాన్ చేస్తోంది…',
    'fullStory.images.planningLong': 'వాక్యాలను సీన్లుగా విభజించి, ఒక్కో దానికి చిత్ర వివరణ రాస్తోంది. వెంటనే చిత్రాలు తయారవుతాయి — ఒకటి రెండు నిమిషాలు పడుతుంది.',
    'fullStory.images.plan': 'సీన్లు ప్లాన్ చేయి',
    'fullStory.images.replan': 'సీన్లు మళ్లీ ప్లాన్ చేయి',
    'fullStory.images.replanConfirm': 'అన్ని సీన్లు మళ్లీ ప్లాన్ చేయాలా? ప్రస్తుత చిత్రాలన్నీ తొలగించి కొత్త AI చిత్రాలు తయారవుతాయి (ఒక్కోటి సుమారు $0.06).',
    'fullStory.images.instructionsLabel': 'చిత్రాల సూచనలు',
    'fullStory.images.optional': '(ఐచ్ఛికం)',
    'fullStory.images.instructionsPlaceholder': 'ఉదా: ప్రతి బైక్ Royal Enfield Classic 350 అయి ఉండాలి, Royal Enfield బ్యాడ్జ్ కనిపించాలి — ఇతర బ్రాండ్లు వద్దు. హైదరాబాద్ వీధులు చూపించండి.',
    'fullStory.images.instructionsHint': 'ప్రతి AI చిత్రానికి, వెబ్ ఫోటో శోధనలకు కచ్చితంగా పాటించబడతాయి',
    'fullStory.images.makePictures': 'చిత్రాలు తయారు చేయి',
    'fullStory.images.remake': 'ఈ సూచనలతో {{count}} చిత్రాలు మళ్లీ తయారు చేయి',
    'fullStory.images.remakeConfirm': 'ఈ సూచనల ప్రకారం {{count}} కొత్త AI చిత్రాలు తయారు చేయాలా? ప్రస్తుత AI చిత్రాలు మారిపోతాయి (ఒక్కోటి సుమారు $0.06). సీన్ల అమరిక, కదలికలు, ఎఫెక్ట్‌లు అలాగే ఉంటాయి.',
    'fullStory.images.remakeConfirmKeep': 'ఈ సూచనల ప్రకారం {{count}} కొత్త AI చిత్రాలు తయారు చేయాలా? ప్రస్తుత AI చిత్రాలు మారిపోతాయి (ఒక్కోటి సుమారు $0.06). మీ {{kept}} సొంత అప్‌లోడ్‌లు, ఎంచుకున్న వెబ్ ఫోటోలు, స్టాక్ క్లిప్‌లు అలాగే ఉంటాయి; సీన్ల అమరిక, కదలికలు, ఎఫెక్ట్‌లు మారవు.',
    'fullStory.images.remakeNothing': 'మళ్లీ తయారు చేయడానికి AI చిత్రాలు లేవు — ప్రతి సీన్‌లో మీ అప్‌లోడ్, వెబ్ ఫోటో లేదా స్టాక్ క్లిప్ ఉంది.',
    'fullStory.images.scene': 'సీన్ {{n}}',
    'fullStory.images.sentence': 'వాక్యం {{n}}',
    'fullStory.images.sentences': 'వాక్యాలు {{from}}–{{to}}',
    'fullStory.images.giveFirst': 'మొదటి వాక్యాన్ని ముందు సీన్‌కు పంపు',
    'fullStory.images.giveLast': 'చివరి వాక్యాన్ని తర్వాతి సీన్‌కు పంపు',
    'fullStory.images.mergePrev': 'ముందు సీన్‌లో కలుపు (ఈ చిత్రం తొలగిపోతుంది)',
    'fullStory.images.mergeNext': 'తర్వాతి సీన్‌లో కలుపు (ఈ చిత్రం తొలగిపోతుంది)',
    'fullStory.images.mergeConfirm': 'ఈ సీన్‌ను పక్క సీన్‌లో కలపాలా? దీని చిత్రం తొలగిపోతుంది.',
    'fullStory.images.splitHere': 'ఈ వాక్యం నుంచి కొత్త చిత్రం',
    'fullStory.images.noPicture': 'ఇంకా చిత్రం లేదు',
    'fullStory.images.making': 'చిత్రం తయారవుతోంది…',
    'fullStory.images.sourceAi': 'AI',
    'fullStory.images.sourceWeb': 'వెబ్ ఫోటో',
    'fullStory.images.sourceUpload': 'మీ చిత్రం',
    'fullStory.images.sourceUploadVideo': 'మీ వీడియో',
    'fullStory.images.sourceStock': 'ఉచిత స్టాక్',
    'fullStory.images.videoBadge': 'వీడియో {{seconds}}సె',
    'fullStory.images.stockCredit': '{{author}} క్లిప్ ({{provider}})',
    'fullStory.images.uploadingVideo': 'వీడియో అప్‌లోడ్ చేసి సిద్ధం చేస్తోంది…',
    'fullStory.images.videoTooBig': 'వీడియో గరిష్టంగా {{max}} MB ఉండవచ్చు. దాన్ని కత్తిరించండి లేదా చిన్న ఫైల్‌గా ఎక్స్‌పోర్ట్ చేయండి.',
    'fullStory.images.clipPlays': 'ఈ {{clip}}సె క్లిప్‌లో {{from}}సె నుంచి {{used}} ప్లే అవుతుంది. మిగిలిన భాగం వాడబడదు.',
    'fullStory.images.clipSlowed': 'క్లిప్ ({{clip}}సె) సీన్ ({{scene}}సె) కంటే చిన్నది, కాబట్టి దాన్ని నింపడానికి కొంచెం నెమ్మదిగా ({{speed}}% వేగం) ప్లే అవుతుంది.',
    'fullStory.images.clipSlowedHold': 'క్లిప్ ({{clip}}సె) సీన్ ({{scene}}సె) కంటే చిన్నది: {{played}}సె స్లో మోషన్‌లో ({{speed}}% వేగం) ప్లే అయి, తర్వాత {{hold}}సె చివరి ఫ్రేమ్‌పై ఆగుతుంది.',
    'fullStory.images.clipHoldTip': 'ఫ్రేమ్ ఆగకుండా ఉండాలంటే పొడవైన క్లిప్ వాడండి లేదా ఒక వాక్యాన్ని తర్వాతి సీన్‌కు మార్చండి.',
    'fullStory.images.clipStartAt': 'ప్రారంభం (సెకన్లు)',
    'fullStory.images.clipStartHint': 'క్లిప్‌లో ఏ భాగం చూపాలి — 0 నుంచి {{max}}.',
    'fullStory.images.photoSuggestion': 'ఈ సీన్ ఒక నిజమైన వ్యక్తి లేదా ప్రదేశం గురించి — వెబ్ ఫోటో సరిపోవచ్చు: "{{query}}".',
    'fullStory.images.aiPicture': 'కొత్త AI చిత్రం',
    'fullStory.images.webPhotos': 'వెబ్ ఫోటోలు',
    'fullStory.images.upload': 'ఫోటో / వీడియో అప్‌లోడ్',
    'fullStory.images.remove': 'తొలగించు',
    'fullStory.images.removeConfirm': 'ఈ చిత్రాన్ని తొలగించాలా?',
    'fullStory.images.briefLabel': 'చిత్రాన్ని వివరించండి',
    'fullStory.images.briefPlaceholder': 'ఖాళీగా వదిలితే సీన్ వాక్యాల నుంచి వివరణ తయారవుతుంది.',
    'fullStory.images.make': 'చిత్రం చేయి',
    'fullStory.images.makeNew': 'కొత్త చిత్రం చేయి',
    'fullStory.images.aiCost': 'ఒక్కో చిత్రం సుమారు $0.06. AI చిత్రాల్లో నిజమైన వ్యక్తుల ముఖాలు రావు — దానికి వెబ్ ఫోటో లేదా మీ చిత్రం వాడండి.',
    'fullStory.images.searchPlaceholder': 'ఏం వెతకాలి, ఉదా. "Hyderabad metro"',
    'fullStory.images.search': 'వెతుకు',
    'fullStory.images.searchHint': 'వార్తా సైట్ల నుంచి నిజమైన ఫోటోలు చూడటానికి వెతకండి; వాడాలంటే దానిపై క్లిక్ చేయండి.',
    'fullStory.images.webRights': 'వెబ్ ఫోటోలు వాటి ప్రచురణకర్తలవి — ప్రసారం చేసే ముందు హక్కులు చూసుకోండి.',
    'fullStory.images.missing': '{{count}} సీన్(ల)కు ఇంకా చిత్రం కావాలి.',
    'fullStory.images.approve': 'చిత్రాలు ఆమోదించు',
    'fullStory.images.approveHint': 'ప్రతి సీన్‌కు సరైన చిత్రం ఉంటే ఆమోదించండి. తర్వాత: వీడియో.',
    'fullStory.images.approvedNote': 'ఆమోదించారు.',
    'fullStory.video.title': 'వీడియో',
    'fullStory.video.desc': 'చిత్రాలకు యానిమేషన్, ట్రాన్సిషన్‌లతో కలిపి, వాయిస్ ఓవర్‌కు సరిగ్గా సమయానికి. కావాలంటే మీ లోగో లేదా బ్యాక్‌గ్రౌండ్ మ్యూజిక్ జోడించండి.',
    'fullStory.video.needImages': 'ముందుగా చిత్రాలు ఆమోదించండి.',
    'fullStory.video.animation': 'యానిమేషన్',
    'fullStory.video.mixAuto': 'ఆటోమేటిక్‌గా కలుపు',
    'fullStory.effect.label': 'ఎఫెక్ట్',
    'fullStory.effect.none': 'ఎఫెక్ట్ లేదు',
    'fullStory.effect.noneHint': 'చిత్రం ఉన్నది ఉన్నట్లే. చాలా సీన్‌లు ఇలాగే బాగుంటాయి.',
    'fullStory.effect.choose': 'ఈ సీన్‌కు ఎఫెక్ట్ ఎంచుకోండి',
    'fullStory.effect.intro': 'ఏ సీన్‌కైనా {{count}} ఎఫెక్ట్‌ల నుంచి ఎంచుకోండి: వాతావరణం, టోన్, కెమెరా, ఫిల్మ్, న్యూస్ లుక్స్. అర్థం పెంచే చోట మాత్రమే వాడండి; చాలా సీన్‌లు ఎఫెక్ట్ లేకుండానే బాగుంటాయి.',
    'fullStory.effect.pickTitle': 'సీన్ {{n}} కోసం ఎఫెక్ట్',
    'fullStory.effect.pickDesc': '{{count}} ఎఫెక్ట్‌లు. ప్రతి దానికీ ఎప్పుడు సరిపోతుందో ఉంది. వర్తింపజేసే ముందు ఈ సీన్‌పై ప్రివ్యూ చూడండి.',
    'fullStory.effect.search': 'ఎఫెక్ట్‌లు వెతకండి: వర్షం, నివాళి, CCTV, చరిత్ర…',
    'fullStory.effect.all': 'అన్నీ',
    'fullStory.effect.preview': 'ఈ సీన్‌పై ప్రివ్యూ',
    'fullStory.effect.previewAgain': 'మళ్లీ ప్రివ్యూ',
    'fullStory.effect.noPicture': 'ఈ సీన్‌కు ఇంకా చిత్రం లేదు, కాబట్టి ప్రివ్యూ చేయలేము.',
    'fullStory.effect.tip': 'సూచన: ఎఫెక్ట్‌పై డబుల్-క్లిక్ చేస్తే ఎంచుకుని వెంటనే ప్రివ్యూ చూపిస్తుంది.',
    'fullStory.effect.noMatch': 'మీ శోధనకు సరిపోయే ఎఫెక్ట్‌లు లేవు.',
    'fullStory.effect.apply': 'వర్తింపజేయి',
    'fullStory.effect.close': 'మూసివేయి',
    'fullStory.effect.clearAll': 'ఎఫెక్ట్‌లు తొలగించు ({{count}})',
    'fullStory.effect.clearConfirm': 'ఎఫెక్ట్ ఉన్న మొత్తం {{count}} సీన్‌ల నుంచి ఎఫెక్ట్ తొలగించాలా?',
    'fullStory.effectCategory.tone': 'రంగు & టోన్',
    'fullStory.effectCategory.weather': 'వాతావరణం',
    'fullStory.effectCategory.camera': 'కెమెరా & నిఘా',
    'fullStory.effectCategory.film': 'ఫిల్మ్ & ప్రింట్',
    'fullStory.effectCategory.light': 'లైట్ & లెన్స్',
    'fullStory.effectCategory.news': 'న్యూస్ యాక్సెంట్స్',
    'fullStory.effect.bw': 'బ్లాక్ & వైట్',
    'fullStory.effect.bw_contrast': 'బోల్డ్ బ్లాక్ & వైట్',
    'fullStory.effect.noir': 'ఫిల్మ్ నోయిర్',
    'fullStory.effect.sepia': 'సెపియా',
    'fullStory.effect.vintage': 'వింటేజ్',
    'fullStory.effect.faded': 'వెలిసిన జ్ఞాపకం',
    'fullStory.effect.warm': 'వెచ్చని టోన్',
    'fullStory.effect.cool': 'చల్లని నీలం',
    'fullStory.effect.teal_orange': 'సినిమాటిక్',
    'fullStory.effect.vivid': 'ప్రకాశవంతమైన రంగులు',
    'fullStory.effect.muted': 'మందమైన రంగులు',
    'fullStory.effect.night': 'రాత్రి నీలం',
    'fullStory.effect.golden_hour': 'గోల్డెన్ అవర్',
    'fullStory.effect.high_key': 'ప్రకాశవంతం & తేలిక',
    'fullStory.effect.low_key': 'చీకటి & గంభీరం',
    'fullStory.effect.red_tint': 'ఎరుపు ఛాయ',
    'fullStory.effect.duotone_blue': 'నీలం డ్యూటోన్',
    'fullStory.effect.duotone_red': 'ఎరుపు డ్యూటోన్',
    'fullStory.effect.cross_process': 'క్రాస్-ప్రాసెస్డ్',
    'fullStory.effect.split_tone': 'స్ప్లిట్ టోన్',
    'fullStory.effect.rain': 'వర్షం',
    'fullStory.effect.heavy_rain': 'భారీ వర్షం',
    'fullStory.effect.thunderstorm': 'ఉరుములతో కూడిన వర్షం',
    'fullStory.effect.lightning': 'మెరుపులు',
    'fullStory.effect.snow': 'మంచు',
    'fullStory.effect.fog': 'పొగమంచు',
    'fullStory.effect.smog': 'కాలుష్య పొగ',
    'fullStory.effect.smoke': 'పొగ',
    'fullStory.effect.fire_glow': 'మంటల వెలుగు',
    'fullStory.effect.heat_haze': 'వేడి గాలి అలలు',
    'fullStory.effect.sun_glow': 'సూర్యకాంతి',
    'fullStory.effect.dust_storm': 'దుమ్ము తుఫాను',
    'fullStory.effect.cctv': 'CCTV',
    'fullStory.effect.night_vision': 'నైట్ విజన్',
    'fullStory.effect.thermal': 'థర్మల్ కెమెరా',
    'fullStory.effect.old_tv': 'పాత టీవీ',
    'fullStory.effect.vhs': 'VHS టేప్',
    'fullStory.effect.glitch': 'డిజిటల్ గ్లిచ్',
    'fullStory.effect.chromatic': 'క్రోమాటిక్ షిఫ్ట్',
    'fullStory.effect.handheld': 'హ్యాండ్‌హెల్డ్ కెమెరా',
    'fullStory.effect.earthquake': 'భూకంప కుదుపు',
    'fullStory.effect.heartbeat': 'గుండె చప్పుడు పల్స్',
    'fullStory.effect.spotlight': 'స్పాట్‌లైట్',
    'fullStory.effect.scan_line': 'సెక్యూరిటీ స్కాన్',
    'fullStory.effect.old_film': 'పాత ఫిల్మ్',
    'fullStory.effect.film_grain': 'ఫిల్మ్ గ్రెయిన్',
    'fullStory.effect.projector': 'ప్రొజెక్టర్ మినుకు',
    'fullStory.effect.newspaper': 'వార్తాపత్రిక ప్రింట్',
    'fullStory.effect.photo_print': 'ఫోటో ప్రింట్',
    'fullStory.effect.sketch': 'పెన్సిల్ స్కెచ్',
    'fullStory.effect.blueprint': 'బ్లూప్రింట్',
    'fullStory.effect.xray': 'ఎక్స్-రే',
    'fullStory.effect.poster': 'పోస్టర్',
    'fullStory.effect.relief': 'రాతి శిల్పం',
    'fullStory.effect.vignette': 'విగ్నెట్',
    'fullStory.effect.soft_glow': 'మృదువైన కాంతి',
    'fullStory.effect.dreamy': 'కలలాంటి',
    'fullStory.effect.light_leak': 'లైట్ లీక్',
    'fullStory.effect.sharpen': 'స్పష్టమైన వివరాలు',
    'fullStory.effect.miniature': 'మినియేచర్ (టిల్ట్-షిఫ్ట్)',
    'fullStory.effect.breaking_pulse': 'బ్రేకింగ్ ఎరుపు పల్స్',
    'fullStory.effect.alert_border': 'రెడ్ అలర్ట్ బార్డర్',
    'fullStory.effect.camera_flash': 'కెమెరా ఫ్లాష్',
    'fullStory.effect.cinematic_bars': 'సినిమాటిక్ బార్స్',
    'fullStory.effect.sensitive_blur': 'సున్నితం (బ్లర్)',
    'fullStory.effect.pixelate': 'పిక్సెలేటెడ్',
    'fullStory.video.motion': 'కదలిక',
    'fullStory.video.clipMoves': 'వీడియో క్లిప్ — దానంతట అదే కదులుతుంది',
    'fullStory.video.transitionIn': 'ట్రాన్సిషన్',
    'fullStory.video.opening': 'ప్రారంభం',
    'fullStory.video.startsVideo': 'వీడియో ప్రారంభం',
    'fullStory.video.logo': 'లోగో (ఐచ్ఛికం)',
    'fullStory.video.logoHint': 'మీ చానల్ లోగో అప్‌లోడ్ చేయండి — పారదర్శక బ్యాక్‌గ్రౌండ్ PNG బాగుంటుంది.',
    'fullStory.video.uploadLogo': 'లోగో అప్‌లోడ్',
    'fullStory.video.replaceLogo': 'లోగో మార్చు',
    'fullStory.video.position': 'స్థానం',
    'fullStory.video.music': 'బ్యాక్‌గ్రౌండ్ మ్యూజిక్ (ఐచ్ఛికం)',
    'fullStory.video.musicHint': 'MP3, WAV లేదా M4A అప్‌లోడ్ చేయండి — వాయిస్ కింద మెల్లగా వినిపించి, చివర్లో తగ్గిపోతుంది.',
    'fullStory.video.uploadMusic': 'మ్యూజిక్ అప్‌లోడ్',
    'fullStory.video.replaceMusic': 'మ్యూజిక్ మార్చు',
    'fullStory.video.musicFile': 'మ్యూజిక్',
    'fullStory.video.musicVolume': 'మ్యూజిక్ వాల్యూమ్',
    'fullStory.video.useInVideo': 'వీడియోలో వాడు',
    'fullStory.video.remove': 'తొలగించు',
    'fullStory.video.make': 'వీడియో చేయి',
    'fullStory.video.remake': 'వీడియో మళ్లీ చేయి',
    'fullStory.video.renderHint': '{{length}} · {{scenes}} సీన్లు. సర్వర్‌లో తయారవుతుంది — ఉచితం.',
    'fullStory.video.rendering': 'వీడియో తయారవుతోంది…',
    'fullStory.video.renderingHint': '{{length}} వీడియోకు, ఒక్కో నిమిషం వీడియోకు సుమారు ఒకటి రెండు నిమిషాలు. ఈ పేజీ వదిలినా ఇది కొనసాగుతుంది.',
    'fullStory.video.outdated': 'ఈ వీడియో తయారైన తర్వాత మార్పులు జరిగాయి — అవి చేరాలంటే మళ్లీ చేయండి.',
    'fullStory.video.downloadMp4': 'వీడియో డౌన్‌లోడ్ (MP4)',
    'fullStory.video.downloadMp3': 'వాయిస్ ఓవర్ డౌన్‌లోడ్ (MP3)',
    'fullStory.video.madeAt': '{{length}} · {{shape}} · {{time}}కు తయారైంది',
    'fullStory.motion.zoom_in': 'మెల్లగా జూమ్ ఇన్',
    'fullStory.motion.zoom_out': 'మెల్లగా జూమ్ అవుట్',
    'fullStory.motion.pan_right': 'ఎడమ నుంచి కుడికి',
    'fullStory.motion.pan_left': 'కుడి నుంచి ఎడమకు',
    'fullStory.motion.pan_down': 'పై నుంచి కిందకు',
    'fullStory.motion.pan_up': 'కింది నుంచి పైకి',
    'fullStory.motion.zoom_in_left': 'జూమ్ ఇన్, ఎడమవైపు',
    'fullStory.motion.zoom_in_right': 'జూమ్ ఇన్, కుడివైపు',
    'fullStory.motion.still': 'కదలిక లేదు',
    'fullStory.transition.fade': 'క్రాస్ ఫేడ్',
    'fullStory.transition.fadeblack': 'నలుపు ద్వారా ఫేడ్',
    'fullStory.transition.dissolve': 'డిసాల్వ్',
    'fullStory.transition.smoothleft': 'ఎడమకు స్లైడ్',
    'fullStory.transition.smoothright': 'కుడికి స్లైడ్',
    'fullStory.transition.smoothup': 'పైకి స్లైడ్',
    'fullStory.transition.circleopen': 'వృత్తాకార రివీల్',
    'fullStory.transition.wipeleft': 'ఎడమకు వైప్',
    'fullStory.transition.zoomin': 'జూమ్ త్రూ',
    'fullStory.transition.radial': 'రేడియల్ వైప్',
    'fullStory.transition.cut': 'నేరుగా కట్',
    'fullStory.position.top-left': 'పైన ఎడమ',
    'fullStory.position.top-right': 'పైన కుడి',
    'fullStory.position.bottom-left': 'కింద ఎడమ',
    'fullStory.position.bottom-right': 'కింద కుడి',
    // Auth
    'auth.platformSubtitle': 'AI-ఆధారిత తెలుగు న్యూస్‌రూమ్ వేదిక',
    'auth.welcomeBack': 'తిరిగి స్వాగతం',
    'auth.emailAddress': 'ఇమెయిల్ చిరునామా',
    'auth.password': 'పాస్‌వర్డ్',
    'auth.signIn': 'సైన్ ఇన్',
    'auth.signingIn': 'లాగిన్ అవుతున్నారు...',
    'auth.dontHaveAccount': 'అకౌంట్ లేదా?',
    'auth.signUpHere': 'ఇక్కడ నమోదు చేయండి',
    'auth.demoNote': 'డెమో: ఇమెయిల్ వాడండి: demo@kultworks.com | పాస్‌వర్డ్: demo123456',
    'auth.loginSuccess': 'లాగిన్ విజయవంతమైంది!',
    'auth.loginFailed': 'లాగిన్ విఫలమైంది',
    'auth.loggedOutAnotherDevice': 'మీరు మరొక పరికరం నుండి లాగిన్ అయినందున లాగ్ అవుట్ చేయబడ్డారు.',
    'auth.createAccount': 'అకౌంట్ సృష్టించండి',
    'auth.fullName': 'పూర్తి పేరు',
    'auth.email': 'ఇమెయిల్',
    'auth.organization': 'సంస్థ',
    'auth.creatingAccount': 'అకౌంట్ సృష్టిస్తున్నారు...',
    'auth.alreadyHaveAccount': 'ఇప్పటికే అకౌంట్ ఉందా?',
    'auth.registerSuccess': 'అకౌంట్ విజయవంతంగా సృష్టించబడింది!',
    'auth.registerFailed': 'నమోదు విఫలమైంది',
    // Admin
    'admin.userManagement': 'వినియోగదారు నిర్వహణ',
    'admin.createUser': 'వినియోగదారు సృష్టించు',
    'admin.newUser': 'కొత్త వినియోగదారు',
    'admin.editUser': 'వినియోగదారు సవరించు —',
    'admin.saveChanges': 'మార్పులు సేవ్ చేయి',
    'admin.cancel': 'రద్దు చేయి',
    'admin.loadingUsers': 'వినియోగదారులను లోడ్ చేస్తున్నారు...',
    'admin.noUsersFound': 'వినియోగదారులు కనుగొనబడలేదు',
    'admin.failedLoadUsers': 'వినియోగదారులను లోడ్ చేయడంలో విఫలమైంది',
    'admin.userCreated': 'వినియోగదారు {{email}} సృష్టించబడ్డారు',
    'admin.userUpdated': 'వినియోగదారు అప్‌డేట్ చేయబడ్డారు',
    'admin.failedCreateUser': 'వినియోగదారు సృష్టించడంలో విఫలమైంది',
    'admin.failedUpdateUser': 'వినియోగదారు అప్‌డేట్ చేయడంలో విఫలమైంది',
    'admin.fullName': 'పూర్తి పేరు',
    'admin.email': 'ఇమెయిల్',
    'admin.password': 'పాస్‌వర్డ్',
    'admin.newPassword': 'కొత్త పాస్‌వర్డ్',
    'admin.leaveBlankPassword': '(ప్రస్తుత పాస్‌వర్డ్ ఉంచడానికి ఖాళీగా వదలండి)',
    'admin.role': 'పాత్ర',
    'admin.dailyBudget': 'రోజువారీ బడ్జెట్',
    'admin.fixedForAdmins': '(నిర్వాహకులకు $50 నిర్ణీతం)',
    'admin.editor': 'సంపాదకుడు',
    'admin.manager': 'మేనేజర్',
    'admin.admin': 'నిర్వాహకుడు',
    'admin.user': 'వినియోగదారు',
    'admin.todaySpend': 'నేటి వ్యయం',
    'admin.dailyLimit': 'రోజువారీ పరిమితి',
    'admin.remaining': 'మిగిలినది',
    'admin.actions': 'చర్యలు',
    'admin.edit': 'సవరించు',
    'admin.fixed': 'నిర్ణీతం',
    'admin.deleteUser': 'వినియోగదారుని తొలగించు',
    'admin.confirmDelete': '{{name}}ని శాశ్వతంగా తొలగించాలనుకుంటున్నారా? ఇది రద్దు చేయలేరు.',
    'admin.userDeleted': 'వినియోగదారు తొలగించబడ్డారు',
    'admin.failedDeleteUser': 'వినియోగదారుని తొలగించడంలో విఫలమైంది',
    'admin.deactivate': 'నిష్క్రియం చేయి',
    'admin.activate': 'సక్రియం చేయి',
    'admin.statusActive': 'సక్రియ',
    'admin.statusInactive': 'నిష్క్రియ',
    'admin.organization': 'సంస్థ',
    'admin.orgPlaceholder': 'ఉదా. Prime9 న్యూస్',
    'admin.dailyTokens': 'రోజువారీ టోకెన్ బడ్జెట్ (USD)',
    'admin.budgetHint': 'ప్రతి AI జనరేషన్ సుమారు $0.001–0.01 ఖర్చవుతుంది. $10/రోజు ≈ 500–2000 స్క్రిప్ట్‌లు.',
    'alert.budgetExhausted': 'మీ రోజువారీ టోకెన్ పరిమితి అయిపోయింది.',
    'alert.budgetExhaustedDetail': 'మీ రోజువారీ బడ్జెట్ పెంచడానికి దయచేసి మీ నిర్వాహకుడిని సంప్రదించండి.',
    'alert.apiNotConfigured': 'AI ప్రొవైడర్ కాన్ఫిగర్ చేయబడలేదు.',
    'alert.apiNotConfiguredDetail': 'మీ అకౌంట్‌కు API కీ సెట్ చేయబడలేదు. సెట్టింగ్‌లు → AI ప్రొవైడర్‌లో కాన్ఫిగర్ చేయండి లేదా మీ నిర్వాహకుడిని సంప్రదించండి.',
    // GenPage
    'genpage.inputLabel': 'ఇన్‌పుట్ — వార్త వివరాలు, వైర్ కాపీ లేదా ముడి సమాచారం అతికించండి',
    'genpage.inputPlaceholder': 'ముడి వార్త కాపీ, ప్రెస్ రిలీజ్, ఈవెంట్ వివరాలు లేదా ఏదైనా మూల సమాచారాన్ని అతికించండి…',
    'genpage.generating': 'రూపొందిస్తున్నాం...',
    'genpage.generate': 'రూపొందించు',
    'genpage.stop': 'ఆపు',
    'genpage.stopped': 'ఆపారు. ఇప్పటివరకు వచ్చిన స్క్రిప్ట్ ఉంచబడింది.',
    'prompts.label': 'ప్రాంప్ట్',
    'prompts.none': 'ప్రాంప్ట్ లేదు',
    'prompts.manageButton': 'ప్రాంప్ట్‌లు నిర్వహించు',
    'prompts.standard': 'స్టాండర్డ్',
    'prompts.emptyText': 'ఖాళీ — స్క్రిప్ట్ మీ వార్త సమాచారం ఆధారంగా మాత్రమే రాయబడుతుంది',
    'prompts.isDefault': 'ఇది డిఫాల్ట్ ప్రాంప్ట్ — మార్చడానికి మరో ప్రాంప్ట్‌ను డిఫాల్ట్ చేయండి',
    'prompts.cannotDelete': 'స్టాండర్డ్ ప్రాంప్ట్‌ను మార్చవచ్చు కానీ తొలగించలేరు',
    'prompts.builtInHint': 'ఇది స్టాండర్డ్ ప్రాంప్ట్. దీన్ని మార్చవచ్చు లేదా ఖాళీ చేయవచ్చు, కానీ తొలగించలేరు. ఖాళీగా ఉంటే స్క్రిప్ట్ మీ వార్త సమాచారం ఆధారంగా మాత్రమే రాయబడుతుంది.',
    'prompts.managerTitle': 'నా ప్రాంప్ట్‌లు — {{place}}',
    'prompts.count': '{{max}}లో {{count}} సేవ్ అయ్యాయి',
    'prompts.close': 'మూసివేయి',
    'prompts.default': 'డిఫాల్ట్',
    'prompts.makeDefault': 'డిఫాల్ట్ చేయి',
    'prompts.setDefault': 'ఈ ప్రాంప్ట్‌ను ఆటోమేటిక్‌గా ఎంచుకో',
    'prompts.unsetDefault': 'ఈ ప్రాంప్ట్‌ను ఆటోమేటిక్‌గా ఎంచుకోవడం ఆపు',
    'prompts.edit': 'మార్చు',
    'prompts.delete': 'తొలగించు',
    'prompts.deleteConfirm': '"{{label}}" ప్రాంప్ట్‌ను తొలగించాలా?',
    'prompts.newTitle': 'కొత్త ప్రాంప్ట్',
    'prompts.editTitle': 'ప్రాంప్ట్ మార్చు',
    'prompts.labelPlaceholder': 'పేరు, ఉదా. "డిబేట్ ఫార్మాట్, బలమైన ముగింపు"',
    'prompts.textPlaceholder': 'మళ్లీ వాడాలనుకునే సూచనలు రాయండి…',
    'prompts.useByDefault': 'ఈ ప్రాంప్ట్‌ను డిఫాల్ట్‌గా ఎంచుకో',
    'prompts.cancel': 'రద్దు',
    'prompts.save': 'ప్రాంప్ట్ సేవ్ చేయి',
    'prompts.saving': 'సేవ్ అవుతోంది…',
    'prompts.saved': 'ప్రాంప్ట్ సేవ్ అయింది',
    'prompts.saveFailed': 'ప్రాంప్ట్ సేవ్ కాలేదు. మళ్లీ ప్రయత్నించండి.',
    'prompts.needLabelAndText': 'పేరు మరియు ప్రాంప్ట్ టెక్స్ట్ ఇవ్వండి.',
    'prompts.add': 'ప్రాంప్ట్ జోడించు',
    'prompts.full': 'మీ దగ్గర {{max}} ప్రాంప్ట్‌లు ఉన్నాయి — మరొకటి జోడించడానికి ఒకదాన్ని తొలగించండి లేదా మార్చండి',
    'prompts.search': 'ప్రాంప్ట్‌లు వెతకండి…',
    'prompts.noMatch': 'మీ వెతుకులాటకు సరిపోయే ప్రాంప్ట్ లేదు.',
    'genpage.tone': 'శైలి',
    'genpage.toneStandard': 'ప్రామాణిక',
    'genpage.toneUrgent': 'అత్యవసర',
    'genpage.toneConversational': 'సంభాషణాత్మక',
    'genpage.copy': 'కాపీ చేయి',
    'genpage.copied': 'కాపీ అయింది!',
    'genpage.copyToClipboard': 'క్లిప్‌బోర్డ్‌కు కాపీ చేయండి',
    'genpage.download': 'డౌన్‌లోడ్',
    'genpage.clear': 'క్లియర్ చేయి',
    'genpage.clearAll': 'అన్నీ క్లియర్ చేయి',
    'genpage.aiGenerating': 'AI రూపొందిస్తున్నది...',
    'genpage.outputPlaceholder': 'రూపొందించిన అవుట్‌పుట్ ఇక్కడ కనిపిస్తుంది. ప్రారంభించడానికి రూపొందించు నొక్కండి.',
    'genpage.promptUsedFor': 'ప్రాంప్ట్ ఉపయోగించబడింది',
    'genpage.loadingPrompt': 'ప్రాంప్ట్ లోడ్ చేస్తున్నారు...',
    'genpage.userPromptTemplate': 'వినియోగదారు ప్రాంప్ట్ టెంప్లేట్',
    'genpage.noTemplate': '(టెంప్లేట్ లేదు)',
    'genpage.editPrompt': 'ప్రాంప్ట్ సవరించు',
    'genpage.promptError': 'ప్రాంప్ట్ లోడ్ చేయడం సాధ్యం కాలేదు. బ్యాకెండ్ నడుస్తున్నదా అని నిర్ధారించుకోండి.',
    'genpage.generateError': 'కంటెంట్ రూపొందించడం విఫలమైంది. మీ AI ప్రొవైడర్ సెట్టింగ్‌లు తనిఖీ చేయండి.',
    'genpage.clipboardError': 'బ్రౌజర్ క్లిప్‌బోర్డ్ యాక్సెస్ నిరాకరించింది.',
    'genpage.downloadError': 'డౌన్‌లోడ్ విఫలమైంది. దయచేసి మళ్ళీ ప్రయత్నించండి.',
    'genpage.inputRequired': 'రూపొందించే ముందు దయచేసి ఇన్‌పుట్ వచనం నమోదు చేయండి.',
    'genpage.docx': '.docx (వర్డ్)',
    'genpage.pdf': '.pdf',
    'genpage.characters': 'అక్షరాలు',
    'genpage.words': 'పదాలు',
    'genpage.editSaved': 'సవరణ సేవ్ అయింది — AI ఈ మెరుగుదల నుండి నేర్చుకుంటుంది ✓',
    'genpage.editSavedError': 'స్థానికంగా సేవ్ అయింది, కానీ అభ్యాస అభిప్రాయం నిల్వ చేయబడలేదు.',
    // OutputToolbar
    'toolbar.changesVsOriginal': 'అసలు AI అవుట్‌పుట్ vs మార్పులు',
    'toolbar.addedByEditor': 'సంపాదకుడు జోడించాడు',
    'toolbar.removedFromDraft': 'AI డ్రాఫ్ట్ నుండి తొలగించబడింది',
    'toolbar.noContent': 'పోల్చడానికి కంటెంట్ లేదు.',
    'toolbar.fontFamily': 'ఫాంట్ కుటుంబం',
    'toolbar.decreaseFont': 'ఫాంట్ పరిమాణం తగ్గించు',
    'toolbar.increaseFont': 'ఫాంట్ పరిమాణం పెంచు',
    'toolbar.editOutput': 'అవుట్‌పుట్ సవరించు',
    'toolbar.edit': 'సవరించు',
    'toolbar.editing': 'సవరిస్తున్నారు...',
    'toolbar.saveYourEdit': 'మీ సవరణ సేవ్ చేయండి',
    'toolbar.saveEdit': 'సవరణ సేవ్ చేయి',
    'toolbar.discardYourEdit': 'మీ సవరణ రద్దు చేయండి',
    'toolbar.discard': 'రద్దు చేయి',
    'toolbar.showChangesTitle': 'అసలు AI అవుట్‌పుట్ vs మార్పులు చూపించు',
    'toolbar.showChanges': 'మార్పులు చూపించు',
    'toolbar.close': 'మూసివేయి',
    // Settings — Profile
    'settings.profile': 'ప్రొఫైల్ & అకౌంట్',
    'settings.profileSubtitle': 'మీ పేరు, ఇమెయిల్ మరియు పాస్‌వర్డ్ నిర్వహించండి',
    'settings.comingSoon': 'త్వరలో వస్తుంది',
    'settings.profileBeingBuilt': 'ప్రొఫైల్ ఎడిటర్ నిర్మించబడుతోంది.',
    // Settings — AI Provider
    'settings.aiProvider': 'AI ప్రొవైడర్ సెట్టింగ్‌లు',
    'settings.aiProviderSubtitle': 'ప్రతి AI ప్రొవైడర్‌కు API కీలు మరియు మోడళ్లను కాన్ఫిగర్ చేయండి. చురుకైన ప్రొవైడర్ అన్ని కంటెంట్ తయారీకి ఉపయోగించబడుతుంది.',
    'settings.loadingProviders': 'ప్రొవైడర్ సెట్టింగ్‌లు లోడ్ చేస్తున్నారు...',
    'settings.active': 'చురుకుగా',
    'settings.enabled': 'ప్రారంభించబడింది',
    'settings.apiKey': 'API కీ',
    'settings.storedKey': '(నిల్వ చేయబడింది — భర్తీ చేయడానికి కొత్తది నమోదు చేయండి)',
    'settings.model': 'మోడల్',
    'settings.saving': 'సేవ్ చేస్తున్నారు...',
    'settings.saved': 'సేవ్ అయింది!',
    'settings.save': 'సేవ్ చేయి',
    'settings.setAsDefault': 'డిఫాల్ట్‌గా సెట్ చేయి',
    'settings.getApiKey': 'API కీ పొందండి →',
    'settings.apiKeyRequired': 'API కీ అవసరం',
    'settings.failedSave': 'సేవ్ చేయడంలో విఫలమైంది',
    // Settings — Prompt Editor
    'settings.promptEditor': 'ప్రాంప్ట్ ఎడిటర్',
    'settings.promptEditorSubtitle': 'ప్రతి కంటెంట్ రకానికి సిస్టమ్ మరియు వినియోగదారు ప్రాంప్ట్ టెంప్లేట్లను కస్టమైజ్ చేయండి. మార్పులు అంతర్నిర్మిత రిజిస్ట్రీ డిఫాల్ట్‌లను భర్తీ చేస్తాయి.',
    'settings.loadingPrompts': 'ప్రాంప్ట్‌లు లోడ్ చేస్తున్నారు...',
    'settings.contentType': 'కంటెంట్ రకం',
    'settings.customOverrideActive': '✦ కస్టమ్ ఓవర్‌రైడ్ చురుకుగా ఉంది',
    'settings.systemPrompt': 'సిస్టమ్ ప్రాంప్ట్',
    'settings.systemPromptHint': 'ఈ కంటెంట్ రకానికి AI యొక్క పాత్ర మరియు శైలిని నిర్ణయిస్తుంది.',
    'settings.systemPromptPlaceholder': 'మీరు తెలుగు TV ప్రసార స్క్రిప్ట్ రచయిత...',
    'settings.userPromptTemplate': 'వినియోగదారు ప్రాంప్ట్ టెంప్లేట్',
    'settings.userPromptHint': 'మూల వచనానికి {{input}} మరియు అదనపు ఐచ్ఛికాలకు {{options}} ఉపయోగించండి.',
    'settings.userPromptPlaceholder': 'స్క్రిప్ట్ రాయండి:\n{{input}}\n\n{{options}}',
    'settings.notes': 'గమనికలు',
    'settings.optional': '(ఐచ్ఛికం)',
    'settings.notesPlaceholder': 'ఈ ప్రాంప్ట్ కోసం వినియోగ సూచనలు లేదా రిమైండర్లు...',
    'settings.saveChanges': 'మార్పులు సేవ్ చేయి',
    'settings.resetting': 'రీసెట్ చేస్తున్నారు...',
    'settings.resetToDefault': 'డిఫాల్ట్‌కు రీసెట్ చేయి',
    'settings.failedLoadPrompts': 'ప్రాంప్ట్‌లు లోడ్ చేయడంలో విఫలమైంది',
    'settings.failedLoadPrompt': 'ప్రాంప్ట్ లోడ్ చేయడంలో విఫలమైంది',
    'settings.userPromptRequired': 'వినియోగదారు ప్రాంప్ట్ టెంప్లేట్ అవసరం',
    'settings.failedSavePrompt': 'సేవ్ చేయడంలో విఫలమైంది',
    'settings.failedResetPrompt': 'రీసెట్ చేయడంలో విఫలమైంది',
    'settings.resetConfirm': 'ఈ ప్రాంప్ట్‌ను రిజిస్ట్రీ డిఫాల్ట్‌కు రీసెట్ చేయాలా?',
    'settings.promptEditorAccessRestricted': 'యాక్సెస్ నిరోధించబడింది',
    'settings.promptEditorAdminOnly': 'ప్రాంప్ట్ ఎడిటింగ్ నిర్వాహకులకు మాత్రమే అందుబాటులో ఉంటుంది.',
    'settings.resetSuccess': 'డిఫాల్ట్‌కు రీసెట్ చేయబడింది — కస్టమ్ ఓవర్‌రైడ్ తీసివేయబడింది',
    'settings.saveSuccess': 'ప్రాంప్ట్ సేవ్ చేయబడింది',
    'settings.lastModifiedBy': 'చివరిగా మార్చినవారు',
    'settings.on': 'న',
    'settings.editorialNotes': 'సంపాదకీయ గమనికలు',
    'settings.systemPromptFullHint': 'సిస్టమ్ ప్రాంప్ట్ — AI వ్యక్తిత్వం మరియు నియమాలను నిర్ణయిస్తుంది',
    'settings.userPromptFullHint': 'వినియోగదారు ప్రాంప్ట్ టెంప్లేట్ — {{input}}, {{options}} ను ప్లేస్‌హోల్డర్లుగా ఉపయోగించండి',
    'settings.selectPromptType': 'ఎడిటింగ్ ప్రారంభించడానికి జాబితా నుండి కంటెంట్ రకాన్ని ఎంచుకోండి.',
    // Settings — Editorial Rules
    'settings.editorialRules': 'సంపాదకీయ నియమాలు',
    'settings.editorialRulesSubtitle': 'ఛానల్-వ్యాప్త శైలి గైడ్, నిషేధిత పదాలు మరియు శైలి నిర్దేశాలు',
    'settings.editorialRulesBeingBuilt': 'సంపాదకీయ నియమాల ఎడిటర్ నిర్మించబడుతోంది.',
    // Settings — Usage & Billing
    'settings.usageBilling': 'వినియోగం & బిల్లింగ్',
    'settings.usageBillingSubtitle': 'టోకెన్ వినియోగం, రోజువారీ బడ్జెట్ మరియు వ్యయ వివరణ',
    'settings.usageDashboardBeingBuilt': 'వినియోగ డాష్‌బోర్డ్ నిర్మించబడుతోంది.',
    // Usage & Billing — cost report
    'usage.subtitle': 'AI ఖర్చు — వ్యక్తి వారీగా, పని వారీగా',
    'usage.range.today': 'ఈరోజు',
    'usage.range.yesterday': 'నిన్న',
    'usage.range.thisWeek': 'ఈ వారం',
    'usage.range.lastWeek': 'గత వారం',
    'usage.range.thisMonth': 'ఈ నెల',
    'usage.range.lastMonth': 'గత నెల',
    'usage.range.last30': 'గత 30 రోజులు',
    'usage.range.thisYear': 'ఈ సంవత్సరం',
    'usage.range.lastYear': 'గత సంవత్సరం',
    'usage.from': 'నుండి',
    'usage.to': 'వరకు',
    'usage.refresh': 'రిఫ్రెష్',
    'usage.badRange': 'ప్రారంభ తేదీ ముగింపు తేదీకి ముందు లేదా అదే రోజు ఉండాలి.',
    'usage.totalSpend': 'మొత్తం ఖర్చు',
    'usage.paidCalls': 'చెల్లింపు AI కాల్స్',
    'usage.topActivity': 'ఎక్కువ ఖర్చైన పని',
    'usage.topUser': 'ఎక్కువ ఖర్చు చేసిన వారు',
    'usage.noSpend': 'ఈ కాలంలో AI ఖర్చు లేదు.',
    'usage.byActivity': 'పని వారీగా',
    'usage.byUser': 'వ్యక్తి వారీగా',
    'usage.activity': 'పని',
    'usage.user': 'వ్యక్తి',
    'usage.cost': 'ఖర్చు',
    'usage.share': 'వాటా',
    'usage.calls': 'కాల్స్',
    'usage.activity.scripts': 'స్క్రిప్ట్‌లు & ప్రోగ్రామ్‌లు',
    'usage.activity.dubbing': 'భాష మార్పు (డబ్బింగ్)',
    'usage.activity.graphicPlates': 'గ్రాఫిక్ ప్లేట్లు',
    'usage.kind.Text': 'టెక్స్ట్',
    'usage.kind.Images': 'చిత్రాలు',
    'usage.kind.Video': 'వీడియో',
    'usage.kind.Voice': 'వాయిస్',
    'usage.kind.Transcription': 'ట్రాన్స్‌క్రిప్షన్',
    'usage.role.admin': 'అడ్మిన్',
    'usage.role.superadmin': 'అడ్మిన్',
    'usage.role.manager': 'మేనేజర్',
    'usage.role.editor': 'ఎడిటర్',
    'usage.role.user': 'యూజర్',
    'usage.role.viewer': 'వీక్షకుడు',
    'usage.note': 'ఖర్చులు ప్రతి ప్రొవైడర్ ప్రకటించిన ధరల ఆధారంగా లెక్కించబడ్డాయి; ఇన్‌వాయిస్‌లతో కొద్దిగా తేడా ఉండవచ్చు. రోజులు భారత కాలమానం ప్రకారం. ElevenLabs వాయిస్ ధర 1,000 క్రెడిట్‌లకు {{rate}} (ఒక్కో అక్షరానికి 1 క్రెడిట్). Script to Voice, డబ్బింగ్, పైప్‌లైన్ థంబ్‌నెయిల్స్ & వాయిస్-ఓవర్లు, Video to Script ఖర్చులు 29 అక్టోబర్ 2026 నుండి లెక్కించబడుతున్నాయి.',
    // Budget (ContentEditor)
    'budget.exceeded': 'రోజువారీ బడ్జెట్ ${{limit}} చేరుకుంది (${{spent}} వ్యయం). కంటెంట్ తయారీ నిలిపివేయబడింది. మీ పరిమితిని పెంచడానికి మీ నిర్వాహకుడిని సంప్రదించండి.',
    'budget.near90': 'బడ్జెట్ దాదాపు అయిపోయింది! ${{remaining}} మిగిలింది ${{limit}} రోజువారీ పరిమితిలో ({{percent}}% వినియోగించబడింది).',
    'budget.near': 'బడ్జెట్ హెచ్చరిక: ${{remaining}} మిగిలింది ${{limit}} లో నేడు ({{percent}}% వినియోగించబడింది).',
    'budget.contactAdmin': 'మరిన్ని క్రెడిట్లు జోడించడానికి నిర్వాహకుడిని సంప్రదించండి.',
    'budget.dailyReached': 'రోజువారీ బడ్జెట్ ${{limit}} చేరింది. టాప్-అప్ కోసం మీ నిర్వాహకుడిని సంప్రదించండి.',
    // Facebook preview (ContentEditor)
    'facebook.previewTitle': 'KultWorks న్యూస్',
    'facebook.previewSubtitle': 'ఫేస్‌బుక్ పోస్ట్ ప్రివ్యూ',
    // History table
    'history.user': 'వినియోగదారు',
    'history.input': 'ఇన్‌పుట్',
    'history.aiOutput': 'AI రూపొందించిన అవుట్‌పుట్',
    'history.currentOutput': 'ప్రస్తుత అవుట్‌పుట్ (సవరించబడింది)',
    'history.editHistoryLabel': 'సవరణ చరిత్ర',
    'history.version': 'వెర్షన్',
    'history.editedOn': 'సవరించిన తేదీ',
    'history.original': 'అసలు AI అవుట్‌పుట్',
    'history.editedBadge': 'సవరించబడింది',
    'history.noEdits': 'ఈ అవుట్‌పుట్‌కు ఎటువంటి సవరణలు చేయబడలేదు.',
    'history.collapseVersions': 'వెర్షన్లు దాచు',
    'history.expandVersions': 'అన్ని వెర్షన్లు చూపు',
    'history.aiTab': 'AI అవుట్‌పుట్',
    'history.editedTab': 'సవరించిన అవుట్‌పుట్',
    'history.showDiff': 'మార్పులు చూపు',
    'history.hideDiff': 'మార్పులు దాచు',
    'history.addedByEditor': 'సంపాదకుడు జోడించారు',
    'history.removedFromDraft': 'AI ముసాయిదా నుండి తొలగించారు',
    'history.noEditYet': 'ఈ అవుట్‌పుట్ ఇంకా సవరించబడలేదు.',
    'history.lastEditedOn': 'చివరిసారిగా సవరించిన తేదీ',
    'history.settingsUsed': 'ఉపయోగించిన సెట్టింగ్‌లు',
    'history.toneLabel': 'టోన్',
    'history.durationLabel': 'వ్యవధి',
    'history.wordCountLabel': 'పదాల సంఖ్య',
    'history.providerLabel': 'AI ప్రొవైడర్',
    'history.customInstructionsLabel': 'అదనపు సూచనలు',
    'history.wordsUnit': 'పదాలు',
    'history.pagination.showing': 'చూపిస్తున్నది',
    'history.pagination.to': 'నుండి',
    'history.pagination.of': 'మొత్తం',
    'history.pagination.results': 'ఫలితాలు',
    'history.pagination.prev': 'మునుపటి',
    'history.pagination.next': 'తదుపరి',
    'history.pagination.perPage': 'పేజీకి',
    // Shared control labels
    'label.duration': 'వ్యవధి',
    'label.stories': 'వార్తలు',
    'label.count': 'సంఖ్య',
    'label.maxWords': 'గరిష్ట పదాలు',
    'label.headlines': 'శీర్షికలు',
    'label.plates': 'ప్లేట్స్',
    'label.sport': 'క్రీడ',
    'label.hashtags': 'హ్యాష్‌ట్యాగ్‌లు',
    'label.emojis': 'ఎమోజీలు',
    'label.posts': 'పోస్ట్‌లు',
    'label.length': 'పొడవు',
    'label.include': 'చేర్చు',
    'label.exclude': 'మినహాయించు',
    'label.byMinutes': 'నిమిషాల వారీగా',
    'label.byWords': 'పదాల వారీగా',
    // Coming-soon pages
    'page.comingSoon': 'త్వరలో వస్తుంది',
    'page.editorBeingBuilt': 'ఈ ఎడిటర్ నిర్మించబడుతోంది.',
    // Content page — Breaking Plates
    'page.breakingPlates.title': 'బ్రేకింగ్ ప్లేట్స్',
    'page.breakingPlates.desc': 'బ్రేకింగ్ వార్తలకు ఆన్-స్క్రీన్ లోయర్ థర్డ్స్, హెడ్‌లైన్ ప్లేట్స్ మరియు టిక్కర్ బ్యానర్లు రూపొందించండి',
    'page.breakingPlates.output': 'రూపొందించిన ప్లేట్స్',
    // Content page — Breaking Points
    'page.breakingPoints.title': 'బ్రేకింగ్ పాయింట్స్',
    'page.breakingPoints.desc': 'బ్రేకింగ్ వార్తల పరిస్థితులకు వేగవంతమైన బుల్లెట్-పాయింట్ సారాంశాలు రూపొందించండి',
    'page.breakingPoints.output': 'రూపొందించిన పాయింట్స్',
    // Content page — Tops
    'page.tops.title': 'టాప్స్',
    'page.tops.desc': 'షో ఓపెన్‌ల కోసం టాప్-ఆఫ్-బులెటిన్ యాంకర్ రీడ్ స్క్రిప్ట్‌లు రూపొందించండి',
    'page.tops.output': 'రూపొందించిన టాప్స్ స్క్రిప్ట్',
    // Content page — News Bulletin
    'page.newsBulletin.title': 'న్యూస్ బులెటిన్',
    'page.newsBulletin.desc': 'యాంకర్ రీడ్‌లు, VOs మరియు ట్రాన్సిషన్లతో పూర్తి న్యూస్ బులెటిన్ రన్‌డౌన్ స్క్రిప్ట్ రూపొందించండి',
    'page.newsBulletin.output': 'రూపొందించిన బులెటిన్ స్క్రిప్ట్',
    // Content page — Scrollings
    'page.scrollings.title': 'స్క్రోలింగ్స్',
    'page.scrollings.desc': 'నిరంతర వార్తా నవీకరణల కోసం TV టిక్కర్ / స్క్రోల్ బార్ వచనం రూపొందించండి',
    'page.scrollings.output': 'రూపొందించిన స్క్రోల్స్',
    // Content page — Voice Over
    'page.voiceOver.title': 'వాయిస్ ఓవర్',
    'page.voiceOver.desc': 'B-రోల్ విజువల్స్‌పై యాంకర్ లేదా రిపోర్టర్ చదవడానికి VO ట్రాన్స్‌క్రిప్ట్ రూపొందించండి',
    'page.voiceOver.output': 'రూపొందించిన VO స్క్రిప్ట్',
    // Content page — Speed News
    'page.speedNews.title': 'స్పీడ్ న్యూస్',
    'page.speedNews.desc': 'హై-టెంపో బులెటిన్ సెగ్మెంట్‌ల కోసం వేగవంతమైన స్పీడ్ న్యూస్ అంశాలు రూపొందించండి',
    'page.speedNews.output': 'రూపొందించిన స్పీడ్ న్యూస్ అంశాలు',
    // Content page — Headlines with Slugs
    'page.headlinesSlugs.title': 'స్లగ్‌లతో శీర్షికలు',
    'page.headlinesSlugs.desc': 'రన్‌డౌన్ షీట్ల కోసం వాటి సంపాదకీయ స్లగ్‌లతో అనుసంధానించిన బ్రాడ్‌కాస్ట్ శీర్షికలు రూపొందించండి',
    'page.headlinesSlugs.output': 'రూపొందించిన శీర్షికలు & స్లగ్‌లు',
    // Content page — Breaking News Presentation
    'page.breakingNewsPresentation.title': 'బ్రేకింగ్ న్యూస్ ప్రెజెంటేషన్',
    'page.breakingNewsPresentation.desc': 'యాంకర్ క్యూలు, టిక్కర్లు మరియు హ్యాండాఫ్‌లతో పూర్తి బ్రేకింగ్ న్యూస్ ఆన్-ఎయిర్ ప్రెజెంటేషన్ స్క్రిప్ట్',
    'page.breakingNewsPresentation.output': 'రూపొందించిన బ్రేకింగ్ న్యూస్ స్క్రిప్ట్',
    // Content page — Anchor BG Titles
    'page.anchorBgTitles.title': 'యాంకర్ బిజి టైటిల్స్',
    'page.anchorBgTitles.desc': 'యాంకర్ షాట్‌ల కోసం లోయర్-థర్డ్ సూపర్స్ మరియు బ్యాక్‌గ్రౌండ్ స్క్రీన్ టైటిల్స్ రూపొందించండి',
    'page.anchorBgTitles.output': 'రూపొందించిన టైటిల్స్',
    // Content page — Promo Script
    'page.promoScript.title': 'ప్రోమో స్క్రిప్ట్',
    'page.promoScript.desc': 'రాబోయే షోలు మరియు బ్రేకింగ్ వార్తలకు ఆన్-ఎయిర్ ప్రోమో మరియు టీజర్ స్క్రిప్ట్‌లు రూపొందించండి',
    'page.promoScript.output': 'రూపొందించిన ప్రోమో స్క్రిప్ట్',
    // Content page — Digital Anchor Visual
    'page.digitalAnchorVisual.title': 'డిజిటల్ యాంకర్ విజువల్',
    'page.digitalAnchorVisual.desc': 'ఒకటి లేదా అంతకంటే ఎక్కువ నంబర్ చేసిన ముడి న్యూస్ ఐటమ్‌లను (సంక్షిప్త నోట్స్, పూర్తి వాక్యాలు కాదు) పేస్ట్ చేయండి — హ్యూమన్ యాంకర్ ఆన్ కెమెరా చదవడానికి, మీ ఇన్‌పుట్‌లో ఉన్న ప్రతి ఐటమ్‌కూ అదే క్రమంలో ఒక సహజమైన స్పోకెన్-తెలుగు పేరాగ్రాఫ్ లభిస్తుంది.',
    'page.digitalAnchorVisual.output': 'రూపొందించిన డిజిటల్ యాంకర్ విజువల్ స్క్రిప్ట్',
    // Content page — Conspiracy Theory Angle
    'page.conspiracyTheory.title': 'కుట్ర సిద్ధాంత కోణం',
    'page.conspiracyTheory.desc': 'బాధ్యతగా ఉంటూ ప్రత్యామ్నాయ వ్యాఖ్యానాలు ప్రదర్శించే దర్యాప్తు లేదా కుట్ర-కోణం స్క్రిప్ట్ రూపొందించండి',
    'page.conspiracyTheory.output': 'రూపొందించిన దర్యాప్తు స్క్రిప్ట్',
    // Content page — In-Depth (30 Min)
    'page.indepth.title': 'లోతైన విశ్లేషణ (30 నిమి)',
    'page.indepth.desc': 'నిర్మాణాత్మక సెగ్మెంట్‌లు, విశ్లేషణ, నిపుణుల బైట్‌లు మరియు ముగింపు సారాంశంతో పూర్తి 30-నిమిషాల లోతైన షో స్క్రిప్ట్ రూపొందించండి',
    'page.indepth.output': 'రూపొందించిన లోతైన స్క్రిప్ట్',
    // Content page — Off The Record (30 Min)
    'page.offTheRecord.title': 'ఆఫ్ ది రికార్డ్ (30 నిమి)',
    'page.offTheRecord.desc': 'ఇంటర్వ్యూ ప్రశ్నలు, యాంకర్ ఇంట్రో, నిపుణుల పానెల్ మాటలు మరియు ముగింపు వ్యాఖ్యలతో 30-నిమిషాల రాజకీయ చర్చా షో స్క్రిప్ట్ రూపొందించండి',
    'page.offTheRecord.output': 'రూపొందించిన ఆఫ్ ది రికార్డ్ స్క్రిప్ట్',
    // Content page — Special Focus (30 Min)
    'page.specialFocus.title': 'ప్రత్యేక దృష్టి (30 నిమి)',
    'page.specialFocus.desc': 'లోతైన సెగ్మెంట్‌లు, విజువల్ క్యూలు మరియు యాంకర్ నరేషన్‌తో 30-నిమిషాల ప్రత్యేక దృష్టి డాక్యుమెంటరీ-శైలి షో స్క్రిప్ట్ రూపొందించండి',
    'page.specialFocus.output': 'రూపొందించిన ప్రత్యేక దృష్టి స్క్రిప్ట్',
    // Content page — Analysis (10 Min)
    'page.analysis.title': 'విశ్లేషణ (10 నిమి)',
    'page.analysis.desc': 'నిర్మాణాత్మక వాదనలు, సహాయక డేటా పాయింట్లు మరియు స్పష్టమైన యాంకర్-నేతృత్వ నిర్ణయంతో 10-నిమిషాల విశ్లేషణ సెగ్మెంట్ స్క్రిప్ట్ రూపొందించండి',
    'page.analysis.output': 'రూపొందించిన విశ్లేషణ స్క్రిప్ట్',
    // Content page — Burning Issue
    'page.burningIssue.title': 'బర్నింగ్ ఇష్యూ',
    'page.burningIssue.desc': 'మీ వార్త సమాచారంతో బర్నింగ్ ఇష్యూ స్క్రిప్ట్ రాయండి — ఫార్మాట్ కోసం మీ సొంత సేవ్ చేసిన ప్రాంప్ట్ వాడండి',
    'page.burningIssue.output': 'రూపొందించిన బర్నింగ్ ఇష్యూ స్క్రిప్ట్',
    'page.tcr.title': 'TCR',
    'page.tcr.desc': 'మీ వార్త సమాచారంతో TCR స్క్రిప్ట్ రాయండి — ఫార్మాట్ కోసం మీ సొంత సేవ్ చేసిన ప్రాంప్ట్ వాడండి',
    'page.tcr.output': 'రూపొందించిన TCR స్క్రిప్ట్',
    'page.worldNews.title': 'వరల్డ్ న్యూస్',
    'page.worldNews.desc': 'మీ వార్త సమాచారంతో వరల్డ్ న్యూస్ స్క్రిప్ట్ రాయండి — ఫార్మాట్ కోసం మీ సొంత సేవ్ చేసిన ప్రాంప్ట్ వాడండి',
    'page.worldNews.output': 'రూపొందించిన వరల్డ్ న్యూస్ స్క్రిప్ట్',
    'page.crimeStory.title': 'క్రైమ్ స్టోరీ',
    'page.crimeStory.desc': 'మీ వార్త సమాచారంతో క్రైమ్ స్టోరీ స్క్రిప్ట్ రాయండి — ఫార్మాట్ కోసం మీ సొంత సేవ్ చేసిన ప్రాంప్ట్ వాడండి',
    'page.crimeStory.output': 'రూపొందించిన క్రైమ్ స్టోరీ స్క్రిప్ట్',
    // Coming-soon content pages
    'page.indepth30.title': 'ఇన్-డెప్త్ 30',
    'page.indepth30.desc': 'నిర్మాణాత్మక సెగ్మెంట్‌లు మరియు ట్రాన్సిషన్లతో 30-నిమిషాల లోతైన షో స్క్రిప్ట్‌లు',
    'page.offTheRecord30.title': 'ఆఫ్ ది రికార్డ్ 30',
    'page.offTheRecord30.desc': '30-నిమిషాల దర్యాప్తు మరియు నేపథ్య-సందర్భ షో ఫార్మాట్ స్క్రిప్ట్‌లు',
    'page.specialFocus30.title': 'స్పెషల్ ఫోకస్ 30',
    'page.specialFocus30.desc': 'సంపాదకీయ ఆర్క్‌తో 30-నిమిషాల ప్రత్యేక ప్రోగ్రామ్ స్క్రిప్ట్‌లు',
    'page.analysis10.title': 'అనాలిసిస్ 10',
    'page.analysis10.desc': 'నిర్మాణాత్మక టాకింగ్ పాయింట్‌లతో 10-నిమిషాల నిపుణుల విశ్లేషణ సెగ్మెంట్‌లు',
    // News Anchor Formats page
    'anchorFormats.title': 'న్యూస్ యాంకర్ ఫార్మాట్లు',
    'anchorFormats.desc': 'తెలుగు TV యాంకర్ స్క్రిప్ట్‌లు — విజువల్, విజువల్ బైట్, బైట్, ప్యాకేజ్, లైవ్, రిపోర్టర్, గెస్ట్ మరియు డ్రైవ్',
    // QuickAI
    'quickAI.title': 'క్విక్ AI',
    'quickAI.desc': 'ఫ్రీ-ఫారమ్ AI చాట్ — ఏదైనా అడగండి, ఏదైనా రాయండి, టెంప్లేట్లు లేకుండా',
    'quickAI.newChat': 'కొత్త చాట్',
    'quickAI.chats': 'చాట్‌లు',
    'quickAI.loadingChats': 'చాట్‌లు లోడ్ అవుతున్నాయి…',
    'quickAI.noChats': 'ఇంకా చాట్‌లు లేవు. కింద ఒకటి ప్రారంభించండి.',
    'quickAI.emptyTitle': 'నేను మీకు ఎలా సహాయం చేయగలను?',
    'quickAI.emptyDesc': 'కింద ఒక స్టోరీ, ప్రశ్న లేదా సూచన టైప్ చేయండి — తెలుగు, ఇంగ్లీష్ లేదా ఏ భాషలోనైనా.',
    'quickAI.inputPlaceholder': 'క్విక్ AI కి మెసేజ్ పంపండి…',
    'quickAI.send': 'పంపు',
    'quickAI.attach': 'ఫైల్‌లు జత చేయండి — PDF, Word, Excel, చిత్రాలు లేదా ఏ ఫైల్ అయినా (గరిష్టంగా {{max}})',
    'quickAI.removeFile': 'తీసివేయి',
    'quickAI.dropHere': 'జత చేయడానికి ఫైల్‌లను ఇక్కడ వదలండి (గరిష్టంగా {{max}})',
    'quickAI.tooManyFiles': 'ఒక మెసేజ్‌కు గరిష్టంగా {{max}} ఫైల్‌లు జత చేయవచ్చు.',
    'quickAI.fileTooLarge': '"{{name}}" 25 MB కంటే పెద్దది.',
    'quickAI.emptyFile': '"{{name}}" ఖాళీగా ఉంది.',
    'quickAI.stop': 'జనరేషన్ ఆపు',
    'quickAI.disclaimer': 'క్విక్ AI తప్పులు చేయవచ్చు — ముఖ్యమైన సమాచారాన్ని సరిచూసుకోండి.',
    'quickAI.deleteConfirm': 'ఈ చాట్‌ను తొలగించాలా? దీన్ని వెనక్కి తీసుకోలేరు.',
    'quickAI.myChats': 'నా చాట్‌లు',
    'quickAI.team': 'టీమ్',
    'quickAI.searchUser': 'యూజర్ పేరుతో వెతకండి…',
    'quickAI.noTeamChats': 'చాట్‌లు ఏవీ కనిపించలేదు.',
    'quickAI.viewingAs': 'చూస్తున్నారు',
    'quickAI.readOnly': 'చదవడానికి మాత్రమే',
    'sidebar.item.mediaAI': 'మీడియా AI',
    'admin.mediaAI': 'మీడియా AI',
    'admin.mediaAIAlwaysOn': 'ఎల్లప్పుడూ ఆన్',
    'admin.mediaAITurnOn': 'ఈ వినియోగదారుకు మీడియా AI ఆన్ చేయండి',
    'admin.mediaAITurnOff': 'ఈ వినియోగదారుకు మీడియా AI ఆఫ్ చేయండి',
    'admin.mediaAIEnabled': '{{name}}కి మీడియా AI ఆన్ చేయబడింది',
    'admin.mediaAIDisabled': '{{name}}కి మీడియా AI ఆఫ్ చేయబడింది',
    'admin.featureAccess': 'ఫీచర్ యాక్సెస్',
    'admin.featureAccessHint': 'ఈ వినియోగదారు ఏ ఐచ్ఛిక ఫీచర్లను తెరవగలరో ఎంచుకోండి. మీరు ఆన్ చేసే వరకు అన్నీ ఆఫ్‌లో ఉంటాయి.',
    'admin.featuresAlwaysOnHint': 'అడ్మిన్‌లకు అన్ని ఫీచర్లు ఎల్లప్పుడూ ఉంటాయి.',
    'admin.featureAlwaysOnForRole': '{{role}} పాత్రకు ఎల్లప్పుడూ ఆన్‌లో ఉంటుంది.',
    'admin.allFeatures': 'అన్ని ఫీచర్లు',
    'admin.featureTurnOn': 'ఈ వినియోగదారుకు {{feature}} ఆన్ చేయండి',
    'admin.featureTurnOff': 'ఈ వినియోగదారుకు {{feature}} ఆఫ్ చేయండి',
    'admin.featureEnabled': '{{name}}కి {{feature}} ఆన్ చేయబడింది',
    'admin.featureDisabled': '{{name}}కి {{feature}} ఆఫ్ చేయబడింది',
    'admin.filterByFeature': 'ఫీచర్ యాక్సెస్ ప్రకారం వినియోగదారులను ఫిల్టర్ చేయండి',
    'admin.filterAllUsers': 'అందరు వినియోగదారులు',
    'admin.filterHasFeature': '{{feature}} ఉన్నవారు',
    'admin.filterLacksFeature': '{{feature}} లేనివారు',
    'admin.noUsersMatchFilter': 'ఈ ఫిల్టర్‌కు సరిపోయే వినియోగదారులు లేరు.',
    'features.mediaAI': 'మీడియా AI',
    'features.mediaAIDesc': 'AIతో ఇమేజ్‌లు, వీడియోలు తయారు చేయండి, సవరించండి.',
    'features.fullStory': 'ఫుల్ స్టోరీ',
    'features.fullStoryDesc': 'కథను వాయిస్‌తో కూడిన వీడియోగా మార్చండి: స్క్రిప్ట్, వాయిస్, చిత్రాలు, రెండర్.',
    'sidebar.item.fullStoryVideo': 'ఫుల్ స్టోరీ వీడియో',
    'features.fullStoryVideo': 'ఫుల్ స్టోరీ వీడియో',
    'features.fullStoryVideoDesc': 'రా ఫుటేజ్‌ను పూర్తి టీవీ ప్యాకేజీగా మార్చండి: స్క్రిప్ట్, సరిపోయే ఫుటేజ్‌పై వాయిస్ ఓవర్, స్పాట్‌లు, బైట్‌లు, గ్రాఫిక్స్.',
    'features.scriptToVoice': 'స్క్రిప్ట్ టు వాయిస్',
    'features.scriptToVoiceDesc': 'రాసిన స్క్రిప్ట్‌ను ఎంచుకున్న వాయిస్‌లో వాయిస్ ఓవర్ (MP3)గా మార్చండి — 3,00,000 అక్షరాల వరకు.',
    'fullStoryVideo.title': 'ఫుల్ స్టోరీ వీడియో',
    'fullStoryVideo.subtitle': 'రా ఫుటేజ్, ఫోటోలు అప్‌లోడ్ చేయండి — వాయిస్ ఓవర్, స్పాట్‌లు, బైట్‌లు, గ్రాఫిక్స్‌తో పూర్తి ప్యాకేజీ పొందండి.',
    'fullStoryVideo.untitled': 'పేరు లేని ప్యాకేజీ',
    'fullStoryVideo.newStory': 'కొత్త ప్యాకేజీ',
    'fullStoryVideo.plateTemplates': 'గ్రాఫిక్ ప్లేట్లు',
    'fullStoryVideo.look.plateTemplate': 'గ్రాఫిక్ ప్లేట్',
    'fullStoryVideo.look.plateTemplateHint': 'ఈ వీడియోలోని ప్రతి టెక్స్ట్ ప్లేట్ ఈ గ్రాఫిక్ ప్లేట్‌లో వస్తుంది — దాని ఫోటో, పదాలు ప్లేట్ విండోలో కనిపిస్తాయి. ఒక ప్లేట్‌కు వేరేది కూడా పెట్టవచ్చు.',
    'fullStoryVideo.look.plateTemplateAi': 'ఈ వార్త కోసం AI ఎంచుకుంది',
    'fullStoryVideo.look.plateTemplateYou': 'మీరు ఎంచుకున్నది',
    'fullStoryVideo.look.plateTemplateDefault': 'డిఫాల్ట్ — సీన్లు ప్లాన్ చేస్తే AI ఎంచుకుంటుంది',
    'fullStoryVideo.scene.plateChange': 'గ్రాఫిక్ ప్లేట్',
    'fullStoryVideo.scene.plateOwn': 'సొంత గ్రాఫిక్ ప్లేట్',
    'fullStoryVideo.scene.plateTitle': 'ఈ ప్లేట్‌కు గ్రాఫిక్ ప్లేట్',
    'fullStoryVideo.scene.plateHint': 'ఈ టెక్స్ట్ ప్లేట్‌కు మాత్రమే — మిగతావి వార్త గ్రాఫిక్ ప్లేట్‌నే వాడతాయి.',
    'fullStoryVideo.scene.plateUseStory': 'వార్త గ్రాఫిక్ ప్లేట్ వాడు',
    'plateTemplates.title': 'టెంప్లేట్లు — గ్రాఫిక్ ప్లేట్లు',
    'plateTemplates.subtitle': 'లూప్‌లో కదిలే ప్లేట్ డిజైన్లు. ప్రతి దానిలోని ముదురు భాగంలో వీడియో లేదా యానిమేటెడ్ టెక్స్ట్ వస్తుంది.',
    'plateTemplates.back': 'ఫుల్ స్టోరీ వీడియో',
    'plateTemplates.all': 'అన్నీ',
    'plateTemplates.count': '{{count}} టెంప్లేట్లు',
    'plateTemplates.loading': 'టెంప్లేట్లు లోడ్ అవుతున్నాయి…',
    'plateTemplates.preparing': 'యానిమేషన్ సిద్ధమవుతోంది…',
    'plateTemplates.preparingAll': 'యానిమేషన్లు సిద్ధమవుతున్నాయి: {{total}} లో {{done}} రెడీ. అప్పటివరకు పోస్టర్ కనిపిస్తుంది.',
    'plateTemplates.loop': '{{seconds}} సె. లూప్',
    'plateTemplates.areas': '{{count}} కంటెంట్ ఏరియాలు',
    'plateTemplates.area': '1 కంటెంట్ ఏరియా',
    'plateTemplates.close': 'మూసివేయి',
    'plateTemplates.previous': 'మునుపటి',
    'plateTemplates.next': 'తదుపరి',
    'plateTemplates.create': 'గ్రాఫిక్ ప్లేట్ సృష్టించు',
    'plateTemplates.createTitle': 'గ్రాఫిక్ ప్లేట్ సృష్టించండి',
    'plateTemplates.createHint': 'ప్లేట్‌ను వివరించండి — లేదా అప్‌లోడ్ చేసిన ప్లేట్ ప్రాంప్ట్ (ప్రాంప్ట్ చూడండి) పేస్ట్ చేయండి. ఇది ఖాళీ టెక్స్ట్ ప్యానెల్‌తో ఒక పూర్తి 16:9 డిజైన్‌గా తయారవుతుంది; వార్తలో సీన్ వాక్యం ప్యానెల్‌లో రాయబడుతుంది, అప్‌లోడ్ ప్లేట్ల లాగే యానిమేషన్, ఫాంట్‌లతో.',
    'plateTemplates.createPlaceholder': 'ఉదా: ఇద్దరు ముఖ్యమంత్రుల ముఖాముఖి ప్లేట్, రాత్రి అసెంబ్లీ నేపథ్యం, కాషాయం మరియు ఆకుపచ్చ కాంతి',
    'plateTemplates.createCost': 'ఒక హై-క్వాలిటీ AI చిత్రం (సుమారు $0.05). సుమారు ఒక నిమిషం పడుతుంది.',
    'plateTemplates.createGo': 'సృష్టించు',
    'plateTemplates.creating': 'ప్రారంభమవుతోంది…',
    'plateTemplates.cancel': 'రద్దు',
    'plateTemplates.custom': 'సృష్టించినవి',
    'plateTemplates.customBadge': 'కస్టమ్',
    'plateTemplates.by': '{{name}} చేసినది',
    'plateTemplates.status.planning': 'ప్లేట్ డిజైన్ అవుతోంది…',
    'plateTemplates.status.imaging': 'నేపథ్యం తయారవుతోంది…',
    'plateTemplates.status.drawing': 'యానిమేషన్ సిద్ధమవుతోంది…',
    'plateTemplates.status.failed': 'తయారు కాలేదు',
    'plateTemplates.status.designing': 'ప్లేట్ డిజైన్ అవుతోంది…',
    'plateTemplates.usually': 'సాధారణంగా 1–2 నిమిషాలు',
    'plateTemplates.openToRetry': 'మళ్లీ ప్రయత్నించడానికి దీన్ని తెరవండి.',
    'plateTemplates.tryAgain': 'మళ్లీ ప్రయత్నించండి',
    'platePrompts.galleryButton': 'ఇష్టమైన ప్రాంప్ట్‌లు',
    'platePrompts.loadFailed': 'ఇష్టమైనవి రాలేదు: {{error}}',
    'platePrompts.savedUnder': '"{{label}}" కింద ఇష్టమైనవాటిలో సేవ్ అయింది.',
    'platePrompts.removed': 'ఇష్టమైనవాటి నుంచి తీసేశాం.',
    'platePrompts.seeFavorites': 'ఇష్టమైనవి చూడండి',
    'plateTemplates.people.startFailed': 'మొదలు కాలేదు: {{error}}',
    'plateTemplates.studio.fullscreen': 'ఫుల్ స్క్రీన్',
    'plateTemplates.studio.exitFullscreen': 'ఫుల్ స్క్రీన్ నుంచి బయటకు',
    'plateTemplates.studio.back': 'గ్యాలరీ',
    'plateTemplates.studio.more': 'మరిన్ని',
    'plateTemplates.studio.downloads': 'డౌన్‌లోడ్‌లు (16:9, 1920×1080)',
    'plateTemplates.studio.remove': 'ఈ ప్లేట్ తీసేయండి…',
    'plateTemplates.studio.previewMode': 'ప్రివ్యూ',
    'plateTemplates.studio.live': 'లైవ్ ప్రివ్యూ',
    'plateTemplates.studio.areas': 'ప్రాంతాలు సర్దండి',
    'plateTemplates.studio.sampleWords': 'నమూనా పదాలతో',
    'plateTemplates.studio.replay': 'మళ్లీ ప్లే',
    'plateTemplates.studio.unsaved': 'ఇంకా సేవ్ కాలేదు',
    'plateTemplates.studio.liveHint': 'మీరు చేసే ప్రతి మార్పు ఇక్కడ వెంటనే కనిపిస్తుంది — సేవ్ చేయక ముందే.',
    'plateTemplates.studio.areasHint': 'టెక్స్ట్ ప్రాంతం, బ్లర్ ప్రాంతాలను లాగండి; మూలల నుంచి సైజు మార్చండి. ఫలితం లైవ్ ప్రివ్యూలో.',
    'plateTemplates.studio.tab.design': 'డిజైన్',
    'plateTemplates.studio.tab.animation': 'యానిమేషన్',
    'plateTemplates.studio.tab.blur': 'బ్లర్',
    'plateTemplates.studio.tab.changes': 'AI మార్పులు',
    'plateTemplates.studio.tab.details': 'వివరాలు',
    'plateTemplates.studio.textAreaHint': 'పదాలు ఎక్కడ వస్తాయి.',
    'plateTemplates.studio.move': 'కదిలించండి / సైజు',
    'plateTemplates.studio.done': 'పూర్తి',
    'plateTemplates.studio.blurTitle': 'బ్లర్ ప్రాంతాలు',
    'plateTemplates.studio.tags': 'ట్యాగ్‌లు',
    'plateTemplates.studio.about': 'గురించి',
    'plateTemplates.studio.noPrompt': 'ఈ ప్లేట్‌కు ప్రాంప్ట్ లేదు.',
    'plateTemplates.studio.discard': 'వదిలేయండి',
    'plateTemplates.studio.save': 'మార్పులు సేవ్ చేయండి',
    'plateTemplates.studio.allSaved': 'అన్ని మార్పులు సేవ్ అయ్యాయి',
    'plateTemplates.studio.discardConfirm': 'సేవ్ చేయని మార్పులు ఉన్నాయి. సేవ్ చేయకుండా వెళ్లాలా?',
    'plateTemplates.eta.left': 'సుమారు {{left}} మిగిలింది',
    'plateTemplates.eta.late': 'సాధారణం కంటే ఎక్కువ సమయం పడుతోంది',
    'plateTemplates.people.title': 'కదిలే వ్యక్తులు',
    'plateTemplates.people.hint': 'ప్రతి వ్యక్తి వేరే లేయర్‌పై: ప్లేట్ నిలిచి ఉన్నప్పుడు మెల్లగా కదులుతారు, లోపలికి వచ్చి బయటికి వెళ్తారు — ఛానెల్ ప్లేట్‌లలాగే.',
    'plateTemplates.people.find': 'వ్యక్తులను గుర్తించి కదిలించండి',
    'plateTemplates.people.again': 'వ్యక్తులను మళ్లీ గుర్తించండి',
    'plateTemplates.people.cost': 'సుమారు ఒక నిమిషం, నేపథ్యంలో (మూడు AI చిత్రాలు, ~$0.16). ప్లేట్ వాడుకోవచ్చు.',
    'plateTemplates.people.working': 'వ్యక్తులను గుర్తిస్తోంది…',
    'plateTemplates.people.usually': 'సాధారణంగా ఒక నిమిషం లోపు',
    'plateTemplates.people.stale': 'చిత్రం మారింది — ఈ వెర్షన్ కోసం మళ్లీ గుర్తించండి.',
    'plateTemplates.people.on': 'వ్యక్తులను కదిలించండి ({{count}} గుర్తించాం)',
    'plateTemplates.people.motionLabel': 'కదలిక',
    'plateTemplates.people.entranceLabel': 'ప్రవేశం',
    'plateTemplates.people.strengthLabel': 'తీవ్రత',
    'plateTemplates.people.motion.breathe': 'శ్వాస (మెల్లని జూమ్)',
    'plateTemplates.people.motion.drift': 'ఊగడం',
    'plateTemplates.people.motion.parallax': 'పారలాక్స్',
    'plateTemplates.people.motion.still': 'స్థిరం',
    'plateTemplates.people.entrance.slide': 'పక్కల నుంచి స్లైడ్',
    'plateTemplates.people.entrance.rise': 'కింద నుంచి పైకి',
    'plateTemplates.people.entrance.zoom': 'జూమ్',
    'plateTemplates.people.entrance.fade': 'ఫేడ్',
    'plateTemplates.people.entrance.none': 'ఏదీ లేదు',
    'plateTemplates.people.strength.subtle': 'తక్కువ',
    'plateTemplates.people.strength.medium': 'మధ్యస్థం',
    'plateTemplates.people.strength.strong': 'ఎక్కువ',
    'plateTemplates.live.loading': 'వస్తోంది…',
    'plateTemplates.live.pause': 'ఆపండి',
    'plateTemplates.live.play': 'ప్లే చేయండి',
    'plateTemplates.pkg.playThis': 'ఈ టెక్స్ట్ ప్లే చేయండి',
    'plateTemplates.pkg.fullKeys': 'Space: ప్లే / ఆపు · ← →: ముందు / తర్వాతి టెక్స్ట్ · Esc: ఫుల్ స్క్రీన్ నుండి బయటికి',
    'plateTemplates.fxLayer.title': 'ఎఫెక్ట్‌లు ఎక్కడ',
    'plateTemplates.fxLayer.front': 'టెక్స్ట్ ప్లేట్ల పైన',
    'plateTemplates.fxLayer.behind': 'టెక్స్ట్ ప్లేట్ల వెనుక',
    'plateTemplates.fxLayer.hint.front': 'ఎఫెక్ట్‌లు అన్నింటిపైనా, టెక్స్ట్ ప్యానెల్‌లపైనా పడతాయి (ఎప్పటిలాగే).',
    'plateTemplates.fxLayer.hint.behind': 'ఎఫెక్ట్‌లు టెక్స్ట్ ప్యానెల్‌ల చుట్టూ, వెనుక నడుస్తాయి — ప్యానెల్‌లు, వాటి పదాలపై ఎప్పుడూ రావు. ప్యాకేజీలోని ప్రతి టెక్స్ట్ ఏరియా టెక్స్ట్ ప్లేట్‌గా లెక్క.',
    'plateFonts.search': '{{count}} ఫాంట్లలో వెతకండి…',
    'plateFonts.kind.all': 'అన్నీ',
    'plateFonts.kind.builtin': 'ఛానెల్ ఎంపికలు',
    'plateFonts.kind.uploaded': 'అప్‌లోడ్ చేసినవి',
    'plateFonts.kind.display': 'డిస్‌ప్లే',
    'plateFonts.kind.sans': 'సాన్స్',
    'plateFonts.kind.serif': 'సెరిఫ్',
    'plateFonts.kind.handwriting': 'చేతిరాత',
    'plateFonts.none': 'ఏ ఫాంట్ సరిపోలలేదు.',
    'plateFonts.uploadedBy': '{{name}} అప్‌లోడ్ చేశారు',
    'plateFonts.removeConfirm': '"{{name}}" ఫాంట్‌ను అందరికీ తొలగించాలా? దాన్ని వాడే ప్లేట్లు డిఫాల్ట్ ఫాంట్‌కు మారుతాయి.',
    'plateFonts.namePlaceholder': 'పేరు (ఐచ్ఛికం) — ఉదా. "అను బోల్డ్"',
    'plateFonts.upload': 'ఫాంట్ అప్‌లోడ్ చేయండి',
    'plateFonts.uploadHint': 'మీ ఛానెల్‌కు లైసెన్స్ ఉన్న ఏ ఫాంట్ అయినా (అను, గౌతమి, నిర్మల UI, శ్రీ-లిపి…): .ttf, .otf లేదా .ttc, 30 MB వరకు. అది యూనికోడ్ తెలుగు ఫాంట్ అయి ఉండాలి — స్క్రిప్ట్ మేనేజర్‌తో టైప్ చేసే పాత ఫాంట్లు కారణంతో సహా తిరస్కరించబడతాయి. తర్వాత అందరూ వాడుకోవచ్చు.',
    'plateTemplates.people.hintPlaceholder': 'ఎవరిని గుర్తించాలి (ఐచ్ఛికం) — ఉదా. "ముందున్న ఇద్దరు నాయకులు మాత్రమే"',
    'plateTemplates.people.filling': 'వారి వెనుక నేపథ్యాన్ని నింపుతోంది…',
    'plateTemplates.people.choose': 'ఏవి కదలాలో ఎంచుకోండి',
    'plateTemplates.people.moving': '{{found}} లో {{count}} కదులుతున్నాయి',
    'plateTemplates.people.oldWay': 'పాత పద్ధతిలో గుర్తించారు — ఎవరు కదలాలో ఎంచుకోవడానికి, వారి వెనుక నేపథ్యం నింపడానికి మళ్లీ గుర్తించండి.',
    'plateTemplates.people.uncoveredShort': 'కదిలే భాగంలో కొంతకు వెనుక నేపథ్యం ఇంకా లేదు — నింపడానికి "ఏవి కదలాలో ఎంచుకోండి" తెరవండి.',
    'plateTemplates.people.editor.title': 'ఏవి కదలాలో ఎంచుకోండి',
    'plateTemplates.people.editor.hint': 'ఒక వ్యక్తిని కదిలించడానికి లేదా నిలపడానికి క్లిక్ చేయండి. ఏ వ్యక్తినైనా వస్తువునైనా దానిపై పెయింట్ చేసి జోడించండి. బ్రష్‌తో అంచును సరిచేయండి.',
    'plateTemplates.people.editor.saving': 'సేవ్ అవుతోంది…',
    'plateTemplates.people.editor.done': 'పూర్తి',
    'plateTemplates.people.editor.view.plate': 'ప్లేట్',
    'plateTemplates.people.editor.view.behind': 'వారి వెనుక నేపథ్యం',
    'plateTemplates.people.editor.view.motion': 'కదలిక చూడండి',
    'plateTemplates.people.editor.task.add': 'దాన్ని తీసి వెనుక నేపథ్యం నింపుతోంది…',
    'plateTemplates.people.editor.task.fill': 'నేపథ్యం నింపుతోంది…',
    'plateTemplates.people.editor.behindHint': 'కదిలేవి పక్కకు వెళ్లినప్పుడు కనిపించేది ఇదే. ఏదైనా మిగిలి ఉందా? "జోడించు"తో పెయింట్ చేసి గుర్తించండి, లేదా నేపథ్యాన్ని మళ్లీ నింపండి.',
    'plateTemplates.people.editor.motionHint': 'వీడియోలో లాగే వ్యక్తులు కదులుతున్నారు (పదాలు లేకుండా).',
    'plateTemplates.people.editor.toolHint.pick': 'ఒక వ్యక్తి లేదా వస్తువుపై క్లిక్ చేయండి: రంగులోనివి కదులుతాయి, బూడిదరంగువి నిలిచి ఉంటాయి.',
    'plateTemplates.people.editor.toolHint.add': 'వ్యక్తి లేదా వస్తువు మొత్తంపై, అంచులకు కొంచెం బయటివరకు పెయింట్ చేయండి — తర్వాత అది ఏమిటో చెప్పి "గుర్తించు" నొక్కండి.',
    'plateTemplates.people.editor.toolHint.moves': 'వ్యక్తితో కలిసి కదలాల్సిన భాగాన్ని పెయింట్ చేయండి (జుట్టు, చేయి, మైక్). బ్రష్ ఎత్తగానే వర్తిస్తుంది.',
    'plateTemplates.people.editor.toolHint.still': 'నిలిచి ఉండాల్సిన భాగాన్ని పెయింట్ చేయండి (అంచులో చిక్కిన ప్యానెల్ లేదా ఫ్రేమ్). అది కదిలే వ్యక్తి ముందు ఉంటుంది.',
    'plateTemplates.people.editor.toolHint.erase': 'బ్రష్ గుర్తులను చెరిపేయండి: ఆ భాగం గుర్తించినట్లే అవుతుంది.',
    'plateTemplates.people.editor.uncovered': 'కదిలే భాగంలో కొంతకు వెనుక నేపథ్యం ఇంకా లేదు, కదిలినప్పుడు కత్తిరించినట్లు కనిపించవచ్చు.',
    'plateTemplates.people.editor.fill': 'నేపథ్యం నింపండి (~40 సె)',
    'plateTemplates.people.editor.tools': 'సాధనాలు',
    'plateTemplates.people.editor.tool.pick': 'ఎంచుకో',
    'plateTemplates.people.editor.tool.add': 'జోడించు',
    'plateTemplates.people.editor.tool.moves': 'కదులుతుంది',
    'plateTemplates.people.editor.tool.still': 'నిలిచి ఉంటుంది',
    'plateTemplates.people.editor.tool.erase': 'చెరుపు',
    'plateTemplates.people.editor.size': 'బ్రష్',
    'plateTemplates.people.editor.undo': 'రద్దు',
    'plateTemplates.people.editor.clearBrush': 'బ్రష్ గుర్తులు తొలగించు',
    'plateTemplates.people.editor.addTitle': 'వ్యక్తిని లేదా వస్తువును జోడించండి',
    'plateTemplates.people.editor.addHint': 'ప్లేట్‌పై దాని మీద పెయింట్ చేశారా? అది ఏమిటో చెప్పండి (AIకి సహాయం), తర్వాత గుర్తించండి. అది కచ్చితంగా తీయబడుతుంది, వెనుక నేపథ్యం నింపబడుతుంది.',
    'plateTemplates.people.editor.labelPlaceholder': 'అది ఏమిటి? ఉదా. "కారు", "ట్రోఫీ"',
    'plateTemplates.people.editor.addGo': 'గుర్తించు',
    'plateTemplates.people.editor.clearMarks': 'గుర్తులు తొలగించు',
    'plateTemplates.people.editor.addCost': 'సుమారు 40 సె, నేపథ్యంలో (రెండు AI చిత్రాలు, ~$0.10).',
    'plateTemplates.people.editor.list': 'ఈ ప్లేట్‌పై ({{count}} లో {{moving}} కదులుతున్నాయి)',
    'plateTemplates.people.editor.moves': '{{n}} కదులుతుంది',
    'plateTemplates.people.editor.object': 'వస్తువు {{n}}',
    'plateTemplates.people.editor.person': 'వ్యక్తి {{n}}',
    'plateTemplates.people.editor.rough': 'అంచు స్థూలంగా ఉంది — సరిచూడండి',
    'plateTemplates.people.editor.moving': 'కదులుతుంది',
    'plateTemplates.people.editor.still': 'నిలిచి',
    'plateTemplates.people.editor.listHint': 'వీరందరి వెనుక నేపథ్యం ఇప్పటికే నింపబడింది, కాబట్టి ఎవరు కదిలినా కత్తిరించినట్లు కనిపించదు.',
    'plateTemplates.pkg.lineSpacing': 'లైన్ {{n}} అంతరం',
    'plateTemplates.pkg.lineSpacingHint': 'లైన్ల మధ్య అంతరం: లైన్ ఎత్తు, దాని పరిమాణానికి గుణకంగా',
    'plateTemplates.pkg.spacingAuto': 'అంతరం: ఆటో',
    'plateTemplates.pkg.spacingValue': 'అంతరం {{v}}×',
    'plateTemplates.pkg.wordStyles': 'పదాల శైలి — ఒక పదానికి సొంత రంగు, పరిమాణం, అంచు లేదా నీడ ఇవ్వడానికి దానిపై క్లిక్ చేయండి',
    'plateTemplates.pkg.wordStyle': '"{{word}}"',
    'plateTemplates.pkg.wordSize': 'పరిమాణం',
    'plateTemplates.pkg.wordAsLine': 'లైన్ లాగే',
    'plateTemplates.pkg.wordStyleClear': 'లైన్ శైలికి తిరిగి',
    'plateTemplates.pkg.transparent': 'పారదర్శక నేపథ్యం (.mov)',
    'plateTemplates.pkg.transparentHint': 'ప్లేట్ లేని చోట పారదర్శక నేపథ్యంతో వీడియోలు (ట్రాన్సిషన్ లోపలికి, బయటికి తెచ్చేటప్పుడు) — ఎడిటింగ్ సాఫ్ట్‌వేర్‌లో ఇతర ఫుటేజ్‌పై ఉంచడానికి.',
    'plateTemplates.pkg.formatTransparent': 'చిత్రాలు: JPG, 1920×1080. వీడియోలు: MOV (పారదర్శకతతో ProRes 4444), 1920×1080, 25 fps — Premiere, Final Cut, DaVinci, Vegasలో తెరుచుకుంటుంది. చాలావి కలిపి ZIPగా వస్తాయి. AI క్రెడిట్లు ఖర్చు కావు.',
    'plateTemplates.pkg.plateUnsaved': 'ప్లేట్ మార్పులు సేవ్ కాలేదు',
    'plateTemplates.pkg.savePlate': 'ప్లేట్ సేవ్ చేయండి',
    'plateTemplates.pkg.tab.style': 'పదాల శైలి',
    'plateTemplates.pkg.blurPackage': 'ఈ ప్యాకేజీ ప్లేట్లపై బ్లర్',
    'plateTemplates.pkg.blurPlate': 'ప్లేట్‌పైనే బ్లర్ (అన్ని ప్యాకేజీలు)',
    'plateTemplates.pkg.onPlate': 'ప్లేట్',
    'plateTemplates.setupView.animation': 'యానిమేషన్',
    'plateTemplates.fx.title': 'ఎఫెక్ట్స్',
    'plateTemplates.fx.hint': '{{max}} లో {{count}} ఎంచుకున్నారు — ప్రివ్యూ, ప్యాకేజీ, డౌన్‌లోడ్‌లలో ప్లేట్‌పై కనిపిస్తాయి',
    'plateTemplates.fx.thunder': 'ఉరుములు-మెరుపులు',
    'plateTemplates.fx.earthquake': 'భూకంపం',
    'plateTemplates.fx.rain': 'వర్షం',
    'plateTemplates.fx.snow': 'మంచు',
    'plateTemplates.fx.embers': 'నిప్పు రవ్వలు',
    'plateTemplates.fx.smoke': 'పొగ / మంచు తెర',
    'plateTemplates.fx.glitch': 'గ్లిచ్',
    'plateTemplates.fx.flare': 'లెన్స్ ఫ్లేర్',
    'plateTemplates.fx.confetti': 'కాన్ఫెటీ',
    'plateTemplates.fx.sparkle': 'మెరుపులు',
    'plateTemplates.fx.pulse': 'బ్రేకింగ్ పల్స్',
    'plateTemplates.fx.searchlight': 'సెర్చ్‌లైట్స్',
    'plateTemplates.fx.grain': 'ఫిల్మ్ గ్రెయిన్',
    'plateTemplates.fx.bokeh': 'బొకే లైట్లు',
    'plateTemplates.fx.dust': 'బంగారు ధూళి',
    'plateTemplates.transition.title': 'ప్రవేశం, నిష్క్రమణ',
    'plateTemplates.transition.hint': 'ప్రారంభంలో ప్లేట్ ఎలా వస్తుంది, చివర్లో ఎలా వెళ్తుంది (ప్యాకేజీలు, కథలు, డౌన్‌లోడ్‌లు).',
    'plateTemplates.transition.build': 'బిల్డ్ (డిఫాల్ట్)',
    'plateTemplates.transition.whip': 'విప్ జూమ్',
    'plateTemplates.transition.slide': 'ఎడమ నుంచి స్లైడ్',
    'plateTemplates.transition.slideright': 'కుడి నుంచి స్లైడ్',
    'plateTemplates.transition.slideup': 'కింద నుంచి స్లైడ్',
    'plateTemplates.transition.wipe': 'లైట్ వైప్',
    'plateTemplates.transition.flash': 'ఫ్లాష్',
    'plateTemplates.transition.blur': 'బ్లర్',
    'plateTemplates.transition.shutter': 'షట్టర్ బార్లు',
    'plateTemplates.transition.split': 'స్ప్లిట్',
    'plateTemplates.transition.glitch': 'గ్లిచ్',
    'plateTemplates.transition.fade': 'ఫేడ్',
    'plateTemplates.transition.none': 'ఏదీ లేదు (కట్)',
    'plateTemplates.times.ready': '{{time}} లో వాడటానికి సిద్ధం',
    'plateTemplates.times.animated': 'యానిమేషన్ {{time}}',
    'plateTemplates.createPromptLabel': 'ప్రాంప్ట్',
    'platePrompts.open': 'ఇష్టమైన & ఇటీవలి ప్రాంప్ట్‌లు',
    'platePrompts.title': 'ఇష్టమైన & ఇటీవలి ప్రాంప్ట్‌లు',
    'platePrompts.hint': 'ప్రతి ప్రాంప్ట్ దానితో తయారైన ప్లేట్‌తో. "వాడండి" ఆ ప్రాంప్ట్‌ను గ్రాఫిక్ ప్లేట్ సృష్టిలో పెడుతుంది — అక్కడ మార్చుకోవచ్చు.',
    'platePrompts.loading': 'ప్రాంప్ట్‌లు వస్తున్నాయి…',
    'platePrompts.favorites': 'మీ ఇష్టమైనవి',
    'platePrompts.labels': 'లేబుల్స్',
    'platePrompts.allLabels': 'అన్నీ',
    'platePrompts.search': 'ఇష్టమైనవాటిలో వెతకండి',
    'platePrompts.noFavorites': 'ఇంకా ఇష్టమైనవి లేవు. ★ ఇష్టమైనది తో ఒక ప్రాంప్ట్‌ను గుర్తించి లేబుల్ ఇవ్వండి — కింద, లేదా మీరు తెరిచే ఏ ప్లేట్‌లోనైనా.',
    'platePrompts.noMatch': 'సరిపోయే ఇష్టమైనది లేదు.',
    'platePrompts.recent': 'ఇటీవలి ప్రాంప్ట్‌లు',
    'platePrompts.recentHint': 'అందరివీ, తాజా 10',
    'platePrompts.noRecent': 'ఇంకా ఏ ప్లేటూ ప్రాంప్ట్‌తో తయారవలేదు.',
    'platePrompts.use': 'వాడండి',
    'platePrompts.favorite': 'ఇష్టమైనది',
    'platePrompts.favoriteHint': 'ఈ ప్లేట్ ప్రాంప్ట్‌ను లేబుల్‌తో ఇష్టమైనదిగా ఉంచండి',
    'platePrompts.isFavorite': 'ఇష్టమైనది: {{label}}. లేబుల్ మార్చడానికి లేదా తీసేయడానికి క్లిక్ చేయండి.',
    'platePrompts.addFavorite': 'ఇష్టమైనవాటిలో చేర్చండి',
    'platePrompts.addFavoriteTitle': 'ఈ ప్రాంప్ట్‌ను ఇష్టమైనదిగా ఉంచండి',
    'platePrompts.editFavorite': 'ఇష్టమైన ప్రాంప్ట్',
    'platePrompts.label': 'లేబుల్',
    'platePrompts.labelPlaceholder': 'లేబుల్, ఉదా. వర్షం, రాజకీయం, క్రికెట్',
    'platePrompts.labelHint': 'ఇష్టమైనవి లేబుల్ వారీగా ఉంటాయి. ఉన్నదాన్ని ఎంచుకోండి, లేదా కొత్తది రాయండి.',
    'platePrompts.saveLabel': 'సేవ్',
    'platePrompts.relabel': 'లేబుల్ మార్చండి',
    'platePrompts.remove': 'ఇష్టమైనవాటి నుంచి తీసేయండి',
    'platePrompts.removeConfirm': '"{{label}}" ను ఇష్టమైనవాటి నుంచి తీసేయాలా?',
    'platePrompts.savedOn': '{{date}} న సేవ్',
    'platePrompts.more': 'మొత్తం చూపండి',
    'platePrompts.less': 'తక్కువ చూపండి',
    'platePrompts.references': '{{count}} రిఫరెన్స్ చిత్రాలతో తయారైంది',
    'platePrompts.referencesHint': 'ఇలాంటి ఫలితం కోసం అలాంటి చిత్రాలను మళ్లీ జత చేయండి: అవి ప్రాంప్ట్‌తో ఉంచబడవు.',
    'platePrompts.replaceConfirm': 'మీరు రాసిన ప్రాంప్ట్ బదులు ఇది పెట్టాలా?',
    'plateTemplates.createNamePlaceholder': 'ఉదా: పొలిటికల్ వార్',
    'plateTemplates.remove': 'తొలగించు',
    'plateTemplates.previewVideo': 'వీడియోతో ప్రివ్యూ',
    'plateTemplates.previewOn': 'విండోల్లో నమూనా వీడియో చూపిస్తోంది — ఆపడానికి క్లిక్ చేయండి',
    'plateTemplates.previewOff': 'విండోల్లో నమూనా వీడియోతో ప్లేట్‌ను చూపించు',
    'plateTemplates.previewBuilding': 'నమూనా వీడియోను ప్లేట్‌లో పెడుతోంది… మొదటిసారి సుమారు ఒక నిమిషం.',
    'plateTemplates.previewFailed': 'ప్రివ్యూ తయారు కాలేదు.',
    'plateTemplates.retry': 'మళ్లీ ప్రయత్నించు',
    'plateTemplates.footage': 'నమూనా వీడియో (Wikimedia Commons):',
    'plateTemplates.removeConfirm': 'ఈ కస్టమ్ ప్లేట్‌ను తొలగించాలా? ఇది తిరిగి రాదు.',
    'plateTemplates.upload': 'ప్లేట్లు అప్‌లోడ్ చేయండి',
    'plateTemplates.uploadTitle': 'మీ గ్రాఫిక్ ప్లేట్లు అప్‌లోడ్ చేయండి',
    'plateTemplates.uploadHint': 'శీర్షిక లేని ప్లేట్‌ను అప్‌లోడ్ చేయండి — టెక్స్ట్ ప్యానెల్ ఖాళీగా ఉన్న వెర్షన్. ప్రతి ప్లేట్‌కు యానిమేషన్ (కెమెరా కదలిక, కాంతి మెరుపు) వస్తుంది, వార్తలో ఆ సీన్ వాక్యం ప్యానెల్‌లో రాయబడుతుంది.',
    'plateTemplates.uploadRules': '16:9 చిత్రాలు (ఉదా: 1920×1080 లేదా 1600×900), JPG, PNG లేదా WebP, ఒక్కోటి 15 MB వరకు. ఒకేసారి చాలా ఎంచుకోవచ్చు.',
    'plateTemplates.uploadChoose': 'చిత్రాలు ఎంచుకోండి',
    'plateTemplates.uploadChosen': '{{count}} ఎంచుకున్నారు',
    'plateTemplates.uploadCategory': 'విభాగం',
    'plateTemplates.uploadGo': 'అప్‌లోడ్',
    'plateTemplates.uploading': '{{total}}లో {{done}} అప్‌లోడ్ అవుతోంది…',
    'plateTemplates.uploadFailed': '"{{name}}": {{error}}',
    'plateTemplates.uploadedBadge': 'అప్‌లోడ్',
    'plateTemplates.createdBadge': 'సృష్టించినది',
    'plateTemplates.uploadRemoveConfirm': 'ఈ అప్‌లోడ్ చేసిన ప్లేట్‌ను తొలగించాలా? దీన్ని తిరిగి పొందలేరు.',
    'plateTemplates.edit': 'సవరించు',
    'plateTemplates.editTitle': 'ప్లేట్ సెట్ చేయండి',
    'plateTemplates.editHint': 'బాక్స్‌ను ప్లేట్ ఖాళీ టెక్స్ట్ ప్యానెల్ మీదకు లాగండి — వార్త పదాలు దాని లోపల వస్తాయి. పరిమాణం మార్చడానికి మూలను లాగండి.',
    'plateTemplates.editName': 'పేరు',
    'plateTemplates.editInk': 'అక్షరాల రంగు',
    'plateTemplates.ink.auto': 'ఆటోమేటిక్ ({{ink}})',
    'plateTemplates.ink.dark': 'ముదురు',
    'plateTemplates.ink.light': 'అంచుతో తెలుపు',
    'plateTemplates.editMotion': 'యానిమేషన్',
    'plateTemplates.motion.push': 'నెమ్మదిగా దగ్గరికి, దూరానికి',
    'plateTemplates.motion.drift': 'మెల్లగా పక్కకు కదలిక',
    'plateTemplates.motion.still': 'దాదాపు స్థిరంగా',
    'plateTemplates.editDust': 'తేలియాడే కాంతి కణాలు',
    'plateTemplates.save': 'సేవ్',
    'plateTemplates.saving': 'సేవ్ అవుతోంది…',
    'plateTemplates.previewWords': 'పదాలతో ప్రివ్యూ',
    'plateTemplates.previewWordsOn': 'ప్యానెల్‌లో నమూనా పదాలు చూపిస్తోంది — ఆపడానికి క్లిక్ చేయండి',
    'plateTemplates.previewWordsOff': 'ప్లేట్ ప్రారంభ యానిమేషన్, ప్యానెల్‌లో నమూనా పదాలతో చూపించు',
    'plateTemplates.previewWordsBuilding': 'నమూనా పదాలు ప్లేట్‌లో రాస్తోంది… కొన్ని సెకన్లు.',
    'plateTemplates.textArea': 'టెక్స్ట్ ప్రాంతం',
    'plateTemplates.font': 'ఫాంట్',
    'plateTemplates.viewPrompt': 'ప్రాంప్ట్ చూడండి',
    'plateTemplates.writePrompt': 'ప్రాంప్ట్ రాయండి',
    'plateTemplates.writingPrompt': 'ప్రాంప్ట్ రాస్తోంది…',
    'plateTemplates.promptFailed': 'ప్రాంప్ట్ రాయలేకపోయింది: {{error}}',
    'plateTemplates.changeWithPrompt': 'ప్రాంప్ట్‌తో మార్చండి',
    'plateTemplates.threadTitle': 'ఈ ప్లేట్‌ను మార్చండి',
    'plateTemplates.threadHint': 'ఏమి మార్చాలో రాయండి — మిగతాది అలాగే ఉంటుంది. ప్రతి మార్పు ఒక కొత్త వెర్షన్; ఏ వెర్షన్‌ను క్లిక్ చేసినా మళ్లీ చూపిస్తుంది.',
    'plateTemplates.versionOriginal': 'మొదటిది',
    'plateTemplates.version': 'వెర్షన్ {{n}}',
    'plateTemplates.versionCurrent': 'ఇప్పుడు చూపిస్తోంది',
    'plateTemplates.versionUse': 'ఈ వెర్షన్‌ను మళ్లీ చూపించు',
    'plateTemplates.changePlaceholder': 'ఉదా: టెక్స్ట్ ప్యానెల్ పెద్దదిగా చేసి కిందికి జరపండి; బ్యాక్‌గ్రౌండ్ ముదురుగా చేయండి',
    'plateTemplates.changeSend': 'పంపు',
    'plateTemplates.references': 'రిఫరెన్స్ చిత్రాలు',
    'plateTemplates.referenceAttach': 'రిఫరెన్స్ చిత్రాలు జత చేయండి ({{count}} వరకు) — ఉదా: పెట్టాల్సిన ఫోటో, లేదా అనుసరించాల్సిన శైలి',
    'plateTemplates.referenceRemove': 'ఈ చిత్రాన్ని తీసివేయండి',
    'plateTemplates.referenceMax': 'గరిష్టంగా {{count}} రిఫరెన్స్ చిత్రాలు జత చేయవచ్చు.',
    'plateTemplates.referenceType': 'రిఫరెన్స్ చిత్రాలు JPG, PNG లేదా WebP అయి ఉండాలి.',
    'plateTemplates.createReferences': 'రిఫరెన్స్ చిత్రాలు (ఐచ్ఛికం, {{count}} వరకు)',
    'plateTemplates.createReferencesHint': '{{max}}లో {{count}} — ఉదా: పెట్టాల్సిన వ్యక్తి లేదా ప్రదేశం ఫోటో, లేదా అనుసరించాల్సిన ప్లేట్ శైలి. వివరణ తప్పనిసరి.',
    'plateTemplates.createReferencesUsed': 'ఈ రిఫరెన్స్ చిత్రాలతో తయారైంది:',
    'plateTemplates.download.title': 'డౌన్‌లోడ్ (16:9, 1920×1080)',
    'plateTemplates.download.background': 'బ్యాక్‌గ్రౌండ్ చిత్రం',
    'plateTemplates.download.image': 'చిత్రం',
    'plateTemplates.download.video': 'వీడియో (MP4)',
    'plateTemplates.download.failed': 'డౌన్‌లోడ్ తయారు కాలేదు. మళ్లీ ప్రయత్నించండి.',
    'plateTemplates.download.making.video': 'Full HD వీడియో తయారవుతోంది…',
    'plateTemplates.download.making.images': 'చిత్రాలు తయారవుతున్నాయి… {{done}} / {{total}}',
    'plateTemplates.download.making.videos': 'వీడియోలు తయారవుతున్నాయి… {{done}} / {{total}}',
    'plateTemplates.pkg.open': 'ప్యాకేజ్',
    'plateTemplates.pkg.title': 'గ్రాఫిక్ ప్లేట్ ప్యాకేజ్',
    'plateTemplates.pkg.hint': 'ఒకే బ్యాక్‌గ్రౌండ్, ఒకటి లేదా రెండు టెక్స్ట్ ప్రాంతాలు, {{count}} వరకు టెక్స్ట్‌లు — ఒక్కో టెక్స్ట్‌కు ఒక ప్లేట్. ప్రతి ప్లేట్‌ను చిత్రంగా లేదా వీడియోగా డౌన్‌లోడ్ చేయండి.',
    'plateTemplates.pkg.saved': 'సేవ్ అయింది',
    'plateTemplates.pkg.new': 'కొత్త ప్యాకేజ్',
    'plateTemplates.pkg.view.preview': 'ప్రివ్యూ',
    'plateTemplates.pkg.view.areas': 'టెక్స్ట్ ప్రాంతాలు జరపండి',
    'plateTemplates.pkg.previewHint': 'ఎంచుకున్న టెక్స్ట్ ప్లేట్‌పై — డౌన్‌లోడ్ అయ్యే చిత్రం సరిగ్గా ఇలాగే. వీడియోల్లో పదాలు యానిమేషన్‌తో వస్తాయి.',
    'plateTemplates.pkg.areasHint': 'టెక్స్ట్ ప్రాంతాన్ని జరపడానికి బాక్స్‌ను లాగండి, పరిమాణం మార్చడానికి మూలను లాగండి. పదాల చుట్టూ కొంత ఖాళీ ఉంచండి.',
    'plateTemplates.pkg.drawing': 'తయారవుతోంది…',
    'plateTemplates.pkg.showing': 'టెక్స్ట్ {{n}}',
    'plateTemplates.pkg.area': 'టెక్స్ట్ ప్రాంతం {{n}}',
    'plateTemplates.pkg.removeArea': 'తీసివేయండి',
    'plateTemplates.pkg.addArea': 'రెండో టెక్స్ట్ ప్రాంతం జోడించండి',
    'plateTemplates.pkg.roleLabel': 'ఈ టెక్స్ట్ ప్రాంతంలో ఏమి ఉంటుంది',
    'plateTemplates.pkg.role.changes': 'ప్రతి ప్లేట్‌లో మారుతుంది',
    'plateTemplates.pkg.role.common': 'అన్ని ప్లేట్లలో ఒకటే',
    'plateTemplates.pkg.roleHint.changes': 'కింద ఉన్న ప్రతి టెక్స్ట్‌కు ఈ పదాలతో సొంత ప్లేట్ వస్తుంది.',
    'plateTemplates.pkg.roleHint.common': 'ఇక్కడ ఒకసారి రాయండి, ప్రతి ప్లేట్‌లో కనిపిస్తుంది (ఉదా: హెడ్డింగ్).',
    'plateTemplates.pkg.commonPlaceholder': 'ప్రతి ప్లేట్‌లో ఉండే పదాలు',
    'plateTemplates.pkg.inkAuto': 'ఆటోమేటిక్',
    'plateTemplates.pkg.texts': 'టెక్స్ట్‌లు',
    'plateTemplates.pkg.count': '{{max}}లో {{count}}',
    'plateTemplates.pkg.paste': 'జాబితా పేస్ట్ చేయండి',
    'plateTemplates.pkg.pasteHint': 'ఒక్కో లైన్‌కు ఒక టెక్స్ట్ — ప్రతి లైన్ ఒక ప్లేట్ అవుతుంది ({{count}} వరకు).',
    'plateTemplates.pkg.pasteHintTwo': 'ఒక్కో లైన్‌కు ఒక ప్లేట్; రెండు టెక్స్ట్ ప్రాంతాలను | తో వేరు చేయండి (ఉదా: "మొదటి ప్రాంతం | రెండో ప్రాంతం"). {{count}} వరకు.',
    'plateTemplates.pkg.pasteGo': 'వీటిని జోడించండి',
    'plateTemplates.pkg.tooMany': 'ఒక ప్యాకేజ్‌లో గరిష్టంగా {{count}} టెక్స్ట్‌లు — మిగిలినవి వదిలేశాం.',
    'plateTemplates.pkg.item': 'టెక్స్ట్ {{n}}',
    'plateTemplates.pkg.itemPlaceholder': 'టెక్స్ట్ {{n}} — తర్వాతి దానికి Enter నొక్కండి',
    'plateTemplates.pkg.show': 'ప్లేట్‌పై చూపించు',
    'plateTemplates.pkg.oneImage': 'ఈ ప్లేట్‌ను చిత్రంగా డౌన్‌లోడ్ చేయండి',
    'plateTemplates.pkg.oneVideo': 'ఈ ప్లేట్‌ను వీడియోగా డౌన్‌లోడ్ చేయండి',
    'plateTemplates.pkg.removeItem': 'ఈ టెక్స్ట్ తీసివేయండి',
    'plateTemplates.pkg.addText': 'టెక్స్ట్ జోడించండి',
    'plateTemplates.pkg.full': '{{count}} టెక్స్ట్‌లు — ఒక ప్యాకేజ్‌లో గరిష్టం',
    'plateTemplates.pkg.allCommon': 'అన్ని టెక్స్ట్ ప్రాంతాలు ప్రతి ప్లేట్‌లో ఒకటే, కాబట్టి ఈ ప్యాకేజ్ ఒక ప్లేట్ మాత్రమే చేస్తుంది. చాలా ప్లేట్లు కావాలంటే ఒక ప్రాంతాన్ని "ప్రతి ప్లేట్‌లో మారుతుంది"కి మార్చండి.',
    'plateTemplates.pkg.name': 'ప్యాకేజ్ పేరు',
    'plateTemplates.pkg.namePlaceholder': 'ఉదా: పల్లె పండుగ — 12 ప్లేట్లు',
    'plateTemplates.pkg.removeConfirm': 'సేవ్ చేసిన ఈ ప్యాకేజ్ తీసివేయాలా? ప్లేట్ అలాగే ఉంటుంది.',
    'plateTemplates.pkg.seconds': 'వీడియో నిడివి',
    'plateTemplates.pkg.secondsValue': '{{seconds}} సెకన్లు',
    'plateTemplates.pkg.image': 'చిత్రం డౌన్‌లోడ్',
    'plateTemplates.pkg.video': 'వీడియో డౌన్‌లోడ్',
    'plateTemplates.pkg.allImages': 'మొత్తం {{count}} చిత్రాలు (ZIP)',
    'plateTemplates.pkg.allVideos': 'మొత్తం {{count}} వీడియోలు (ZIP)',
    'plateTemplates.pkg.playingOf': 'టెక్స్ట్ {{n}} · {{count}}లో {{at}}',
    'plateTemplates.pkg.playAgain': 'మళ్లీ ప్లే చేయండి',
    'plateTemplates.pkg.restart': 'మొదటి నుండి',
    'plateTemplates.pkg.gettingReady': 'ప్లేట్లు సిద్ధమవుతున్నాయి…',
    'plateTemplates.pkg.previewAll': 'మొత్తం {{count}} ప్రివ్యూ',
    'plateTemplates.pkg.makingAll': 'అన్ని టెక్స్ట్‌ల ప్రివ్యూ తయారవుతోంది… {{done}} / {{total}}',
    'plateTemplates.pkg.oneVideoAll': 'మొత్తం {{count}} ఒకే వీడియోగా',
    'plateTemplates.download.making.combined': 'అన్ని ప్లేట్లతో ఒకే వీడియో తయారవుతోంది… {{done}} / {{total}}',
    'plateTemplates.download.making.previewAll': 'అన్ని టెక్స్ట్‌ల ప్రివ్యూ తయారవుతోంది… {{done}} / {{total}}',
    'plateTemplates.pkg.format': 'చిత్రాలు: JPG, 1920×1080. వీడియోలు: MP4, 1920×1080 (Full HD), 25 fps. చాలా ప్లేట్లు కలిపి ZIPగా వస్తాయి. AI క్రెడిట్లు ఖర్చు కావు.',
    'plateTemplates.download.making.preview': 'వీడియో ప్రివ్యూ తయారవుతోంది…',
    'plateTemplates.pkg.lineStyles': 'ప్రతి లైన్ పరిమాణం, రంగులు (Shift+Enterతో కొత్త లైన్)',
    'plateTemplates.pkg.sizeAuto': 'ఆటో పరిమాణం',
    'plateTemplates.pkg.sizeOld': '{{size}} (పాత పరిమాణం)',
    'plateTemplates.pkg.sizeHint': '1920×1080 ప్లేట్‌పై అక్షరాల పరిమాణం (పిక్సెల్స్). ఆటో: టెక్స్ట్ ఏరియాలో పట్టేంత పెద్దగా.',
    'plateTemplates.pkg.wordColours': 'పదాల రంగులు — ఒక పదానికి సొంత రంగు ఇవ్వడానికి దానిపై క్లిక్ చేయండి',
    'plateTemplates.pkg.wordColoursEmpty': 'ముందు టెక్స్ట్ రాయండి; దాని పదాలు ఇక్కడ కనిపిస్తాయి.',
    'plateTemplates.pkg.wordColour': '“{{word}}” రంగు',
    'plateTemplates.pkg.wordColourClear': 'మళ్లీ లైన్ రంగే వాడండి',
    'plateTemplates.pkg.styles': 'సేవ్ చేసిన టెక్స్ట్ స్టైల్స్',
    'plateTemplates.pkg.stylesPick': 'సేవ్ చేసిన టెక్స్ట్ స్టైల్ వాడండి…',
    'plateTemplates.pkg.stylesNone': 'ఇంకా సేవ్ చేసిన టెక్స్ట్ స్టైల్స్ లేవు',
    'plateTemplates.pkg.styleSave': 'స్టైల్ సేవ్',
    'plateTemplates.pkg.styleSaveHint': 'ఈ ఏరియా ఫాంట్, ఎఫెక్ట్, పరిమాణాలు, రంగులను ఏ ప్లేట్‌లోనైనా మళ్లీ వాడటానికి సేవ్ చేయండి',
    'plateTemplates.pkg.styleName': 'స్టైల్ పేరు',
    'plateTemplates.pkg.styleUpdate': 'అప్‌డేట్',
    'plateTemplates.pkg.styleRemoveConfirm': '“{{name}}” టెక్స్ట్ స్టైల్ తీసేయాలా? ఇప్పటికే చేసిన ప్లేట్ల రూపం మారదు.',
    'plateTemplates.pkg.line': 'లైన్ {{n}}',
    'plateTemplates.pkg.lineColour': 'లైన్ {{n}} రంగు',
    'plateTemplates.pkg.lineSize': 'లైన్ {{n}} పరిమాణం',
    'plateTemplates.pkg.lineHint': 'మరిన్ని లైన్లు (4 వరకు) జోడిస్తే, వాటికీ ఇక్కడ రంగు, పరిమాణం వస్తాయి.',
    'plateTemplates.pkg.withText': 'టెక్స్ట్‌తో',
    'plateTemplates.pkg.withoutText': 'టెక్స్ట్ లేకుండా',
    'plateTemplates.pkg.backToPicture': 'చిత్రానికి తిరిగి',
    'plateTemplates.pkg.makingVideo': 'టెక్స్ట్ {{n}} వీడియో తయారవుతోంది… (కొన్ని సెకన్లు)',
    'plateTemplates.pkg.playVideo': 'వీడియో ప్లే చేయండి (యానిమేషన్‌తో)',
    'plateTemplates.pkg.defaultAnim': 'యానిమేషన్',
    'plateTemplates.pkg.animDefault': 'యానిమేషన్: {{anim}} (అదే)',
    'plateTemplates.pkg.fontDefault': 'ఫాంట్: {{font}} (అదే)',
    'plateTemplates.pkg.secondsDefault': 'నిడివి: {{seconds}} సె (అదే)',
    'plateTemplates.pkg.itemAnim': 'టెక్స్ట్ {{n}} యానిమేషన్',
    'plateTemplates.pkg.itemFont': 'టెక్స్ట్ {{n}} ఫాంట్',
    'plateTemplates.pkg.itemSeconds': 'టెక్స్ట్ {{n}} వీడియో నిడివి',
    'plateTemplates.pkg.keysHint': 'Enter: తర్వాతి టెక్స్ట్ · Shift+Enter: అదే టెక్స్ట్‌లో కొత్త లైన్',
    'plateTemplates.anim.wipe': 'వైప్',
    'plateTemplates.anim.fade': 'ఫేడ్',
    'plateTemplates.anim.rise': 'పైకి లేచి',
    'plateTemplates.anim.pop': 'పాప్',
    'plateTemplates.anim.slide': 'స్లైడ్',
    'plateTemplates.anim.none': 'యానిమేషన్ లేదు',
    'plateTemplates.colour.auto': 'ఆటోమేటిక్',
    'plateTemplates.colour.white': 'తెలుపు',
    'plateTemplates.colour.silver': 'సిల్వర్',
    'plateTemplates.colour.gold': 'బంగారు',
    'plateTemplates.colour.yellow': 'పసుపు',
    'plateTemplates.colour.red': 'ఎరుపు',
    'plateTemplates.colour.black': 'నలుపు',
    'plateTemplates.colour.blue': 'నీలం',
    'plateTemplates.colour.custom': 'సొంత రంగు',
    'plateTemplates.colour.none': 'వద్దు',
    'plateTemplates.colour.fill': 'రంగు',
    'plateTemplates.colour.stroke': 'అంచు',
    'plateTemplates.colour.shadow': 'నీడ',
    'plateTemplates.colour.depth': '3D లోతు',
    'plateTemplates.shadow.title': 'నీడ (Photoshop లాంటి డ్రాప్ షాడో)',
    'plateTemplates.shadow.presets': 'త్వరిత లుక్స్',
    'plateTemplates.shadow.auto': 'ఆటో',
    'plateTemplates.shadow.none': 'వద్దు',
    'plateTemplates.shadow.soft': 'మెత్తని',
    'plateTemplates.shadow.hard': 'గట్టి అంచు',
    'plateTemplates.shadow.long': 'పొడవైన',
    'plateTemplates.shadow.glow': 'మెరుపు',
    'plateTemplates.shadow.double': 'రెండు నీడలు',
    'plateTemplates.shadow.n': 'డ్రాప్ షాడో {{n}}',
    'plateTemplates.shadow.add': 'రెండో నీడ జోడించండి',
    'plateTemplates.shadow.remove': 'ఈ నీడ తీసేయండి',
    'plateTemplates.shadow.blend': 'బ్లెండ్ మోడ్',
    'plateTemplates.shadow.colour': 'రంగు',
    'plateTemplates.shadow.opacity': 'ఒపాసిటీ',
    'plateTemplates.shadow.angle': 'కోణం',
    'plateTemplates.shadow.angleHint': 'వెలుగు ఎటు నుంచి: 90° = పై నుంచి, నీడ కింద పడుతుంది. డయల్‌పై క్లిక్ చేయండి లేదా లాగండి.',
    'plateTemplates.shadow.distance': 'దూరం',
    'plateTemplates.shadow.spread': 'స్ప్రెడ్',
    'plateTemplates.shadow.size': 'సైజు',
    'plateTemplates.shadow.noise': 'నాయిస్',
    'plateTemplates.shadow.hint': 'సైజులు 1920×1080 ప్లేట్‌పై పిక్సెల్స్‌లో. అవుట్‌లైన్ (స్ట్రోక్) నీడపై ఉంటుంది; సన్నని నీడ కనిపించాలంటే దాన్ని "వద్దు" చేయండి.',
    'plateTemplates.shadow.depth': '3D లోతు',
    'plateTemplates.shadow.depthSize': 'లోతు',
    'plateTemplates.shadow.depthAuto': 'ఆటో',
    'plateTemplates.shadow.depthAngle': 'వెలుగు దిశ',
    'plateTemplates.shadow.blend.normal': 'Normal',
    'plateTemplates.shadow.blend.multiply': 'Multiply',
    'plateTemplates.shadow.blend.screen': 'Screen',
    'plateTemplates.shadow.blend.overlay': 'Overlay',
    'plateTemplates.shadow.blend.darken': 'Darken',
    'plateTemplates.shadow.blend.lighten': 'Lighten',
    'plateTemplates.shadow.blend.color-burn': 'Color Burn',
    'plateTemplates.shadow.blend.color-dodge': 'Color Dodge',
    'plateTemplates.shadow.blend.hard-light': 'Hard Light',
    'plateTemplates.shadow.blend.soft-light': 'Soft Light',
    'plateTemplates.shadow.blend.difference': 'Difference',
    'plateTemplates.colour.looks': 'రెడీ లుక్స్',
    'plateTemplates.colour.used': 'ఎక్కువగా వాడినవి',
    'plateTemplates.colour.palette': 'రంగులు',
    'plateTemplates.colour.typeHint': '#FF8800 లేదా 255, 136, 0',
    'plateTemplates.colour.gradient': 'గ్రేడియంట్ (పై → కింద)',
    'plateTemplates.colour.gradientTo': 'కింది రంగు',
    'plateTemplates.blur.title': 'బ్లర్ ప్రాంతాలు',
    'plateTemplates.blur.hint': 'ప్లేట్‌లో కొంత భాగాన్ని బ్లర్ చేయండి — ముఖం, లోగో, రద్దీ మూల. ఆకారం ఎంచుకుని, ప్లేట్‌పై జరిపి పరిమాణం మార్చండి.',
    'plateTemplates.blur.plateHint': 'ఈ బ్లర్ ప్రాంతాలు ప్లేట్‌లో భాగం: ప్లేట్ ఎక్కడ వాడినా (వార్తలు, ప్యాకేజీలు, డౌన్‌లోడ్లు) కనిపిస్తాయి.',
    'plateTemplates.blur.add': '{{shape}} బ్లర్ జోడించండి',
    'plateTemplates.blur.label': 'బ్లర్ {{n}}',
    'plateTemplates.blur.remove': 'ఈ బ్లర్ ప్రాంతం తీసివేయండి',
    'plateTemplates.blur.shapeLabel': 'ఆకారం',
    'plateTemplates.blur.strengthLabel': 'తీవ్రత',
    'plateTemplates.blur.edgeLabel': 'అంచు',
    'plateTemplates.blur.shape.rect': 'దీర్ఘచతురస్రం',
    'plateTemplates.blur.shape.rounded': 'గుండ్రని మూలలు',
    'plateTemplates.blur.shape.square': 'చతురస్రం',
    'plateTemplates.blur.shape.ellipse': 'దీర్ఘవృత్తం',
    'plateTemplates.blur.shape.circle': 'వృత్తం',
    'plateTemplates.blur.strength.light': 'తేలికపాటి బ్లర్',
    'plateTemplates.blur.strength.medium': 'మధ్యస్థ బ్లర్',
    'plateTemplates.blur.strength.strong': 'బలమైన బ్లర్',
    'plateTemplates.blur.strength.pixelate': 'పిక్సెలేట్',
    'plateTemplates.blur.edge.sharp': 'పదునైన అంచు',
    'plateTemplates.blur.edge.soft': 'మృదువైన అంచు',
    'plateTemplates.blur.edge.softer': 'చాలా మృదువైన అంచు',
    'plateTemplates.setupView.areas': 'టెక్స్ట్ & బ్లర్ ప్రాంతాలు',
    'plateTemplates.setupView.preview': 'ప్రివ్యూ',
    'plateTemplates.search': 'పేరు, ట్యాగ్, తయారు చేసినవారు లేదా వర్గంతో వెతకండి',
    'plateTemplates.dates.label': 'మార్చిన తేదీ',
    'plateTemplates.dates.any': 'ఎప్పుడైనా',
    'plateTemplates.dates.today': 'ఈ రోజు',
    'plateTemplates.dates.7': 'గత 7 రోజులు',
    'plateTemplates.dates.30': 'గత 30 రోజులు',
    'plateTemplates.dates.custom': 'తేదీల మధ్య…',
    'plateTemplates.dates.from': 'నుండి',
    'plateTemplates.dates.to': 'వరకు',
    'plateTemplates.clearFilters': 'క్లియర్',
    'plateTemplates.found': '{{count}} దొరికాయి',
    'plateTemplates.noMatch': 'ఏ ప్లేట్లూ సరిపోలలేదు. వేరే పదాలు ప్రయత్నించండి, లేదా ఫిల్టర్లు క్లియర్ చేయండి.',
    'plateTemplates.showMore': 'మరిన్ని చూపించు ({{count}})',
    'plateTemplates.card.created': 'సృష్టించింది {{at}}',
    'plateTemplates.card.modified': 'మార్చింది {{at}}',
    'plateTemplates.card.builtIn': 'అంతర్నిర్మిత ప్లేట్',
    'plateTemplates.tags.add': 'ట్యాగ్‌లు జోడించండి',
    'plateTemplates.tags.placeholder': 'ట్యాగ్‌లు, కామాతో వేరు చేసి',
    'plateTemplates.tags.remove': '{{tag}} ట్యాగ్ తీసివేయండి',
    'plateTemplates.createTags': 'ట్యాగ్‌లు',
    'plateTemplates.optional': '(ఐచ్ఛికం)',
    'plateTemplates.createTagsHint': 'తర్వాత వెతికినప్పుడు ఈ ప్లేట్ దొరకడానికి పదాలు — ఉదా: ఎన్నికలు, AP, ర్యాలీ. కామాలతో వేరు చేయండి.',
    'plateTemplates.changeWorking': 'మార్పు చేస్తోంది… సుమారు ఒక నిమిషం',
    'plateTemplates.changeFailed': 'మార్పు చేయలేకపోయాం.',
    'plateTemplates.changeDone': 'వెర్షన్ {{n}} — ఇప్పుడు చూపిస్తోంది',
    'plateTemplates.changeCost': 'ప్రతి మార్పుకు ఒక AI చిత్రం (సుమారు $0.05). Ctrl+Enter తో పంపండి.',
    'plateTemplates.promptTitle': 'ఈ ప్లేట్ వెనుక ఉన్న ప్రాంప్ట్',
    'plateTemplates.promptHint': 'ఇలాంటి ప్లేట్ కోసం దీన్ని ఇమేజ్ జనరేటర్‌లో పేస్ట్ చేయండి (16:9, హై క్వాలిటీ). ప్యానెల్, లేబుల్ ఖాళీగా వస్తాయి — పదాలు తర్వాత వేస్తారు.',
    'plateTemplates.promptAvoid': 'రాకూడనివి:',
    'plateTemplates.promptParts': 'ఇది ఎందుకు బాగుంది',
    'plateTemplates.promptTips': 'సూచనలు',
    'plateTemplates.copyPrompt': 'ప్రాంప్ట్ కాపీ',
    'plateTemplates.copy': 'కాపీ',
    'plateTemplates.copied': 'కాపీ అయింది',
    'plateTemplates.createdEmpty': '"గ్రాఫిక్ ప్లేట్ సృష్టించు"తో మీరు చేసే ప్లేట్లు ఇక్కడ కనిపిస్తాయి.',
    'plateTemplates.textStyle': 'అక్షరాల శైలి',
    'plateTemplates.effect.flat': 'సాదా',
    'plateTemplates.effect.3d': '3D',
    'fullStoryVideo.noStories': 'ఇంకా ప్యాకేజీలు లేవు. ఒకటి మొదలుపెట్టి ఫుటేజ్ అప్‌లోడ్ చేయండి.',
    'fullStoryVideo.step.script': 'మెటీరియల్ & స్క్రిప్ట్',
    'fullStoryVideo.step.voice': 'వాయిస్ ఓవర్',
    'fullStoryVideo.step.images': 'సీన్లు',
    'fullStoryVideo.step.video': 'వీడియో',
    'fullStoryVideo.stepHint.script': 'ఫుటేజ్ అప్‌లోడ్ చేసి, AIతో ప్యాకేజీ రాయించండి లేదా మీ స్క్రిప్ట్ అతికించండి.',
    'fullStoryVideo.stepHint.voice': 'యాంకర్, వాయిస్ భాగాలు వాక్యం వాక్యంగా వాయిస్.',
    'fullStoryVideo.stepHint.images': 'ప్రతి లైన్‌కు సరిపోయే ఫుటేజ్, స్పాట్‌లు, బైట్‌లు, టెక్స్ట్ ప్లేట్లు.',
    'fullStoryVideo.stepHint.video': 'హెడర్, లొకేషన్, టాప్స్‌తో పూర్తి ప్యాకేజీ.',
    'fullStoryVideo.footage.title': 'ఫుటేజ్',
    'fullStoryVideo.footage.hint': 'ఒక్కో వీడియో 5 GB (సుమారు 3 గంటలు) వరకు — MP4, MOV, AVI, MXF, MKV, MTS, WMV మరియు ఇతర వీడియో ఫార్మాట్‌లు — ఫోటోలు కూడా. ప్రతి వీడియో ట్రాన్స్‌క్రైబ్ చేసి, షాట్ వారీగా చదవబడుతుంది.',
    'fullStoryVideo.notVideo': '"{{name}}" వీడియో ఫైల్ కాదు. MP4, MOV, AVI, MXF, MKV, MTS, WMV లేదా ఇతర వీడియో ఫార్మాట్ వాడండి.',
    'fullStoryVideo.footage.uploadVideos': 'వీడియోలు అప్‌లోడ్',
    'fullStoryVideo.footage.addPhotos': 'ఫోటోలు జోడించండి',
    'fullStoryVideo.footage.none': 'ఇంకా ఫుటేజ్ లేదు.',
    'fullStoryVideo.footage.photo': 'ఫోటో',
    'fullStoryVideo.footage.ready': 'సిద్ధం',
    'fullStoryVideo.footage.read': '{{moments}} క్షణాలు · {{lines}} మాటలు',
    'fullStoryVideo.footage.incomplete': 'అప్‌లోడ్ పూర్తి కాలేదు — తీసివేసి మళ్లీ అప్‌లోడ్ చేయండి.',
    'fullStoryVideo.footage.removeConfirm': '"{{name}}"ను ఈ ప్యాకేజీ నుంచి తీసివేయాలా?',
    'fullStoryVideo.footage.uploadingHint': 'అప్‌లోడ్‌లు పూర్తయ్యే వరకు ఈ పేజీని తెరిచి ఉంచండి.',
    'fullStoryVideo.notes.title': 'స్క్రిప్ట్ కోసం నోట్స్',
    'fullStoryVideo.notes.placeholder': 'కథ ఏమిటి? పేర్లు, ప్రదేశాలు, వాస్తవాలు, మీకు కావలసిన కోణం — ఫుటేజ్‌లో చెప్పిన మాటలతో కలిపి AI వాడుతుంది.',
    'fullStoryVideo.length': 'నిడివి',
    'fullStoryVideo.minutes': 'నిమిషాలు',
    'fullStoryVideo.minutesRange': '1 నుంచి 30 నిమిషాల మధ్య.',
    'fullStoryVideo.tooBig': '"{{name}}" చాలా పెద్దది — వీడియోలు 5 GB వరకు మాత్రమే.',
    'fullStoryVideo.uploadFailed': 'అప్‌లోడ్ విఫలమైంది. కనెక్షన్ చూసి మళ్లీ ప్రయత్నించండి.',
    'fullStoryVideo.script.title': 'స్క్రిప్ట్',
    'fullStoryVideo.script.hint': 'నోట్స్, ఫుటేజ్ నుంచి AIతో రాయించండి, లేదా పూర్తి స్క్రిప్ట్ (Sk, tops, location, header, Anchor, Voice, gfx, ...spot...) అతికించండి — ఉన్నది ఉన్నట్టే వాడతాం.',
    'fullStoryVideo.script.placeholder': 'ప్యాకేజీ స్క్రిప్ట్ ఇక్కడ అతికించండి, లేదా "AIతో రాయండి" నొక్కండి.',
    'fullStoryVideo.script.write': 'AIతో రాయండి',
    'fullStoryVideo.script.rewrite': 'AIతో మళ్లీ రాయండి',
    'fullStoryVideo.script.waitFootage': 'AI వాడేందుకు ఫుటేజ్ చదవడం పూర్తయ్యే వరకు ఆగండి.',
    'fullStoryVideo.script.approve': 'స్క్రిప్ట్ ఆమోదించండి',
    'fullStoryVideo.script.approveHint': 'యాంకర్, వాయిస్ భాగాలకే వాయిస్; స్పాట్‌లు, బైట్‌లు, gfx ఫుటేజ్ నుంచి వస్తాయి.',
    'fullStoryVideo.script.approved': 'స్క్రిప్ట్ ఆమోదించబడింది',
    'fullStoryVideo.preview.title': 'ప్యాకేజీ ఇలా ఉంటుంది',
    'fullStoryVideo.preview.empty': 'ప్యాకేజీ చూడటానికి స్క్రిప్ట్ అతికించండి లేదా రాయించండి.',
    'fullStoryVideo.preview.header': 'హెడర్',
    'fullStoryVideo.preview.location': 'లొకేషన్',
    'fullStoryVideo.preview.tops': '{{count}} టాప్స్',
    'fullStoryVideo.preview.sentences': 'వాయిస్ చేయాల్సిన {{count}} వాక్యాలు',
    'fullStoryVideo.block.anchor': 'యాంకర్',
    'fullStoryVideo.block.voice': 'వాయిస్ ఓవర్',
    'fullStoryVideo.block.spot': 'స్పాట్',
    'fullStoryVideo.block.byte': 'బైట్',
    'fullStoryVideo.block.gfx': 'గ్రాఫిక్స్',
    'fullStoryVideo.stage.waiting': 'వేచి ఉంది',
    'fullStoryVideo.stage.checking': 'తనిఖీ',
    'fullStoryVideo.stage.preparing': 'సిద్ధం చేస్తోంది',
    'fullStoryVideo.stage.converting': 'మారుస్తోంది',
    'fullStoryVideo.stage.transcribing': 'ట్రాన్స్‌క్రైబ్ చేస్తోంది',
    'fullStoryVideo.stage.finding shots': 'షాట్లు వెతుకుతోంది',
    'fullStoryVideo.stage.describing': 'షాట్లు చదువుతోంది',
    'fullStoryVideo.stage.indexing': 'ఇండెక్స్ చేస్తోంది',
    'fullStoryVideo.scenes.title': 'సీన్లు',
    'fullStoryVideo.scenes.hint': 'ప్రతి వాయిస్ లైన్‌కు సరిపోయే ఫుటేజ్; స్పాట్‌లు, బైట్‌లు అసలు శబ్దంతో; gfx లైన్లు టెక్స్ట్ ప్లేట్లుగా.',
    'fullStoryVideo.scenes.instructions': 'ప్లానర్‌కు ఏమైనా చెప్పాలా? (ఐచ్ఛికం)',
    'fullStoryVideo.scenes.plan': 'ఫుటేజ్ సరిపోల్చండి',
    'fullStoryVideo.scenes.replan': 'మళ్లీ సరిపోల్చండి',
    'fullStoryVideo.scenes.replanConfirm': 'అన్ని సీన్లు మళ్లీ సరిపోల్చాలా? మీ మార్పులు పోతాయి.',
    'fullStoryVideo.scenes.planning': 'ఫుటేజ్ సరిపోలుస్తోంది…',
    'fullStoryVideo.scenes.waitFootage': 'అన్ని ఫుటేజ్ చదవడం పూర్తయ్యే వరకు ఆగండి.',
    'fullStoryVideo.scenes.runningTime': 'నిడివి {{time}} · {{count}} సీన్లు',
    'fullStoryVideo.scenes.missing': '{{count}} సీన్లకు ఇంకా ఫుటేజ్ లేదా చిత్రం కావాలి.',
    'fullStoryVideo.scenes.allReady': 'అన్ని సీన్లు సిద్ధం.',
    'fullStoryVideo.scenes.approve': 'సీన్లు ఆమోదించండి',
    'fullStoryVideo.scene.chooseFootage': 'ఫుటేజ్ ఎంచుకోండి',
    'fullStoryVideo.scene.aiPicture': 'AI చిత్రం',
    'fullStoryVideo.scene.webPhoto': 'వెబ్ ఫోటో',
    'fullStoryVideo.scene.upload': 'అప్‌లోడ్',
    'fullStoryVideo.scene.editPlate': 'టెక్స్ట్ మార్చండి',
    'fullStoryVideo.scene.removeConfirm': 'ఈ సీన్‌ను ప్యాకేజీ నుంచి తీసివేయాలా?',
    'fullStoryVideo.scene.fromFootage': '{{name}} — {{at}}',
    'fullStoryVideo.scene.fromRange': '{{name}} {{from}}–{{to}}',
    'fullStoryVideo.scene.source.ai': 'AI చిత్రం',
    'fullStoryVideo.scene.source.web': 'వెబ్ ఫోటో',
    'fullStoryVideo.scene.source.upload': 'మీ అప్‌లోడ్',
    'fullStoryVideo.scene.source.stock': 'స్టాక్',
    'fullStoryVideo.scene.source.gfx': 'టెక్స్ట్ ప్లేట్',
    'fullStoryVideo.scene.source.footage': 'ఫుటేజ్',
    'fullStoryVideo.scene.briefPlaceholder': 'మీకు కావలసిన చిత్రాన్ని వివరించండి.',
    'fullStoryVideo.scene.makePicture': 'చిత్రం తయారు చేయండి',
    'fullStoryVideo.scene.searchPlaceholder': 'వెబ్‌లో ఫోటో వెతకండి',
    'fullStoryVideo.scene.search': 'వెతకండి',
    'fullStoryVideo.scene.seconds': 'సెకన్లు',
    'fullStoryVideo.scene.platePhoto': 'ఫుటేజ్ నుంచి ప్లేట్ ఫోటో',
    'fullStoryVideo.scene.platePhotoUpload': 'ప్లేట్ ఫోటో అప్‌లోడ్',
    'fullStoryVideo.look.title': 'లుక్ & మ్యూజిక్',
    'fullStoryVideo.look.hint': 'ఫుటేజ్ ఫుల్ స్క్రీన్‌లో; అన్ని బ్రేకింగ్ ప్లేట్‌లకు ఒకే డిజైన్; ప్రతి భాగం కింద మ్యూజిక్, ప్లేట్‌లపై పెరుగుతుంది — కింద ప్రతి సీన్‌కు మార్చవచ్చు.',
    'fullStoryVideo.look.editText': 'ప్లేట్ కిక్కర్',
    'fullStoryVideo.look.autoMusic': 'బ్యాక్‌గ్రౌండ్ మ్యూజిక్',
    'fullStoryVideo.look.musicVolume': 'మ్యూజిక్ స్థాయి',
    'fullStoryVideo.look.kicker': 'ప్లేట్ కిక్కర్',
    'fullStoryVideo.look.plateDesign': 'బ్రేకింగ్ ప్లేట్ డిజైన్',
    'fullStoryVideo.look.plateAuto': 'ఈ స్టోరీకి ఆటోమేటిక్‌గా ఎంచుకున్నది — వీడియోలోని ప్రతి ప్లేట్‌కి ఇదే.',
    'fullStoryVideo.look.plateChosen': 'మీరు ఎంచుకున్నది — వీడియోలోని ప్రతి ప్లేట్‌కి ఇదే.',
    'fullStoryVideo.look.plateChange': 'డిజైన్ మార్చు',
    'fullStoryVideo.look.plateHint': 'ఈ వీడియోలోని అన్ని ప్లేట్‌లకు ఒకే డిజైన్.',
    'fullStoryVideo.look.plateAutoUse': 'ఆటోమేటిక్‌గా ఎంచుకో',
    'fullStoryVideo.look.cancel': 'రద్దు',
    'fullStoryVideo.music.none': 'మ్యూజిక్ లేదు',
    'fullStoryVideo.music.custom': 'మీరు అప్‌లోడ్ చేసిన ట్రాక్',
    'fullStoryVideo.music.listen': 'వినండి',
    'fullStoryVideo.music.forPart': 'ఈ భాగం మొత్తానికి మ్యూజిక్',
    'fullStoryVideo.music.ownSound': 'అసలు శబ్దం (మ్యూజిక్ లేదు)',
    'fullStoryVideo.frame.title': 'ఓవర్‌లే ఫ్రేమ్',
    'fullStoryVideo.frame.add': 'ఫ్రేమ్',
    'fullStoryVideo.frame.change': 'ఫ్రేమ్ మార్చండి',
    'fullStoryVideo.frame.remove': 'ఫ్రేమ్ తీసివేయండి',
    'fullStoryVideo.frame.use': 'ఈ ఫ్రేమ్ వాడండి',
    'fullStoryVideo.frame.opacity': 'పారదర్శకత',
    'fullStoryVideo.frame.search': 'ఫ్రేమ్‌లు వెతకండి (మంటలు, దీపావళి, పోలీస్…)',
    'fullStoryVideo.frame.preparing': 'ప్రివ్యూ సిద్ధమవుతోంది…',
    'fullStoryVideo.frame.category.festival': 'పండుగలు',
    'fullStoryVideo.frame.category.celebration': 'వేడుకలు',
    'fullStoryVideo.frame.category.fire': 'మంటలు & ప్రమాదం',
    'fullStoryVideo.frame.category.film': 'ఫిల్మ్ & టెక్స్చర్',
    'fullStoryVideo.frame.category.alert': 'అలర్ట్‌లు',
    'fullStoryVideo.frame.category.emotion': 'భావోద్వేగం & నివాళి',
    'fullStoryVideo.frame.category.nature': 'వాతావరణం & ప్రకృతి',
    'fullStoryVideo.frame.category.tech': 'టెక్నాలజీ & డబ్బు',
    'fullStoryVideo.picker.title': 'ఈ లైన్‌కు ఫుటేజ్ ఎంచుకోండి',
    'fullStoryVideo.picker.titleRange': 'స్పాట్ ఎక్కడ మొదలై ఎక్కడ ముగుస్తుందో ఎంచుకోండి',
    'fullStoryVideo.picker.noFootage': 'ఇంకా ఫుటేజ్ సిద్ధంగా లేదు.',
    'fullStoryVideo.picker.noSoundFootage': 'శబ్దం ఉన్న వీడియో ఇంకా సిద్ధంగా లేదు.',
    'fullStoryVideo.picker.start': 'మొదలు (సె)',
    'fullStoryVideo.picker.end': 'ముగింపు (సె)',
    'fullStoryVideo.picker.useNowStart': 'ఇక్కడ మొదలు',
    'fullStoryVideo.picker.useNowEnd': 'ఇక్కడ ముగింపు',
    'fullStoryVideo.picker.length': '{{seconds}} సె',
    'fullStoryVideo.picker.play': 'ప్లే',
    'fullStoryVideo.picker.use': 'ఇది వాడండి',
    'fullStoryVideo.picker.search': 'క్షణాలు వెతకండి (కనిపించేది లేదా మాట్లాడేది)',
    'features.noAccessTitle': 'మీ ఖాతాకు {{feature}} ఆన్ చేయబడలేదు',
    'features.noAccessDesc': 'యూజర్ మేనేజ్‌మెంట్‌లో దీన్ని ఆన్ చేయమని మీ అడ్మినిస్ట్రేటర్ లేదా మేనేజర్‌ను అడగండి.',
    'mediaAI.title': 'మీడియా AI',
    'mediaAI.desc': 'ఇమేజ్ లేదా వీడియోను వివరించండి, లేదా ఫోటోలు, వీడియోలు జత చేసి వాటి ఆధారంగా తయారు చేయించండి',
    'mediaAI.newChat': 'కొత్త చాట్',
    'mediaAI.chats': 'చాట్‌లు',
    'mediaAI.loadingChats': 'చాట్‌లు లోడ్ అవుతున్నాయి…',
    'mediaAI.noChats': 'ఇంకా చాట్‌లు లేవు. కింద ఒకటి ప్రారంభించండి.',
    'mediaAI.emptyTitle': 'నేను ఏమి తయారు చేయాలి?',
    'mediaAI.emptyDesc': 'మీకు కావలసిన ఇమేజ్ లేదా వీడియోను వివరించండి — తెలుగు, ఇంగ్లీష్ లేదా ఏ భాషలోనైనా. ఎడిట్ చేయడానికి, కలపడానికి, యానిమేట్ చేయడానికి లేదా రిఫరెన్స్‌గా వాడటానికి ఫోటోలు లేదా వీడియోలు జత చేయండి.',
    'mediaAI.inputPlaceholder': 'మీకు కావలసిన ఇమేజ్ లేదా వీడియోను వివరించండి…',
    'mediaAI.send': 'పంపు',
    'mediaAI.waitForResult': 'ప్రస్తుత అభ్యర్థన పూర్తయ్యే వరకు వేచి ఉండండి',
    'mediaAI.attach': 'ఇమేజ్‌లు లేదా వీడియోలు జత చేయండి',
    'mediaAI.removeFile': 'తీసివేయి',
    'mediaAI.dropHere': 'జత చేయడానికి ఇమేజ్‌లు లేదా వీడియోలను ఇక్కడ వదలండి',
    'mediaAI.creating': 'తయారవుతోంది…',
    'mediaAI.creatingHint': 'ఇమేజ్‌లకు సుమారు ఒక నిమిషం, వీడియోలకు నిడివిని బట్టి 5 నుండి 20 నిమిషాలు పడుతుంది',
    'mediaAI.failed': 'జనరేషన్ విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.',
    'mediaAI.generatedAlt': 'జనరేట్ చేసిన ఇమేజ్',
    'mediaAI.download': 'డౌన్‌లోడ్',
    'mediaAI.disclaimer': 'ఇమేజ్‌లు, వీడియోలు AI ద్వారా తయారైనవి — ప్రచురించే ముందు సరిచూసుకోండి.',
    'mediaAI.deleteConfirm': 'ఈ చాట్‌ను, ఇందులో తయారైన వాటన్నింటినీ తొలగించాలా? దీన్ని వెనక్కి తీసుకోలేరు.',
    'mediaAI.deleteChat': 'చాట్ తొలగించు',
    'mediaAI.deleteFailed': 'ఈ చాట్‌ను తొలగించలేకపోయాం.',
    'mediaAI.loadFailed': 'ఈ చాట్‌ను లోడ్ చేయలేకపోయాం.',
    'mediaAI.myChats': 'నా చాట్‌లు',
    'mediaAI.team': 'టీమ్',
    'mediaAI.searchUser': 'యూజర్ పేరుతో వెతకండి…',
    'mediaAI.noTeamChats': 'చాట్‌లు ఏవీ కనిపించలేదు.',
    'mediaAI.viewingAs': 'చూస్తున్నారు',
    'mediaAI.readOnly': 'చదవడానికి మాత్రమే',
    'mediaAI.unsupportedFile': '"{{name}}" సపోర్ట్ చేయబడే ఇమేజ్ లేదా వీడియో కాదు.',
    'mediaAI.fileTooLarge': '"{{name}}" 200 MB కంటే పెద్దది.',
    'mediaAI.tooManyFiles': 'ఒక మెసేజ్‌కు గరిష్టంగా {{max}} ఫైల్‌లు జత చేయవచ్చు.',
    'mediaAI.noAccessTitle': 'మీ ఖాతాకు మీడియా AI ఆన్ చేయబడలేదు',
    'mediaAI.noAccessDesc': 'యూజర్ మేనేజ్‌మెంట్‌లో దీన్ని ఆన్ చేయమని మీ అడ్మినిస్ట్రేటర్‌ను అడగండి.',
    'header.mediaAIProviders': 'మీడియా AI ప్రొవైడర్లు',
    'mediaAI.imagesBy': 'ఇమేజ్‌లు తయారు చేసేది',
    'mediaAI.madeWith': '{{provider}} తో తయారైంది',
    'mediaAI.downloadVideo': 'వీడియో డౌన్‌లోడ్',
    'mediaAI.tryAgain': 'మళ్లీ ప్రయత్నించు',
    'mediaAI.shape': 'ఆకారం',
    'mediaAI.edit': 'ఎడిట్',
    'mediaAI.useInChat': 'తదుపరి అభ్యర్థనలో వాడు',
    'mediaAI.referenceAdded': 'ఇమేజ్ మీ తదుపరి అభ్యర్థనకు జోడించబడింది',
    'mediaAI.fromWeb': 'వెబ్‌లో దొరికినవి — ప్రచురించే ముందు మూలం, వినియోగ హక్కులు సరిచూసుకోండి.',
    'mediaAI.viewSource': 'మూలం',
    'mediaAI.editor.title': 'ఇమేజ్ ఎడిట్',
    'mediaAI.editor.adjust': 'సర్దుబాటు',
    'mediaAI.editor.resize': 'సైజ్ మార్చు',
    'mediaAI.editor.blur': 'బ్లర్',
    'mediaAI.editor.removeBg': 'బ్యాక్‌గ్రౌండ్ తొలగించు',
    'mediaAI.editor.removeObject': 'వస్తువు తొలగించు',
    'mediaAI.editor.brightness': 'ప్రకాశం',
    'mediaAI.editor.contrast': 'కాంట్రాస్ట్',
    'mediaAI.editor.saturation': 'రంగు గాఢత',
    'mediaAI.editor.sharpness': 'షార్ప్‌నెస్',
    'mediaAI.editor.reset': 'రీసెట్',
    'mediaAI.editor.crop': 'క్రాప్',
    'mediaAI.editor.extend': 'AI తో విస్తరించు',
    'mediaAI.editor.custom': 'కస్టమ్',
    'mediaAI.editor.width': 'వెడల్పు',
    'mediaAI.editor.height': 'ఎత్తు',
    'mediaAI.editor.cropDragHint': 'ఏ భాగం ఉంచాలో ఫ్రేమ్‌ను లాగి ఎంచుకోండి.',
    'mediaAI.editor.extendHint': 'ఇమేజ్ చుట్టూ అదనపు భాగాన్ని AI నింపుతుంది; అసలు ఇమేజ్ మారదు.',
    'mediaAI.editor.blurAll': 'మొత్తం ఇమేజ్',
    'mediaAI.editor.blurSelection': 'పెయింట్ చేసిన భాగం',
    'mediaAI.editor.blurBackground': 'బ్యాక్‌గ్రౌండ్ (AI)',
    'mediaAI.editor.amount': 'పరిమాణం',
    'mediaAI.editor.paintHint': 'మౌస్ లేదా వేలితో ఆ భాగంపై పెయింట్ చేయండి.',
    'mediaAI.editor.brushSize': 'బ్రష్ సైజ్',
    'mediaAI.editor.undo': 'అన్‌డూ',
    'mediaAI.editor.clear': 'క్లియర్',
    'mediaAI.editor.removeBgHint': 'AI ప్రధాన భాగాన్ని కత్తిరించి బ్యాక్‌గ్రౌండ్‌ను పారదర్శకంగా (PNG) చేస్తుంది.',
    'mediaAI.editor.objectDescription': 'అది ఏమిటి? (ఐచ్ఛికం — ఉదా. "ఎడమవైపు ఉన్న వ్యక్తి")',
    'mediaAI.editor.aiNote': 'AI వాడుతుంది — సుమారు ఒక నిమిషం పడుతుంది.',
    'mediaAI.editor.apply': 'అప్లై',
    'mediaAI.editor.applying': 'అప్లై చేస్తోంది…',
    'mediaAI.editor.paintFirst': 'ముందుగా ఆ భాగంపై పెయింట్ చేయండి.',
    'mediaAI.editor.failed': 'ఎడిట్ అప్లై చేయలేకపోయాం.',
    'mediaProviders.title': 'మీడియా AI ప్రొవైడర్లు',
    'mediaProviders.subtitle': 'మీడియా AI లో ఇమేజ్‌లు, వీడియోలు తయారు చేసే సేవల క్రెడెన్షియల్స్',
    'mediaProviders.openaiUse': 'ఇమేజ్‌లు, మరియు ప్రతి అభ్యర్థనను అర్థం చేసుకోవడం',
    'mediaProviders.openaiNote': 'యాప్‌కు ఇప్పటికే సెటప్ చేసిన OpenAI కీని వాడుతుంది. ఇక్కడ ఏమీ నమోదు చేయాల్సిన అవసరం లేదు.',
    'mediaProviders.freepikUse': 'ఇమేజ్‌లు మరియు వీడియోలు',
    'mediaProviders.connected': 'కనెక్ట్ అయింది',
    'mediaProviders.notConnected': 'కనెక్ట్ కాలేదు',
    'mediaProviders.loading': 'లోడ్ అవుతోంది…',
    'mediaProviders.storedKey': 'నిల్వ చేసిన కీ:',
    'mediaProviders.updatedBy': '{{name}} సేవ్ చేశారు',
    'mediaProviders.apiKey': 'API కీ',
    'mediaProviders.apiKeyPlaceholder': 'Freepik API కీని పేస్ట్ చేయండి',
    'mediaProviders.keepBlank': 'నిల్వ చేసిన విలువను ఉంచడానికి ఖాళీగా వదిలేయండి',
    'mediaProviders.webhookSecret': 'వెబ్‌హుక్ సైనింగ్ సీక్రెట్',
    'mediaProviders.optional': '(ఐచ్ఛికం)',
    'mediaProviders.webhookHint': 'తర్వాత వాడటానికి నిల్వ చేయబడుతుంది. మీడియా AI ప్రస్తుతం ఫలితాల కోసం Freepik ను తానే తనిఖీ చేస్తుంది, కాబట్టి వెబ్‌హుక్‌లు లేకుండానే పనిచేస్తుంది.',
    'mediaProviders.save': 'సేవ్',
    'mediaProviders.checking': 'కీని తనిఖీ చేస్తోంది…',
    'mediaProviders.saved': 'Freepik క్రెడెన్షియల్స్ సేవ్ అయ్యాయి',
    'mediaAI.videoModel': 'వీడియో',
    'mediaAI.stop': 'ఆపు',
    'mediaAI.stopped': 'మీరు ఈ అభ్యర్థనను ఆపారు.',
    'mediaAI.stopFailed': 'అభ్యర్థనను ఆపలేకపోయాం. మళ్లీ ప్రయత్నించండి.',
    'mediaAI.copy': 'కాపీ',
    'mediaAI.copied': 'కాపీ అయింది',
    'mediaAI.editMessage': 'మెసేజ్ మార్చు',
    'mediaAI.cancel': 'రద్దు',
    'mediaAI.previousVersion': 'మునుపటి వెర్షన్',
    'mediaAI.nextVersion': 'తదుపరి వెర్షన్',
    'mediaAI.games.title': 'వేచి ఉన్నప్పుడు ఆడండి',
    'mediaAI.games.best': 'బెస్ట్',
    'mediaAI.games.aria': '{{game}} గేమ్ — క్లిక్ చేసి కీబోర్డ్ లేదా మౌస్‌తో ఆడండి',
    'mediaAI.games.playing': 'ఆడుతున్నారు — కీలు గేమ్‌ను నడుపుతాయి. టైప్ చేయడానికి మెసేజ్ బాక్స్‌పై క్లిక్ చేయండి.',
    'mediaAI.games.clickToPlay': 'కీబోర్డ్‌తో ఆడటానికి గేమ్‌పై క్లిక్ చేయండి, లేదా మౌస్‌తో ఆడండి.',
    'mediaAI.games.hide': 'గేమ్ దాచు',
    'mediaAI.games.show': 'గేమ్ ఆడండి',
    'mediaProviders.videoTitle': 'వీడియో',
    'mediaProviders.videoDesc': 'మీరు వాడాలనుకునే ప్రతి వీడియో ప్రొవైడర్‌కు కీ జోడించండి. కీ ఉన్న ప్రతి మోడల్ Media AI లోని వీడియో డ్రాప్‌డౌన్‌లో కనిపిస్తుంది. ధరలు ప్రొవైడర్ల సొంత ధరలు.',
    'mediaProviders.videoBudget': 'రోజువారీ వీడియో బడ్జెట్',
    'mediaProviders.videoBudgetDesc': 'టీమ్ మొత్తం రోజుకు వీడియోపై ఖర్చు చేయగల గరిష్ఠం. దీన్ని దాటే వీడియో తయారవదు.',
    'mediaProviders.spentToday': 'ఈరోజు ${{spent}} ఖర్చయింది',
    'mediaProviders.dailyLimit': 'రోజువారీ పరిమితి',
    'mediaProviders.budgetSaved': 'రోజువారీ వీడియో బడ్జెట్ సేవ్ అయింది',
    'mediaProviders.keySaved': 'కీ సేవ్ అయింది',
    'mediaProviders.model': 'మోడల్',
    'mediaProviders.usingServerKey': 'సర్వర్ Gemini కీ (GEMINI_API_KEY) వాడుతోంది. వేరే కీ వాడాలంటే ఇక్కడ జోడించండి.',
    'mediaProviders.replaceKey': 'నిల్వ ఉన్న కీని మార్చడానికి కొత్త కీ అతికించండి',
    'mediaProviders.whereToGet': '{{where}} నుంచి పొందండి.',
    'mediaProviders.alibabaHost': 'Model Studio చిరునామా',
    'mediaProviders.alibabaHostHint': 'అంతర్జాతీయ (సింగపూర్) చిరునామా కోసం ఖాళీగా వదలండి. సొంత చిరునామా ఉన్న వర్క్‌స్పేస్‌లు దాన్ని Model Studio లో చూపిస్తాయి.',
    'mediaProviders.removeVideoConfirm': '{{provider}} కీని తొలగించాలా? దాని మోడల్స్ Media AI నుంచి తొలగిపోతాయి.',
    'mediaProviders.saving': 'సేవ్ అవుతోంది…',
    'mediaProviders.saveFailed': 'క్రెడెన్షియల్స్ సేవ్ చేయలేకపోయాం',
    'mediaProviders.remove': 'క్రెడెన్షియల్స్ తొలగించు',
    'mediaProviders.removeConfirm': 'Freepik క్రెడెన్షియల్స్ తొలగించాలా? కీని మళ్లీ జోడించే వరకు వీడియో జనరేషన్, Freepik ఇమేజ్‌లు పనిచేయవు.',
    'mediaProviders.removed': 'Freepik క్రెడెన్షియల్స్ తొలగించబడ్డాయి',
    'mediaProviders.restrictedTitle': 'యాక్సెస్ పరిమితం',
    'mediaProviders.restrictedDesc': 'మీడియా AI ప్రొవైడర్ సెట్టింగ్‌లు అడ్మిన్‌లకు మాత్రమే అందుబాటులో ఉంటాయి.',
    'anchorFormats.tab.visual': 'యాంకర్ విజువల్',
    'anchorFormats.tab.visualByte': 'యాంకర్ విజువల్ బైట్',
    'anchorFormats.tab.byte': 'యాంకర్ బైట్',
    'anchorFormats.tab.package': 'యాంకర్ ప్యాకేజ్',
    'anchorFormats.tab.live': 'యాంకర్ లైవ్',
    'anchorFormats.tab.toReporter': 'యాంకర్ టు రిపోర్టర్',
    'anchorFormats.tab.toGuest': 'యాంకర్ టు గెస్ట్',
    'anchorFormats.tab.drive': 'యాంకర్ డ్రైవ్',
    'anchorFormats.generatedScript': 'రూపొందించిన స్క్రిప్ట్',
    'anchorFormats.aiWriting': 'AI మీ స్క్రిప్ట్ రాస్తోంది…',
    'anchorFormats.carriedOver': 'మునుపటి టాబ్ నుండి ఇన్‌పుట్ తీసుకోబడింది',
    // AV Newsroom Controls
    'avControls.label': 'న్యూస్‌రూమ్ నియంత్రణలు',
    'avControls.storyEnhancement': 'స్టోరీ ఎన్‌హాన్స్‌మెంట్',
    'avControls.dramaticIntensity': 'నాటకీయ తీవ్రత',
    'avControls.honorifics': 'గౌరవ వాచ్యాలు',
    'avControls.fullNames': 'పూర్తి పేర్లు',
    'avControls.low': 'తక్కువ',
    'avControls.medium': 'మధ్యస్థం',
    'avControls.high': 'అధికం',
    // IP Whitelist Settings
    'ipWhitelist.title': 'IP వైట్‌లిస్ట్',
    'ipWhitelist.subtitle': 'IP చిరునామా ద్వారా యాక్సెస్‌ని పరిమితం చేయండి. అడ్మిన్‌లకు ఎల్లప్పుడూ యాక్సెస్ ఉంటుంది.',
    'ipWhitelist.adminNotAffected': 'అడ్మిన్‌లు ఈ సెట్టింగ్‌తో సంబంధం లేకుండా ఏ IP నుండైనా యాక్సెస్ చేయగలరు.',
    'ipWhitelist.enableToggle': 'IP వైట్‌లిస్ట్ ఆన్ చేయండి',
    'ipWhitelist.enabledDesc': 'జాబితాలోని IP చిరునామాలు మాత్రమే సిస్టమ్‌ను యాక్సెస్ చేయగలవు.',
    'ipWhitelist.disabledDesc': 'అన్ని IP చిరునామాలకు అనుమతి ఉంది (డిఫాల్ట్). ఎలాంటి పరిమితులు లేవు.',
    'ipWhitelist.warningEmpty': 'హెచ్చరిక: IP జాబితా లేకుండా ఆన్ చేస్తే, అన్ని అడ్మిన్ కాని వినియోగదారులు వెంటనే బ్లాక్ అవుతారు.',
    'ipWhitelist.warningEmptyShort': 'సేవ్ చేయడానికి ముందు కనీసం ఒక IP జోడించండి.',
    'ipWhitelist.yourIp': 'మీ ప్రస్తుత IP చిరునామా',
    'ipWhitelist.loopbackHint': 'సర్వర్ లూప్‌బ్యాక్ చిరునామా (127.0.0.1) చూస్తోంది — మీ రివర్స్ ప్రాక్సీ అసలు client IP ఫార్వార్డ్ చేయడం లేదు. nginx కాన్ఫిగ్‌లో "proxy_set_header X-Real-IP $remote_addr;" జోడించమని సర్వర్ అడ్మిన్‌కు చెప్పండి. అప్పటి వరకు దిగువ ఫారమ్‌లో మీ IP మాన్యువల్‌గా నమోదు చేయండి.',
    'ipWhitelist.addMyIp': '+ నా IP జోడించు',
    'ipWhitelist.myIpLabel': 'అడ్మిన్',
    'ipWhitelist.alreadyAdded': 'ఇప్పటికే జోడించబడింది',
    'ipWhitelist.addIp': 'IP జోడించు',
    'ipWhitelist.ipAddress': 'IP చిరునామా',
    'ipWhitelist.labelCol': 'లేబుల్',
    'ipWhitelist.ipPlaceholder': 'ఉదా: 203.0.113.45',
    'ipWhitelist.labelPlaceholder': 'ఉదా: కార్యాలయం, ఇల్లు, ఎడిటర్ 1',
    'ipWhitelist.ipRequired': 'IP చిరునామా అవసరం.',
    'ipWhitelist.ipInvalid': 'చెల్లుబాటు అయ్యే IP చిరునామా నమోదు చేయండి.',
    'ipWhitelist.allowedIps': 'అనుమతించిన IP చిరునామాలు',
    'ipWhitelist.noIps': 'ఇంకా IP చిరునామాలు జోడించబడలేదు.',
    'ipWhitelist.addedOn': 'జోడించిన తేదీ',
    'ipWhitelist.remove': 'తొలగించు',
    'ipWhitelist.saveChanges': 'మార్పులు సేవ్ చేయండి',
    'ipWhitelist.saving': 'సేవ్ అవుతోంది…',
    'ipWhitelist.saved': 'IP వైట్‌లిస్ట్ సెట్టింగ్‌లు సేవ్ చేయబడ్డాయి.',
    'settings.adminOnly': 'ఈ పేజీ అడ్మిన్‌లకు మాత్రమే పరిమితం.',
    // Settings — Automation Sources
    'settings.automationSources': 'ఆటోమేషన్ సోర్సెస్',
    'settings.automationSourcesSubtitle': 'ఆటోమేషన్ → పైప్‌లైన్ ట్యాబ్‌లో అందుబాటులో ఉండే ఇన్‌పుట్ సోర్సెస్ (ఉదా. WhatsApp) మరియు అవుట్‌పుట్ డెస్టినేషన్‌లను (ఉదా. YouTube) కాన్ఫిగర్ చేయండి.',
    'automationSources.input': 'ఇన్‌పుట్ సోర్సెస్',
    'automationSources.output': 'అవుట్‌పుట్ డెస్టినేషన్‌లు',
    'automationSources.otherSources': 'ఇతర సోర్సెస్',
    'automationSources.addCustomSource': '+ కస్టమ్ సోర్స్ జోడించండి',
    'automationSources.addSource': 'సోర్స్ జోడించండి',
    'automationSources.namePlaceholder': 'ఉదా. WhatsApp',
    'automationSources.keyPlaceholder': 'ఉదా. whatsapp',
    'automationSources.enabled': 'ఎనేబుల్డ్',
    'automationSources.noSources': 'ఇంకా సోర్సెస్ కాన్ఫిగర్ చేయలేదు.',
    'automationSources.deleteConfirm': 'ఈ సోర్స్‌ను తీసివేయాలా? దీన్ని ఇప్పటికే ఉపయోగిస్తున్న పైప్‌లైన్ ఐటమ్‌లపై ప్రభావం ఉండదు.',
    'automationSources.added': 'సోర్స్ జోడించబడింది.',
    'automationSources.deleted': 'సోర్స్ తీసివేయబడింది.',
    'automationSources.connected': 'కనెక్ట్ చేయబడింది',
    'automationSources.notConnected': 'కనెక్ట్ కాలేదు',
    'automationSources.inputs.title': 'WhatsApp సోర్సెస్',
    'automationSources.inputs.subtitle': 'వచ్చే కంటెంట్ కోసం పర్యవేక్షిస్తున్న గ్రూప్‌లు మరియు కాంటాక్ట్‌లు — సరిపోలికలు స్వయంచాలకంగా పైప్‌లైన్‌లోకి తీసుకురాబడతాయి.',
    'automationSources.inputs.empty': 'ఇంకా గ్రూప్‌లు లేదా కాంటాక్ట్‌లు జోడించలేదు — కింద ఒకటి జోడించండి.',
    'automationSources.inputs.colType': 'రకం',
    'automationSources.inputs.colName': 'పేరు',
    'automationSources.outputs.title': 'పబ్లిష్ డెస్టినేషన్‌లు',
    'automationSources.outputs.subtitle': 'పైప్‌లైన్ నుండి పబ్లిష్ చేయడానికి అందుబాటులో ఉన్న YouTube ఛానెల్‌లు.',
    'automationSources.outputs.colChannel': 'ఛానెల్',
    'automationSources.outputs.colStatus': 'స్థితి',
    'automationSources.whatsapp.title': 'WhatsApp',
    'automationSources.whatsapp.subtitle': 'ఎంచుకున్న కాంటాక్ట్‌లు మరియు గ్రూప్‌ల నుండి మెసేజ్‌లను పైప్‌లైన్‌లోకి తీసుకురావడానికి WhatsApp అకౌంట్‌ను కనెక్ట్ చేయండి.',
    'automationSources.whatsapp.connect': 'WhatsApp కనెక్ట్ చేయండి',
    'automationSources.whatsapp.connecting': 'కనెక్ట్ అవుతోంది…',
    'automationSources.whatsapp.initializing': 'WhatsApp సెషన్ ప్రారంభమవుతోంది…',
    'automationSources.whatsapp.stalledHint': 'ఇది అనుకున్నదానికంటే ఎక్కువ సమయం తీసుకుంటోంది. మళ్ళీ చెక్ చేయడం సురక్షితం.',
    'automationSources.whatsapp.checkAgain': 'మళ్ళీ చెక్ చేయండి',
    'automationSources.whatsapp.scanHint': 'మీ ఫోన్‌లో WhatsApp తెరిచి → Linked Devices → Link a Device కి వెళ్ళి, ఈ కోడ్‌ను స్కాన్ చేయండి.',
    'automationSources.whatsapp.disconnect': 'డిస్‌కనెక్ట్ చేయండి',
    'automationSources.whatsapp.syncNow': 'ఇప్పుడు సింక్ చేయండి',
    'automationSources.whatsapp.syncing': 'సింక్ అవుతోంది…',
    'automationSources.whatsapp.syncDone': 'సింక్ పూర్తయింది — మిస్ అయిన మెసేజ్‌లు ఏమైనా ఉంటే అవి తీసుకురాబడ్డాయి.',
    'automationSources.whatsapp.monitoredChats': 'పర్యవేక్షిస్తున్న చాట్‌లు',
    'automationSources.whatsapp.loadChats': 'చాట్‌లు లోడ్ చేయండి',
    'automationSources.whatsapp.allowListHint': 'కింద జోడించిన కాంటాక్ట్‌లు/గ్రూప్‌ల నుండి వచ్చే మెసేజ్‌లు మాత్రమే పైప్‌లైన్ టేబుల్‌లోకి వస్తాయి — మిగిలినవి దిగుమతి చేయబడవు.',
    'automationSources.whatsapp.groups': 'గ్రూప్‌లు',
    'automationSources.whatsapp.contacts': 'కాంటాక్ట్‌లు',
    'automationSources.whatsapp.groupNamePlaceholder': 'WhatsApp గ్రూప్ పేరు (సరిగ్గా అలాగే)',
    'automationSources.whatsapp.labelPlaceholder': 'లేబుల్ (ఐచ్ఛికం)',
    'automationSources.whatsapp.groupNameHint': 'WhatsAppలో కనిపించే గ్రూప్ పేరుతో సరిగ్గా సరిపోలాలి (అప్పర్/లోయర్‌కేస్ తేడా పట్టించుకోదు).',
    'automationSources.whatsapp.contactNumberPlaceholder': 'కంట్రీ కోడ్‌తో ఫోన్ నంబర్, ఉదా. 919876543210',
    'automationSources.whatsapp.contactNumberHint': 'కంట్రీ కోడ్ చేర్చండి, అంకెలు మాత్రమే (+ లేదా స్పేస్‌లు అవసరం లేదు).',
    'automationSources.whatsapp.alreadyAdded': 'ఇది ఇప్పటికే లిస్ట్‌లో ఉంది.',
    'automationSources.whatsapp.invalidNumber': 'కంట్రీ కోడ్‌తో సరైన ఫోన్ నంబర్ నమోదు చేయండి.',
    'automationSources.whatsapp.noChats': 'ఎలాంటి చాట్‌లు కనబడలేదు.',
    'automationSources.whatsapp.saveMonitored': 'లిస్ట్ సేవ్ చేయండి',
    'automationSources.whatsapp.monitoredSaved': 'పర్యవేక్షిస్తున్న లిస్ట్ సేవ్ చేయబడింది.',
    'automationSources.whatsapp.status.disconnected': 'డిస్‌కనెక్ట్ అయింది',
    'automationSources.whatsapp.status.initializing': 'ప్రారంభమవుతోంది…',
    'automationSources.whatsapp.status.qr_pending': 'QR కోడ్ స్కాన్ చేయండి',
    'automationSources.whatsapp.status.connected': 'కనెక్ట్ చేయబడింది',
    'automationSources.youtube.title': 'YouTube',
    'automationSources.youtube.subtitle': 'YouTube అకౌంట్ (Google OAuth యాప్ క్రెడెన్షియల్స్) ఒకసారి జోడించి, దాని ఛానెల్‌లను కింద ఒక్కొక్కటిగా కనెక్ట్ చేయండి — ఒకే లాగిన్ నుండి అయినా, Google ప్రతి ఛానెల్‌కూ విడిగా అథరైజేషన్ అడుగుతుంది, కానీ క్రెడెన్షియల్స్ మళ్ళీ నమోదు చేయాల్సిన అవసరం లేదు.',
    'automationSources.youtube.multiChannelHint': 'ఈ లాగిన్‌లో ఒకటి కంటే ఎక్కువ ఛానెల్‌లు ఉన్నాయా? ప్రతి ఛానెల్ తర్వాత "ఛానెల్ కనెక్ట్ చేయండి" మళ్ళీ క్లిక్ చేయండి — Google ప్రతిసారీ వేరే ఛానెల్‌ను ఎంచుకోనిస్తుంది, ఈ క్రెడెన్షియల్స్ మళ్ళీ అడగదు.',
    'automationSources.youtube.redirectUriLabel': 'ఆథరైజ్డ్ రీడైరెక్ట్ URI',
    'automationSources.youtube.redirectUriHint': 'Google Cloud Console లో మీ OAuth క్లయింట్ యొక్క "Authorized redirect URIs" లో ఈ URIని సరిగ్గా అలాగే జోడించండి.',
    'automationSources.youtube.clientIdPlaceholder': 'Client ID',
    'automationSources.youtube.clientSecretPlaceholder': 'Client Secret',
    'automationSources.youtube.clientSecretStoredPlaceholder': 'ప్రస్తుత సీక్రెట్‌ను అలాగే ఉంచడానికి ఖాళీగా వదిలేయండి',
    'automationSources.youtube.redirectUriPlaceholder': 'https://yourdomain.com/api/automation/sources/youtube/oauth/callback',
    'automationSources.youtube.suggestedUri': 'సూచించినది:',
    'automationSources.youtube.useSuggested': 'దీన్ని వాడండి',
    'automationSources.youtube.connecting': 'రీడైరెక్ట్ అవుతోంది…',
    'automationSources.youtube.disconnect': 'డిస్‌కనెక్ట్ చేయండి',
    'automationSources.youtube.connectedToast': 'YouTube ఛానెల్ కనెక్ట్ చేయబడింది.',
    'automationSources.youtube.connectedToastNamed': 'కనెక్ట్ అయింది: "{{channel}}" — దీన్ని పబ్లిష్ చేయడానికి ఉపయోగించే ముందు ఇది సరైన ఛానెలేనా అని చెక్ చేయండి.',
    'automationSources.youtube.connectFailed': 'YouTube కనెక్షన్ విఫలమైంది.',
    'automationSources.youtube.defaultPrivacyLabel': 'పబ్లిష్ చేసిన వీడియోల కోసం డిఫాల్ట్ ప్రైవసీ',
    'automationSources.youtube.defaultPrivacyHint': 'మీరు పబ్లిష్ చేసినప్పుడు ఇది స్వయంచాలకంగా వర్తించబడుతుంది — Publish స్క్రీన్‌పై ప్రతి వీడియోకూ దీన్ని మార్చవచ్చు.',
    'automationSources.youtube.defaultPrivacySaved': 'డిఫాల్ట్ ప్రైవసీ నవీకరించబడింది.',
    'automationSources.youtube.accountsTitle': 'YouTube అకౌంట్లు',
    'automationSources.youtube.noAccountsYet': 'ఇంకా YouTube అకౌంట్లు లేవు. ఛానెల్‌ను కనెక్ట్ చేయడానికి ఒకటి జోడించండి.',
    'automationSources.youtube.addAccount': 'YouTube అకౌంట్ జోడించండి',
    'automationSources.youtube.accountNamePlaceholder': 'అకౌంట్ పేరు (ఉదా. Studio A)',
    'automationSources.youtube.accountSaved': 'అకౌంట్ సేవ్ చేయబడింది.',
    'automationSources.youtube.deleteAccountConfirm': 'ఈ అకౌంట్‌ను తొలగించాలా? దీనికి కనెక్ట్ చేసిన ఛానెల్‌లు లేనప్పుడు మాత్రమే ఇది సాధ్యమవుతుంది.',
    'automationSources.youtube.accountDeleted': 'అకౌంట్ తీసివేయబడింది.',
    'automationSources.youtube.channelsInAccount': 'ఛానెల్‌లు',
    'automationSources.youtube.noChannelsYet': 'ఇంకా ఛానెల్‌లు కనెక్ట్ చేయలేదు.',
    'automationSources.youtube.connectChannel': 'ఛానెల్ కనెక్ట్ చేయండి',
    'automationSources.youtube.colAccount': 'అకౌంట్',
    'youtube.privacyPublic': 'పబ్లిక్',
    'youtube.privacyUnlisted': 'అన్‌లిస్టెడ్',
    'youtube.privacyPrivate': 'ప్రైవేట్',
    // Automation Sources — Default Destination Mappings
    'automationSources.mappings.title': 'డిఫాల్ట్ డెస్టినేషన్ మ్యాపింగ్‌లు',
    'automationSources.mappings.subtitle': 'ప్రతి WhatsApp గ్రూప్ లేదా కాంటాక్ట్‌కు డిఫాల్ట్ పబ్లిష్ డెస్టినేషన్ సెట్ చేయండి — స్వయంచాలకంగా ముందే నింపబడుతుంది, పబ్లిష్ చేసేటప్పుడు ప్రతి ఐటెమ్‌కూ మార్చవచ్చు.',
    'automationSources.mappings.searchPlaceholder': 'గ్రూప్‌లు/కాంటాక్ట్‌లు వెతకండి…',
    'automationSources.mappings.destinationPlaceholder': 'డెస్టినేషన్ ఎంచుకోండి…',
    'automationSources.mappings.saved': 'డిఫాల్ట్ డెస్టినేషన్ సేవ్ చేయబడింది.',
    'automationSources.mappings.emptyNoInputs': 'డిఫాల్ట్ డెస్టినేషన్‌లు సెట్ చేయడానికి ముందు పైన WhatsApp గ్రూప్ లేదా కాంటాక్ట్‌ను జోడించండి.',
    'automationSources.mappings.emptyNoOutputs': 'డిఫాల్ట్ డెస్టినేషన్‌లు సెట్ చేయడానికి ముందు పైన YouTube ఛానెల్‌ను కనెక్ట్ చేయండి.',
    // Automation — Pipeline page
    'automation.title': 'ఆటోమేషన్',
    'automation.desc': 'కనెక్ట్ చేసిన సోర్సెస్ నుండి వచ్చే కంటెంట్‌ను తీసుకుని మీ ప్లాట్‌ఫారమ్‌లకు పబ్లిష్ చేయండి',
    'automation.tab.pipeline': 'పైప్‌లైన్',
    'automation.configureSources': 'సోర్సెస్ కాన్ఫిగర్ చేయండి',
    'pipeline.filterStatus': 'స్థితి',
    'pipeline.filterAllStatus': 'అన్ని స్థితులు',
    'pipeline.filterSource': 'సోర్స్',
    'pipeline.filterAllSources': 'అన్ని సోర్సెస్',
    'pipeline.filterGroup': 'గ్రూప్',
    'pipeline.filterAllGroups': 'అన్ని గ్రూప్‌లు',
    'pipeline.filterDirect': 'డైరెక్ట్ (గ్రూప్ కాదు)',
    'pipeline.filterName': 'పేరు',
    'pipeline.filterNamePlaceholder': 'పేరుతో వెతకండి…',
    'pipeline.filterNumber': 'నంబర్',
    'pipeline.filterNumberPlaceholder': 'నంబర్‌తో వెతకండి…',
    'pipeline.filterContact': 'కాంటాక్ట్',
    'pipeline.filterAllContacts': 'అన్ని కాంటాక్ట్‌లు',
    'pipeline.clearFilters': 'ఫిల్టర్‌లు క్లియర్ చేయండి',
    'pipeline.backfill': 'పాత మెసేజ్‌ల కోసం ఫిల్టర్‌లు సరిచేయండి',
    'pipeline.backfilling': 'సరిచేస్తోంది…',
    'pipeline.backfillHint': 'ఈ ఫిల్టర్‌లు రాకముందు వచ్చిన మెసేజ్‌లలో కూడా గ్రూప్/కాంటాక్ట్ ఫిల్టర్‌లు పనిచేయడానికి వన్-టైమ్ ఫిక్స్. ఒకటికి మించి రన్ చేయడం సురక్షితం.',
    'pipeline.backfillResult': '{{scanned}} స్కాన్ చేయబడ్డాయి — {{groupsMatched}} గ్రూప్ + {{contactsMatched}} కాంటాక్ట్ మెసేజ్‌లు సరిపోలాయి, {{unmatched}} సరిపోలలేదు.',
    'pipeline.filterReceivedFrom': 'వచ్చినది (నుండి)',
    'pipeline.filterReceivedTo': 'వచ్చినది (వరకు)',
    'pipeline.filterPublishedFrom': 'పబ్లిష్ (నుండి)',
    'pipeline.filterPublishedTo': 'పబ్లిష్ (వరకు)',
    'pipeline.pagination.showing': '{{total}}లో {{from}}–{{to}} చూపిస్తోంది',
    'pipeline.col.source': 'సోర్స్',
    'pipeline.col.receivedDatetime': 'వచ్చిన తేదీ & సమయం',
    'pipeline.col.receivedFrom': 'ఎవరి నుండి వచ్చింది',
    'pipeline.col.text': 'టెక్స్ట్',
    'pipeline.col.attachments': 'అటాచ్‌మెంట్‌లు',
    'pipeline.col.destination': 'డెస్టినేషన్',
    'pipeline.col.status': 'స్థితి',
    'pipeline.col.publishedDatetime': 'పబ్లిష్ చేసిన తేదీ & సమయం',
    'pipeline.col.actions': 'చర్యలు',
    'pipeline.noItems': 'ఇంకా పైప్‌లైన్ ఐటమ్‌లు లేవు. కంటెంట్ రావడానికి ఒక ఇన్‌పుట్ సోర్స్‌ను కనెక్ట్ చేయండి.',
    'pipeline.selectDestination': 'డెస్టినేషన్ ఎంచుకోండి',
    'pipeline.execute': 'ఎగ్జిక్యూట్',
    'pipeline.viewEdit': 'చూడండి / సవరించండి',
    'pipeline.viewEditMessage': 'మెసేజ్ చూడండి / సవరించండి',
    'pipeline.detail.title': 'మెసేజ్ వివరాలు',
    'pipeline.detail.editText': 'సవరించండి',
    'pipeline.detail.noText': 'టెక్స్ట్ కంటెంట్ లేదు',
    'pipeline.detail.uploading': 'అప్‌లోడ్ అవుతోంది…',
    'pipeline.detail.addReplaceVideo': 'వీడియో జోడించండి / మార్చండి',
    'pipeline.detail.noAttachments': 'అటాచ్‌మెంట్‌లు లేవు',
    'pipeline.detail.textSaved': 'టెక్స్ట్ అప్‌డేట్ చేయబడింది.',
    'pipeline.detail.sender': 'పంపినవారు',
    'pipeline.detail.editSender': 'సవరించండి',
    'pipeline.detail.senderSaved': 'పంపినవారి సమాచారం అప్‌డేట్ చేయబడింది.',
    'pipeline.detail.senderNumberPlaceholder': 'ఉదా. 919700802399',
    'pipeline.detail.attachmentAdded': 'అటాచ్‌మెంట్ జోడించబడింది.',
    'pipeline.detail.removeAttachment': 'అటాచ్‌మెంట్ తీసివేయండి',
    'pipeline.detail.removeAttachmentConfirm': 'ఈ అటాచ్‌మెంట్‌ను తీసివేయాలా? దీన్ని రద్దు చేయలేరు.',
    'pipeline.detail.generatedContent': 'రూపొందించిన కంటెంట్',
    'pipeline.detail.cancel': 'రద్దు చేయండి',
    'pipeline.status.collecting': 'సేకరిస్తోంది…',
    'pipeline.stillCollecting': 'ఈ టాపిక్ కోసం ఇంకా మెసేజ్‌లు సేకరిస్తోంది — దీన్ని ముగించడానికి WhatsAppలో 6+ డాష్‌ల లైన్ పంపండి.',
    'pipeline.status.received': 'వచ్చింది',
    'pipeline.status.generating': 'రూపొందిస్తోంది…',
    'pipeline.status.generated': 'రూపొందించబడింది',
    'pipeline.status.publishing': 'పబ్లిష్ చేస్తోంది…',
    'pipeline.status.published': 'పబ్లిష్ చేయబడింది',
    'pipeline.status.failed': 'విఫలమైంది',
    'pipeline.noAttachments': '—',
    'pipeline.attachmentsCount': '{{count}} ఫైల్(లు)',
    'pipeline.capturingAttachment': 'అటాచ్‌మెంట్ క్యాప్చర్ అవుతోంది…',
    'pipeline.pagination.page': 'పేజీ {{page}} / {{pages}}',
    'pipeline.pagination.prev': 'మునుపటి',
    'pipeline.pagination.next': 'తదుపరి',
    'pipeline.modal.title': '{{destination}} కోసం సిద్ధం చేయండి',
    'pipeline.modal.generating': '{{destination}} కంటెంట్ రూపొందిస్తోంది…',
    'pipeline.modal.regenerate': 'మళ్ళీ రూపొందించండి',
    'pipeline.modal.generatedContentLabel': 'రూపొందించిన కంటెంట్',
    'pipeline.modal.editPrompt': 'ప్రాంప్ట్ సవరించు',
    'pipeline.modal.editPromptHint': 'అడ్మిన్ మాత్రమే — ప్రాంప్ట్ ఎడిటర్‌లో ఈ ప్రాంప్ట్‌కు వెళ్ళండి.',
    'pipeline.modal.videoTitle': 'వీడియో టైటిల్',
    'pipeline.modal.videoDescription': 'వీడియో వివరణ',
    'pipeline.modal.hashtags': 'హ్యాష్‌ట్యాగ్‌లు',
    'pipeline.modal.videoTags': 'వీడియో ట్యాగ్‌లు',
    'pipeline.modal.selectAttachment': 'పబ్లిష్ చేయడానికి అటాచ్‌మెంట్ ఎంచుకోండి',
    'pipeline.modal.noAttachments': 'ఈ మెసేజ్‌తో ఎలాంటి అటాచ్‌మెంట్‌లు రాలేదు.',
    'pipeline.modal.inputVideos': 'ఇన్‌పుట్ వీడియోలు — విలీనం క్రమాన్ని సెట్ చేయండి',
    'pipeline.modal.outputVideos': 'అవుట్‌పుట్ వీడియోలు — పబ్లిష్ చేయడానికి ఒకటి ఎంచుకోండి',
    'pipeline.modal.mergeOrderPlaceholder': '#',
    'pipeline.modal.mergeOrderLabel': 'విలీన క్రమం (మినహాయించడానికి ఖాళీగా ఉంచండి)',
    'pipeline.modal.mergeSelectedVideos': 'ఎంచుకున్న వీడియోలను విలీనం చేయండి ({{count}})',
    'pipeline.modal.merging': 'విలీనం చేస్తోంది…',
    'pipeline.modal.mergeStarted': 'విలీనం ప్రారంభమైంది — పొడవైన క్లిప్‌లకు ఇది కొంత సమయం పట్టవచ్చు. మీరు పని కొనసాగించవచ్చు; ఇది స్వయంచాలకంగా అప్‌డేట్ అవుతుంది.',
    'pipeline.modal.mergeSuccess': 'వీడియోలు విజయవంతంగా విలీనం అయ్యాయి.',
    'pipeline.modal.mergeFailed': 'వీడియోలను విలీనం చేయడంలో విఫలమైంది.',
    'pipeline.modal.mergedFrom': '{{count}} వీడియో(ల) నుండి విలీనం చేయబడింది',
    'pipeline.modal.mergeBlocksPublish': 'పబ్లిష్ చేసే ముందు విలీనం పూర్తయ్యే వరకు వేచి ఉండండి.',
    'pipeline.modal.mergeBlocksVoiceOver': 'వాయిస్-ఓవర్ జనరేట్ చేసే ముందు విలీనం పూర్తయ్యే వరకు వేచి ఉండండి.',
    'pipeline.modal.publish': 'పబ్లిష్ చేయండి',
    'pipeline.modal.publishing': 'పబ్లిష్ చేస్తోంది…',
    'pipeline.modal.publishStarted': 'పబ్లిషింగ్ ప్రారంభమైంది — పెద్ద వీడియోకు ఇది కొంత సమయం పట్టవచ్చు. మీరు పని కొనసాగించవచ్చు; ఇది స్వయంచాలకంగా అప్‌డేట్ అవుతుంది.',
    'pipeline.modal.publishStep.watermarking': 'లోగో/వాటర్‌మార్క్ వర్తింపజేస్తోంది…',
    'pipeline.modal.publishStep.uploading': 'YouTubeకి అప్‌లోడ్ చేస్తోంది…',
    'pipeline.modal.publishStep.setting_thumbnail': 'థంబ్‌నెయిల్ సెట్ చేస్తోంది…',
    'pipeline.modal.close': 'మూసివేయండి',
    'pipeline.modal.generationFailed': 'కంటెంట్ జనరేషన్ విఫలమైంది. మీ AI ప్రొవైడర్ సెట్టింగ్‌లను తనిఖీ చేయండి.',
    'pipeline.modal.notSupported': 'ఈ డెస్టినేషన్ కోసం జనరేషన్ ఇంకా అందుబాటులో లేదు.',
    'pipeline.modal.selectDestinationFirst': 'ఎగ్జిక్యూట్ చేయడానికి ముందు ఈ వరుసకు ఒక డెస్టినేషన్‌ను ఎంచుకోండి.',
    'pipeline.modal.publishSuccess': 'పబ్లిష్ చేయబడినట్లు గుర్తించబడింది. గమనిక: డెస్టినేషన్ ప్లాట్‌ఫారమ్‌కు లైవ్ అప్‌లోడ్ ఇంకా కనెక్ట్ కాలేదు — ఆ ఇంటిగ్రేషన్ విడిగా జోడించబడుతోంది.',
    'pipeline.modal.publishSuccessYoutube': 'YouTubeకి {{status}}గా అప్‌లోడ్ చేయబడింది: {{url}}',
    'pipeline.modal.privacyStatusLabel': 'YouTubeలో ప్రైవసీ',
    'pipeline.modal.viewOnYoutube': 'YouTubeలో చూడండి',
    'pipeline.modal.voiceOverTitle': 'వాయిస్-ఓవర్ నరేషన్',
    'pipeline.modal.voiceOverAsk': 'ఈ వీడియోకి వాయిస్-ఓవర్ నరేషన్ జోడించాలనుకుంటున్నారా?',
    'pipeline.modal.voiceOverYes': 'అవును',
    'pipeline.modal.voiceOverNo': 'వద్దు',
    'pipeline.modal.voiceOverSkipped': 'వాయిస్-ఓవర్ జోడించబడదు.',
    'pipeline.modal.voiceOverChangeAnswer': 'బదులుగా జోడించండి',
    'pipeline.modal.voiceOverLoadingVoices': 'వాయిస్‌లు లోడ్ అవుతున్నాయి…',
    'pipeline.modal.voiceOverRefreshVoices': 'వాయిస్ లిస్ట్ రిఫ్రెష్ చేయండి',
    'pipeline.modal.voiceOverPickVideoHint': 'పైన ఎంచుకున్న వీడియోను ఉపయోగిస్తుంది — ఇంకా ఎంచుకోకపోతే ముందు ఎంచుకోండి.',
    'pipeline.modal.voiceOverGenerate': 'వాయిస్ ఓవర్ రూపొందించండి',
    'pipeline.modal.voiceOverUploadOwn': 'మీ సొంతం అప్‌లోడ్ చేయండి',
    'pipeline.modal.voiceOverStarting': 'ప్రారంభమవుతోంది…',
    'pipeline.modal.voiceOverCancel': 'ఆపండి',
    'pipeline.modal.voiceOverCancelling': 'ఆగిపోతోంది…',
    'pipeline.modal.voiceOverSelectVideoFirst': 'వాయిస్-ఓవర్ రూపొందించే ముందు పైన ఒక వీడియో అటాచ్‌మెంట్‌ను ఎంచుకోండి.',
    'pipeline.modal.voiceOverFailed': 'వాయిస్-ఓవర్ రూపొందించడం విఫలమైంది.',
    'pipeline.modal.voiceOverDone': 'వాయిస్-ఓవర్ జోడించబడింది ({{voice}}) — కింద ప్రివ్యూ చూడండి.',
    'pipeline.modal.voiceOverBlocksPublish': 'పబ్లిష్ చేసే ముందు వాయిస్-ఓవర్ పూర్తయ్యే వరకు వేచి ఉండండి.',
    'pipeline.modal.voiceOverStatus.generating_script': 'నరేషన్ స్క్రిప్ట్ రాస్తోంది…',
    'pipeline.modal.voiceOverStatus.generating_audio': 'నరేషన్ ఆడియో రూపొందిస్తోంది…',
    'pipeline.modal.voiceOverStatus.merging': 'నరేషన్‌ను వీడియోలో విలీనం చేస్తోంది…',
    'pipeline.modal.thumbnailText': 'థంబ్‌నెయిల్ టెక్స్ట్',
    'pipeline.modal.thumbnailsTitle': 'థంబ్‌నెయిల్',
    'pipeline.modal.thumbnailsGenerateFrame': 'వీడియో ఫ్రేమ్ నుండి',
    'pipeline.modal.thumbnailsGenerateFrameHint': 'ఉచితం, తక్షణం — 6 ఆప్షన్‌లు: 3 సింగిల్-ఫ్రేమ్, ప్లస్ 3 మల్టీ-ఇమేజ్ కొల్లాజ్ లేఅవుట్‌లు, ప్రతి దానిపై థంబ్‌నెయిల్ టెక్స్ట్ ఓవర్‌లే చేయబడుతుంది.',
    'pipeline.modal.thumbnailsRegenerate': 'మళ్ళీ రూపొందించండి',
    'pipeline.modal.thumbnailsGenerateAI': 'AI తో రూపొందించండి',
    'pipeline.modal.thumbnailsGenerateAIHint': 'కంటెంట్‌కు సంబంధించిన బ్యాక్‌గ్రౌండ్ ఇమేజ్‌ను రూపొందించడానికి AI ఇమేజ్ మోడల్‌ను వాడుతుంది (ప్రతి కాల్‌కు ఖర్చు అవుతుంది), తర్వాత థంబ్‌నెయిల్ టెక్స్ట్‌ను ఓవర్‌లే చేస్తుంది. కొన్ని నిమిషాలు పట్టవచ్చు.',
    'pipeline.modal.thumbnailsGenerateAIAnother': 'మరొకటి రూపొందించండి ({{count}}/{{max}})',
    'pipeline.modal.thumbnailsAILimitReached': 'గరిష్టం {{max}} చేరుకుంది',
    'pipeline.modal.thumbnailsRegenerateAI': 'AI తో మళ్ళీ రూపొందించండి',
    'pipeline.modal.thumbnailsGenerating': 'రూపొందిస్తోంది…',
    'pipeline.modal.thumbnailsGeneratingAILong': 'మీ AI థంబ్‌నెయిల్ రూపొందిస్తోంది — ఇది కొన్ని నిమిషాల వరకు పట్టవచ్చు. దయచేసి ఈ విండోను తెరిచి ఉంచండి.',
    'pipeline.modal.thumbnailsUploadOwn': 'మీ సొంతం అప్‌లోడ్ చేయండి',
    'pipeline.modal.thumbnailsEmpty': 'ఇంకా థంబ్‌నెయిల్‌లు లేవు — వీడియో నుండి రూపొందించండి, AI తో రూపొందించండి, లేదా మీ సొంతం అప్‌లోడ్ చేయండి.',
    'pipeline.modal.thumbnailSelectVideoFirst': 'థంబ్‌నెయిల్‌లు రూపొందించే ముందు పైన ఒక వీడియో అటాచ్‌మెంట్‌ను ఎంచుకోండి.',
    'pipeline.modal.thumbnailTextGenerationFailed': 'థంబ్‌నెయిల్ టెక్స్ట్ రూపొందించడం విఫలమైంది ({{message}}) — మిగిలిన కంటెంట్ రూపొందించబడింది; మీరు దీన్ని మాన్యువల్‌గా టైప్ చేయవచ్చు లేదా మళ్ళీ ప్రయత్నించవచ్చు.',
    'pipeline.modal.unparsedOutputWarning': 'AI స్పందించింది, కానీ దాని సమాధానం ఆశించిన ఫార్మాట్‌తో సరిపోలలేదు (సాధారణంగా ఇది "Text prompt" అవసరమైన సెక్షన్ హెడర్‌లను ఉపయోగించకుండా సవరించబడిందని సూచిస్తుంది). దిగువ రా రెస్పాన్స్ చూపిస్తున్నాము — మీరు దీన్ని మాన్యువల్‌గా ఫీల్డ్‌లలోకి కాపీ చేయవచ్చు, లేదా "Edit Prompt" ద్వారా ప్రాంప్ట్‌ను సరిచేసి మళ్ళీ రూపొందించవచ్చు.',
    'pipeline.modal.thumbnailsViewLarge': 'పెద్దదిగా చూడండి',
    'pipeline.modal.thumbnailsPosition': 'స్థానం:',
    'pipeline.modal.thumbnailsMoveUp': 'టెక్స్ట్‌ను పైకి జరపండి',
    'pipeline.modal.thumbnailsMoveDown': 'టెక్స్ట్‌ను కిందకు జరపండి',
    'pipeline.modal.thumbnailsMoveLeft': 'టెక్స్ట్‌ను ఎడమవైపుకు జరపండి',
    'pipeline.modal.thumbnailsMoveRight': 'టెక్స్ట్‌ను కుడివైపుకు జరపండి',
    'pipeline.modal.thumbnailsSize': 'పరిమాణం:',
    'pipeline.modal.thumbnailsSizeDecrease': 'టెక్స్ట్ పరిమాణం తగ్గించండి',
    'pipeline.modal.thumbnailsSizeIncrease': 'టెక్స్ట్ పరిమాణం పెంచండి',
    'pipeline.modal.thumbnailsResetStyle': 'డిఫాల్ట్‌కు రీసెట్ చేయండి',
    'pipeline.modal.publishFailed': 'పబ్లిష్ విఫలమైంది.',
    'pipeline.modal.originalMessage': 'అసలు మెసేజ్',
    // Script Modes page
    'scriptModes.title': 'స్క్రిప్ట్ మోడ్స్',
    'scriptModes.desc': 'వేర్వేరు సంపాదకీయ శైలులలో స్క్రిప్ట్‌లు మళ్ళీ రాయండి లేదా రూపొందించండి',
    'scriptModes.tab.telangana': 'తెలంగాణ యాస',
    'scriptModes.tab.irony': 'వ్యంగ్యం / హాస్యం / వ్యంగ్యోక్తి',
    'scriptModes.tab.uplifting': 'ఉత్సాహకరమైన & ఆశావాద',
    'scriptModes.tab.critical': 'విమర్శనాత్మక & ప్రశ్నించే',
    'scriptModes.tab.balanced': 'సమతుల్య పాత్రికేయ నిష్పాక్షికత',
    'scriptModes.inputLabel': 'ఇన్‌పుట్ — మళ్ళీ రాయడానికి వార్త కాపీ లేదా ముడి సమాచారం అతికించండి',
    'scriptModes.generatedScript': 'రూపొందించిన స్క్రిప్ట్',
    'scriptModes.aiWriting': 'AI మీ స్క్రిప్ట్ రాస్తున్నది…',
    'scriptModes.placeholder': 'మళ్ళీ రాసిన స్క్రిప్ట్ ఇక్కడ కనిపిస్తుంది. ప్రారంభించడానికి రూపొందించు నొక్కండి.',
    // Social Media page
    'socialMedia.title': 'సోషల్ మీడియా',
    'socialMedia.desc': 'వేదికల వ్యాప్తంగా మీ వార్తకు సోషల్ మీడియా పోస్ట్‌లు రూపొందించండి',
    'socialMedia.tab.all': 'అన్ని వేదికలు',
    'socialMedia.tab.youtube': 'యూట్యూబ్',
    'socialMedia.tab.facebook': 'ఫేస్‌బుక్',
    'socialMedia.tab.instagram': 'ఇన్‌స్టాగ్రామ్',
    'socialMedia.tab.twitter': 'ట్విటర్ / X',
    'socialMedia.inputLabel': 'ఇన్‌పుట్ — వార్త కాపీ, వార్త వివరాలు లేదా ముడి కంటెంట్ అతికించండి',
    'socialMedia.generatedAllPlatforms': 'రూపొందించిన పోస్ట్‌లు — అన్ని వేదికలు',
    'socialMedia.generatedPost': 'రూపొందించిన {{platform}} పోస్ట్',
    'socialMedia.postPerPlatform': 'వేదిక వారీగా 1 పోస్ట్',
    'socialMedia.aiGenerating': 'AI మీ పోస్ట్‌లు రూపొందిస్తున్నది…',
    'socialMedia.placeholder': 'రూపొందించిన సోషల్ మీడియా పోస్ట్‌లు ఇక్కడ కనిపిస్తాయి. ప్రారంభించడానికి రూపొందించు నొక్కండి.',
    // Sports page
    'sports.title': 'క్రీడలు',
    'sports.desc': 'తెలుగు TV స్పోర్ట్స్ స్క్రిప్ట్‌లు — మ్యాచ్ సమీక్షలు మరియు లైవ్ పానెల్ చర్చలు',
    'sports.tab.matchReview': 'మ్యాచ్ సమీక్ష',
    'sports.tab.panelDiscussion': 'మ్యాచ్‌పై పానెల్ చర్చ',
    'sports.inputLabel': 'ఇన్‌పుట్ — మ్యాచ్ వివరాలు, స్కోర్‌కార్డ్‌లు, ఆటగాళ్ళ గణాంకాలు, కీలక క్షణాలు అతికించండి',
    'sports.inputPlaceholder': 'మ్యాచ్ వివరాలు, స్కోర్‌కార్డ్‌లు, ఆటగాళ్ళ గణాంకాలు, కీలక క్షణాలు అతికించండి…',
    'sports.aiWriting': 'AI మీ స్పోర్ట్స్ స్క్రిప్ట్ రాస్తున్నది…',
    'sports.placeholder': 'మీ రూపొందించిన స్క్రిప్ట్ ఇక్కడ కనిపిస్తుంది. ప్రారంభించడానికి రూపొందించు నొక్కండి.',
    // Commercial Interviews page
    'interviews.title': 'వాణిజ్య ఇంటర్వ్యూలు',
    'interviews.desc': 'ప్రాయోజిత ఆన్-ఎయిర్ అతిథి ఇంటర్వ్యూలకు AI-రూపొందించిన నిర్మాణాత్మక ప్రశ్న సమితులు',
    'interviews.tab.doctor': 'డాక్టర్ ఇంటర్వ్యూ',
    'interviews.tab.education': 'విద్య ఇంటర్వ్యూ',
    'interviews.tab.realEstate': 'రియల్ ఎస్టేట్ ఇంటర్వ్యూ',
    'interviews.guestName': 'అతిథి పేరు',
    'interviews.hospitalName': 'ఆసుపత్రి / క్లినిక్ పేరు',
    'interviews.universityName': 'విశ్వవిద్యాలయం / సంస్థ పేరు',
    'interviews.companyName': 'కంపెనీ / ప్రాజెక్ట్ పేరు',
    'interviews.designation': 'హోదా / బిరుదు',
    'interviews.additionalInfo': 'అదనపు సమాచారం',
    'interviews.includeWebResearch': 'వెబ్ పరిశోధన చేర్చు',
    'interviews.generate': 'ప్రశ్నలు రూపొందించు',
    'interviews.clear': 'క్లియర్ చేయి',
    'interviews.sections': '{{count}} విభాగాలు · {{total}} ప్రశ్నలు',
    'interviews.copyAll': 'అన్నీ కాపీ చేయి',
    'interviews.questionsWillAppear': '50+ ప్రశ్నలు ఇక్కడ కనిపిస్తాయి',
    'interviews.fillDetails': 'ఎడమవైపు అతిథి వివరాలు నమోదు చేసి రూపొందించు నొక్కండి',
    'interviews.researchingOnline': '{{org}} ని ఆన్‌లైన్‌లో పరిశోధిస్తున్నారు…',
    'interviews.gatheringContext': 'వెబ్ నుండి నేపథ్య సమాచారం సేకరిస్తున్నారు',
    'interviews.generatingQuestions': 'ప్రశ్నలు రూపొందిస్తున్నారు…',
    'interviews.writingQuestions': 'AI 10 అంశాలలో 50 ఇంటర్వ్యూ ప్రశ్నలు రాస్తున్నది',
    'interviews.questionsLabel': '{{count}} ప్రశ్నలు',
    'interviews.additionalNote': 'AI కి తెలియాల్సినవి — అవార్డులు, వివాదాలు, తాజా వార్తలు, దృష్టి కేంద్రాలు.',
    'interviews.webResearchNote': 'ప్రశ్నలు రూపొందించే ముందు అతిథి మరియు సంస్థపై నేపథ్య సమాచారం కోసం వెబ్‌లో వెతుకుతుంది. SerpAPI కాన్ఫిగర్ అయి ఉంటే దాన్ని, లేదా DuckDuckGo ఉపయోగిస్తుంది (ఉచితం).',
    'interviews.guestRequired': 'రూపొందించే ముందు దయచేసి అతిథి పేరు నమోదు చేయండి.',
    'interviews.generationFailed': 'రూపొందించడం విఫలమైంది. మీ AI ప్రొవైడర్ సెట్టింగ్‌లు తనిఖీ చేయండి.',
    'interviews.doctorPlaceholder': 'ఉదా., స్పెషాలిటీ, విజయాలు, ముఖ్యమైన కేసులు లేదా చికిత్సలు…',
    'interviews.educationPlaceholder': 'ఉదా., NAAC గ్రేడ్, ప్రముఖ పూర్వ విద్యార్థులు, తాజా విజయాలు, ప్రస్తుత కార్యక్రమాలు…',
    'interviews.realEstatePlaceholder': 'ఉదా., నిర్మాణంలో ఉన్న ప్రాజెక్టులు, లక్ష్య మార్కెట్, ధర పరిధి, RERA నమోదు స్థితి…',
    'interviews.guestNamePlaceholder': 'డా. రవి కుమార్ / ప్రొ. సునీత రెడ్డి / శ్రీ అరుణ్ శర్మ',
    'interviews.doctorOrgPlaceholder': 'NIMS ఆసుపత్రి, హైదరాబాద్',
    'interviews.educationOrgPlaceholder': 'ఉస్మానియా విశ్వవిద్యాలయం, హైదరాబాద్',
    'interviews.realEstateOrgPlaceholder': 'రెయిన్‌బో ఇన్‌ఫ్రాకాన్, హైదరాబాద్',
    'interviews.doctorDesignationPlaceholder': 'సీనియర్ కార్డియాలజిస్ట్ & విభాగాధిపతి',
    'interviews.educationDesignationPlaceholder': 'వైస్ ఛాన్సెలర్ / ప్రిన్సిపల్',
    'interviews.realEstateDesignationPlaceholder': 'MD & మేనేజింగ్ డైరెక్టర్',
    'interviews.copySection': 'ఈ విభాగం కాపీ చేయి',
    // Video to Script page
    'videoToScript.title': 'వీడియో నుండి స్క్రిప్ట్',
    'videoToScript.desc': 'AI ద్వారా వీడియో/ఆడియో ట్రాన్స్‌క్రైబ్ చేసి ప్రసార-సిద్ధ TV స్క్రిప్ట్‌గా మార్చండి',
    'videoToScript.uploadVideo': 'వీడియో అప్‌లోడ్',
    'videoToScript.youtubeUrl': 'యూట్యూబ్ URL',
    'videoToScript.drop': 'డ్రాగ్ & డ్రాప్ లేదా బ్రౌజ్ చేయడానికి క్లిక్ చేయండి',
    'videoToScript.dropping': 'ఫైల్ ఇక్కడ వదలండి',
    'videoToScript.fileTypes': 'MP4, MOV, AVI, MKV, MP3, WAV, M4A — గరిష్టంగా 200 MB',
    'videoToScript.remove': 'తొలగించు',
    'videoToScript.step1': 'అప్‌లోడ్ / వీడియో పొందడం',
    'videoToScript.step2': 'ఆడియో ట్రాన్స్‌క్రైబ్',
    'videoToScript.step3': 'TV స్క్రిప్ట్ రూపొందించడం',
    'videoToScript.transcript': 'ట్రాన్స్‌క్రిప్ట్',
    'videoToScript.tvScript': 'TV స్క్రిప్ట్',
    'videoToScript.rawTranscript': 'ముడి ట్రాన్స్‌క్రిప్ట్ (అవుట్‌పుట్)',
    'videoToScript.generatedScript': 'రూపొందించిన TV స్క్రిప్ట్',
    'videoToScript.regenerate': 'స్క్రిప్ట్ మళ్ళీ రూపొందించు',
    'videoToScript.regenerateNote': 'ట్రాన్స్‌క్రిప్షన్ దాటవేసి, స్క్రిప్ట్ రూపొందింపు మాత్రమే మళ్ళీ నడుస్తుంది',
    'videoToScript.transcribeGenerate': 'ట్రాన్స్‌క్రైబ్ & స్క్రిప్ట్ రూపొందించు',
    'videoToScript.processing': 'ప్రాసెస్ అవుతున్నది…',
    'videoToScript.uploading': 'ఫైల్ అప్‌లోడ్ అవుతున్నది…',
    'videoToScript.fetchingYoutube': 'యూట్యూబ్ ఆడియో డౌన్‌లోడ్ అవుతున్నది…',
    'videoToScript.transcribing': 'ఆడియో ట్రాన్స్‌క్రైబ్ అవుతున్నది…',
    'videoToScript.converting': 'TV స్క్రిప్ట్‌గా మారుస్తున్నది…',
    'videoToScript.emptyTitle': 'ట్రాన్స్‌క్రిప్ట్ మరియు స్క్రిప్ట్ ఇక్కడ కనిపిస్తాయి',
    'videoToScript.emptyUpload': 'ఎడమవైపు ఫైల్ ఎంచుకుని రూపొందించు నొక్కండి',
    'videoToScript.emptyUrl': 'ఎడమవైపు యూట్యూబ్ URL అతికించి రూపొందించు నొక్కండి',
    'videoToScript.publicOnly': 'పబ్లిక్ వీడియోలు మాత్రమే. ఆడియో సర్వర్-సైడ్‌లో డౌన్‌లోడ్ అయి ట్రాన్స్‌క్రైబ్ అవుతుంది.',
    'videoToScript.tone': 'శైలి',
    'videoToScript.selectFile': 'దయచేసి వీడియో లేదా ఆడియో ఫైల్ ఎంచుకోండి.',
    'videoToScript.pasteUrl': 'దయచేసి యూట్యూబ్ URL అతికించండి.',
    'videoToScript.willAppear': 'రూపొందించిన తర్వాత ఇక్కడ కనిపిస్తుంది…',
    'videoToScript.promptUsedFor': 'ప్రాంప్ట్ ఉపయోగించబడింది',
    // Video to Video page
    'videoToVideo.title': 'వీడియో నుండి వీడియో',
    'videoToVideo.desc': 'AI ద్వారా పెద్ద వీడియో నుండి వైరల్ షార్ట్ క్లిప్‌లు తయారు చేయండి',
    'videoToVideo.uploadVideo': 'వీడియో అప్‌లోడ్',
    'videoToVideo.youtubeUrl': 'యూట్యూబ్ URL',
    'videoToVideo.drop': 'డ్రాగ్ & డ్రాప్ లేదా బ్రౌజ్ చేయడానికి క్లిక్ చేయండి',
    'videoToVideo.dropping': 'వీడియో ఇక్కడ వదలండి',
    'videoToVideo.fileTypes': 'MP4, MOV, AVI, MKV, WEBM — గరిష్టంగా 500 MB',
    'videoToVideo.remove': 'తొలగించు',
    'videoToVideo.step1': 'వీడియో పొందడం / అప్‌లోడ్',
    'videoToVideo.step2': 'AI తో కంటెంట్ విశ్లేషణ',
    'videoToVideo.step3': 'వైరల్ క్లిప్‌లు వేరు చేయడం',
    'videoToVideo.generate': 'క్లిప్‌లు తీయండి',
    'videoToVideo.processing': 'ప్రాసెస్ అవుతున్నది…',
    'videoToVideo.pasteUrl': 'దయచేసి యూట్యూబ్ URL అతికించండి.',
    'videoToVideo.selectFile': 'దయచేసి వీడియో ఫైల్ ఎంచుకోండి.',
    'videoToVideo.publicOnly': 'పబ్లిక్ వీడియోలు మాత్రమే. వీడియో సర్వర్-సైడ్‌లో డౌన్‌లోడ్ అవుతుంది.',
    'videoToVideo.emptyTitle': 'వైరల్ క్లిప్‌లు ఇక్కడ కనిపిస్తాయి',
    'videoToVideo.emptyDesc': 'అప్‌లోడ్ చేయండి లేదా URL అతికించి క్లిప్‌లు తీయండి నొక్కండి',
    'videoToVideo.download': 'డౌన్‌లోడ్',
    'videoToVideo.clip': 'క్లిప్',
    'videoToVideo.duration': 'వ్యవధి',
    'videoToVideo.platform': 'అనుకూలమైన వేదిక',
    'videoToVideo.hook': 'ఎందుకు వైరల్ అవుతుంది',
    'videoToVideo.seconds': 'సె',
    // Legacy Common/Settings (imported but not currently routed)
    'legacySettings.title': 'API కాన్ఫిగరేషన్',
    'legacySettings.provider': 'AI ప్రొవైడర్',
    'legacySettings.apiKey': 'API కీ',
    'legacySettings.apiKeySecure': 'మీ API కీ గుప్తీకరించబడింది మరియు ఎప్పటికీ పంచుకోబడదు',
    'legacySettings.model': 'మోడల్',
    'legacySettings.temperature': 'ఉష్ణోగ్రత: {{value}}',
    'legacySettings.temperatureNote': 'తక్కువ విలువలు = ఎక్కువ కేంద్రీకృతం, అధిక విలువలు = ఎక్కువ సృజనాత్మకత',
    'legacySettings.maxTokens': 'గరిష్ట టోకెన్లు',
    'legacySettings.save': 'కాన్ఫిగరేషన్ సేవ్ చేయి',
    'legacySettings.saving': 'సేవ్ అవుతున్నది...',
    'legacySettings.saved': 'API కాన్ఫిగరేషన్ విజయవంతంగా సేవ్ అయింది',
    'legacySettings.apiKeyRequired': 'API కీ అవసరం',
    'legacySettings.failedSave': 'కాన్ఫిగరేషన్ సేవ్ చేయడంలో విఫలమైంది',
    'legacySettings.editorialTitle': 'సంపాదకీయ ప్రాధాన్యతలు',
    'legacySettings.editorialDesc': 'కంటెంట్ తయారీ కోసం డిఫాల్ట్ సంపాదకీయ నియమాలు మరియు నాణ్యత తనిఖీలు కాన్ఫిగర్ చేయండి',
  },
};

export const useLanguageStore = create((set, get) => ({
  lang: localStorage.getItem('kultworks_lang') || 'en',
  toggleLanguage: () => {
    const newLang = get().lang === 'en' ? 'te' : 'en';
    localStorage.setItem('kultworks_lang', newLang);
    set({ lang: newLang });
  },
}));

export const useT = () => {
  const lang = useLanguageStore((state) => state.lang);
  return (key, params) => {
    let text = translations[lang]?.[key] ?? translations['en']?.[key] ?? key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), v);
      });
    }
    return text;
  };
};
